var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackPlanTablet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 571,
    viewBox: "0 0 1080 571",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7001_56018)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 571,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1080V800H0V0Z",
    fill: "url(#paint0_linear_7001_56018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.774 691.81V674.036C120.774 581.526 193.614 505.56 285.694 501.404L293.584 493.337C193.84 493.337 112.888 574.185 112.888 674.033V691.807H120.777L120.774 691.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88195 691.81V674.036C6.88195 581.526 79.7228 505.56 171.803 501.404L179.692 493.337C79.9479 493.337 -1.00391 574.185 -1.00391 674.033V691.807H6.88531L6.88195 691.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.808 691.81V674.036C220.808 581.529 293.645 505.56 385.729 501.404L393.618 493.337C293.874 493.337 212.922 574.185 212.922 674.033V691.807H220.811L220.808 691.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.841 691.81V674.036C320.841 581.533 393.675 505.56 485.762 501.404L493.651 493.337C393.907 493.337 312.955 574.185 312.955 674.033V691.807H320.844L320.841 691.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.875 691.81V674.036C420.875 581.536 493.706 505.56 585.796 501.404L593.685 493.337C493.941 493.337 412.989 574.185 412.989 674.033V691.807H420.878L420.875 691.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.906 691.81V674.036C520.906 581.54 593.734 505.56 685.827 501.404L693.716 493.337C593.972 493.337 513.021 574.185 513.021 674.033V691.807H520.91L520.906 691.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.947 691.81V674.036C620.947 581.543 693.771 505.56 785.868 501.404L793.757 493.337C694.013 493.337 613.062 574.185 613.062 674.033V691.807H620.951L620.947 691.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.98 691.81V674.036C720.98 581.546 793.8 505.56 885.9 501.404L893.79 493.337C794.046 493.337 713.094 574.185 713.094 674.033V691.807H720.983L720.98 691.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.015 691.81V674.036C821.015 581.55 893.832 505.56 985.936 501.404L993.825 493.337C894.081 493.337 813.129 574.185 813.129 674.033V691.807H821.018L821.015 691.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.049 691.81V674.036C925.049 581.55 997.866 505.56 1089.97 501.404L1097.86 493.337C998.115 493.337 917.163 574.185 917.163 674.033V691.807H925.052L925.049 691.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.18 691.812V673.224C1028.18 615.026 1057.02 563.36 1101.34 532.015V522.466C1052.51 554.806 1020.29 610.235 1020.29 673.224V691.812H1028.18H1028.18Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101.06 515.396H-14.7051V525.725H1101.06V515.396Z",
    fill: "#BEAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4505 558.438V598.268C18.4505 599.356 17.5668 600.24 16.4782 600.24C15.3895 600.24 14.5059 599.356 14.5059 598.268V558.438H18.4505Z",
    fill: "#ECC0BC",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4671 558.438V599.689C55.4671 600.777 54.5834 601.661 53.4948 601.661C52.4061 601.661 51.5225 600.777 51.5225 599.689V558.438H55.4671Z",
    fill: "#ECC0BC",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.873 558.368V598.197C268.873 599.286 267.99 600.17 266.901 600.17C265.812 600.17 264.929 599.286 264.929 598.197V558.368H268.873Z",
    fill: "#CBB4B2",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.788 558.368V598.197C333.788 599.286 332.905 600.17 331.816 600.17C330.727 600.17 329.844 599.286 329.844 598.197V558.368H333.788Z",
    fill: "#CBB4B2",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.486 558.368V598.197C872.486 599.286 871.602 600.17 870.513 600.17C869.425 600.17 868.541 599.286 868.541 598.197V558.368H872.486Z",
    fill: "#CBB4B2",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.403 558.368V598.197C937.403 599.286 936.519 600.17 935.43 600.17C934.342 600.17 933.458 599.286 933.458 598.197V558.368H937.403Z",
    fill: "#CBB4B2",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M-26.9609 812V564.312L1088 563.937V812H-26.9609Z",
    fill: "url(#paint1_linear_7001_56018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082.78 562.328V436L-32.7964 436V562.328H1082.78Z",
    fill: "#C4E1B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082.79 570.813V552.827L-32.7925 552.827V570.813L1082.79 570.813Z",
    fill: "url(#paint2_linear_7001_56018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.069 476.842L223.25 477.585L324.85 538H711.71L742.069 476.842Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.777 456.514C175.276 455.834 173.648 455.482 172.001 455.482H-31.4829L-40.0352 464.589H136.98C137.977 464.589 138.956 464.846 139.824 465.336L167.25 480.831L238.689 538H324.85L223.25 477.585L176.777 456.514Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.689 538L167.25 480.831H-33.4689L-33.096 538H238.689Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.341 538L875.937 537.629L1091.05 538L1082.96 489.839L856.507 488.868C834.663 488.774 813.125 483.731 793.51 474.119L768.883 462.05C766.116 460.694 767.107 456.528 770.188 456.563L1088.74 460.133V447.508L728.745 446.117C720.565 446.086 716.892 456.356 723.237 461.519L742.069 476.842L711.71 538H801.341Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.098 550.804C862.098 550.804 864.612 548.276 864.683 545.644C864.755 543.011 861.322 545.644 861.322 545.644C861.322 545.644 861.893 544.513 861.108 544.221C860.323 543.932 858.603 545.801 858.603 545.801C858.603 545.801 858.557 540.85 855.359 540.393C852.166 539.937 851.259 542.64 851.259 542.64C851.259 542.64 850.638 540.641 849.446 540.603C848.254 540.57 848.443 542.079 848.443 542.079C848.443 542.079 846.916 539.622 843.198 540.113C839.48 540.603 838.859 544.43 838.859 544.43C838.859 544.43 837.679 543.195 836.572 543.457C835.464 543.719 836.177 546.378 836.177 546.378C836.177 546.378 834.175 542.955 832.816 542.929C831.456 542.903 832.388 545.85 832.388 545.85C832.388 545.85 830.923 542.191 826.416 541.506C821.909 540.82 823.521 545.423 823.521 545.423C823.521 545.423 821.695 544.033 820.625 544.427C819.555 544.82 821.59 547.561 821.59 547.561C821.59 547.561 818.98 546.164 817.335 546.745C815.69 547.325 819.169 550.8 819.169 550.8H862.094L862.098 550.804Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.289133
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.881 458.582C894.881 458.582 896.941 456.511 896.999 454.354C897.058 452.197 894.245 454.354 894.245 454.354C894.245 454.354 894.712 453.427 894.069 453.188C893.426 452.951 892.017 454.483 892.017 454.483C892.017 454.483 891.979 450.426 889.359 450.052C886.742 449.677 885.999 451.893 885.999 451.893C885.999 451.893 885.49 450.254 884.514 450.224C883.537 450.196 883.692 451.433 883.692 451.433C883.692 451.433 882.44 449.42 879.394 449.822C876.347 450.224 875.839 453.36 875.839 453.36C875.839 453.36 874.872 452.347 873.965 452.562C873.057 452.777 873.641 454.955 873.641 454.955C873.641 454.955 872.001 452.151 870.887 452.129C869.773 452.108 870.536 454.523 870.536 454.523C870.536 454.523 869.336 451.525 865.643 450.963C861.95 450.402 863.271 454.173 863.271 454.173C863.271 454.173 861.775 453.034 860.898 453.357C860.021 453.679 861.689 455.925 861.689 455.925C861.689 455.925 859.55 454.78 858.202 455.256C856.855 455.732 859.705 458.579 859.705 458.579H894.878L894.881 458.582Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.289133
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.447 483.121C116.447 483.121 118.23 481.328 118.28 479.461C118.331 477.594 115.897 479.461 115.897 479.461C115.897 479.461 116.301 478.659 115.745 478.452C115.188 478.247 113.968 479.572 113.968 479.572C113.968 479.572 113.935 476.061 111.667 475.737C109.403 475.413 108.76 477.331 108.76 477.331C108.76 477.331 108.319 475.913 107.474 475.886C106.629 475.862 106.763 476.932 106.763 476.932C106.763 476.932 105.679 475.19 103.042 475.538C100.406 475.886 99.9651 478.6 99.9651 478.6C99.9651 478.6 99.1288 477.724 98.3431 477.91C97.5573 478.096 98.0633 479.981 98.0633 479.981C98.0633 479.981 96.6437 477.554 95.6794 477.535C94.7151 477.517 95.3758 479.607 95.3758 479.607C95.3758 479.607 94.3371 477.012 91.1407 476.526C87.9443 476.04 89.0871 479.304 89.0871 479.304C89.0871 479.304 87.7925 478.319 87.0336 478.598C86.2747 478.877 87.7181 480.821 87.7181 480.821C87.7181 480.821 85.8669 479.83 84.7003 480.242C83.5336 480.653 86.0009 483.118 86.0009 483.118H116.444L116.447 483.121Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.205058
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.826 531.717C203.826 531.717 198.858 533.695 200.703 539.926H235.17C235.559 539.088 235.839 538.121 235.922 537.019C234.283 532.597 231.382 533.047 231.382 533.047C231.382 533.047 232.793 531.146 232.051 530.873C231.309 530.6 230.043 531.564 230.043 531.564C230.043 531.564 231.161 528.372 228.035 528.847C224.909 529.322 223.893 531.86 223.893 531.86C223.893 531.86 224.539 529.816 223.596 529.834C222.653 529.852 221.265 532.226 221.265 532.226C221.265 532.226 221.76 530.382 220.991 530.2C220.223 530.018 219.405 530.875 219.405 530.875C219.405 530.875 218.975 528.221 216.396 527.881C213.817 527.541 212.758 529.244 212.758 529.244C212.758 529.244 212.889 528.198 212.062 528.221C211.236 528.247 210.805 529.634 210.805 529.634C210.805 529.634 210.176 527.759 207.961 528.076C205.744 528.393 205.712 531.826 205.712 531.826C205.712 531.826 204.518 530.53 203.974 530.73C203.43 530.933 203.826 531.717 203.826 531.717Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.289133
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5104 331.698H29.4897V331.724H29.5104V331.698Z",
    fill: "url(#paint3_linear_7001_56018)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.353 253.377L893.348 197.198L895.013 253.537C895.387 253.537 895.693 253.842 895.693 254.214V260.966H896.372C896.746 260.966 897.052 261.271 897.052 261.643V264.366C897.544 264.815 897.876 265.44 897.939 266.148L898.078 267.905C898.296 270.478 898.291 273.066 898.053 275.639L897.949 276.744C897.835 277.984 896.891 278.966 895.693 279.162V285.274H896.372C896.746 285.274 897.052 285.579 897.052 285.951V286.627C897.052 286.999 896.746 287.304 896.372 287.304H895.693V290.678H896.372C896.746 290.678 897.052 290.983 897.052 291.355V292.703C897.052 293.075 896.746 293.38 896.372 293.38H895.693V298.779H896.372C896.746 298.779 897.052 299.083 897.052 299.455V300.804C897.052 301.176 896.746 301.481 896.372 301.481H895.693V302.157H896.372C896.746 302.157 897.052 302.462 897.052 302.834V304.183C897.052 304.555 896.746 304.859 896.372 304.859H895.693V306.208H897.046C897.42 306.208 897.726 306.513 897.726 306.885V311.612C897.726 311.984 897.42 312.289 897.046 312.289H896.367V326.465C896.74 326.465 897.046 326.77 897.046 327.142V328.49C897.046 328.862 896.74 329.167 896.367 329.167V330.515C896.74 330.515 897.046 330.82 897.046 331.192V332.54C897.046 332.912 896.74 333.217 896.367 333.217V348.742H897.721C898.094 348.742 898.4 349.047 898.4 349.419V356.466H903.524C904.266 356.466 904.878 357.07 904.878 357.814V358.863H918.751V354.632C918.751 354.229 918.43 353.903 918.025 353.903C917.62 353.903 917.294 353.578 917.294 353.175V350.607C917.294 350.018 916.811 349.538 916.215 349.538C915.473 349.538 914.949 348.789 915.214 348.091L921.64 331.208C921.837 330.681 922.335 330.334 922.905 330.334H1002.97C1003.45 330.334 1003.89 330.582 1004.14 330.996L1014.29 348.101C1014.66 348.737 1014.21 349.538 1013.46 349.538C1012.94 349.538 1012.51 349.961 1012.51 350.488V352.55C1012.51 353.294 1011.91 353.898 1011.16 353.898H1010.95C1010.21 353.898 1009.59 354.502 1009.59 355.246V358.853H1018.5V326.279C1018.5 325.943 1018.77 325.669 1019.11 325.669C1019.45 325.669 1019.73 325.395 1019.73 325.06V312.955C1019.73 312.211 1020.33 311.607 1021.08 311.607H1043.42V310.258C1043.42 309.514 1044.03 308.91 1044.78 308.91H1050.89C1051.49 308.91 1052.02 308.522 1052.19 307.954L1055.33 297.714C1055.5 297.146 1056.03 296.759 1056.63 296.759H1133.21C1133.96 296.759 1134.57 297.363 1134.57 298.107V358.858V430.185H-64.46V345.947V342.351C-64.46 341.607 -63.8532 341.003 -63.1063 341.003H-62.3751C-61.6282 341.003 -61.0214 340.398 -61.0214 339.654V333.124C-61.0214 332.38 -60.4147 331.776 -59.6678 331.776H-35.1108C-34.364 331.776 -33.7572 332.38 -33.7572 333.124V339.654C-33.7572 340.398 -33.1504 341.003 -32.4035 341.003H-29.7896C-29.0584 341.003 -28.4671 341.592 -28.4671 342.32C-28.4671 343.049 -27.8759 343.638 -27.1446 343.638H-19.7542C-19.2511 343.638 -18.7843 343.917 -18.5561 344.361L-13.5306 353.893C-13.4269 354.084 -13.375 354.301 -13.375 354.518V359.441H-7.55603V349.951C-7.55603 349.145 -6.38394 349.021 -6.2128 349.811L-5.90157 351.258L-4.06048 351.253L-3.86858 349.961C-3.75967 349.207 -2.67571 349.181 -2.53568 349.93L-2.28674 351.222V351.258L1.35923 351.253L1.55112 349.961C1.66003 349.207 2.74394 349.181 2.88397 349.93L3.1329 351.222V351.258L4.06646 351.253L4.25835 349.961C4.36726 349.207 5.45117 349.181 5.5912 349.93L5.835 351.222C5.84019 351.227 5.84019 351.243 5.84019 351.243V351.258L6.09951 351.253L6.2914 349.961C6.40031 349.207 7.48421 349.181 7.62424 349.93L7.87317 351.222V351.243V351.258H8.25696L8.56812 349.811C8.73927 349.016 9.91142 349.14 9.91142 349.951V359.441H24.4953V322.332H24.6041L24.739 321.138C24.8323 320.358 25.9629 320.332 26.0874 321.113L26.2689 322.332H26.8031L26.938 321.138C27.0365 320.358 28.1671 320.332 28.2812 321.113L28.4887 322.471H33.6646L33.815 321.138C33.9083 320.358 35.0389 320.332 35.1634 321.113L35.3657 322.471H35.8687L36.0192 321.138C36.1177 320.358 37.2483 320.332 37.3624 321.113L37.5699 322.471H37.8344V331.642H41.2781V311.369H41.4907V311.343V311.302L41.75 308.837C41.833 308.016 43.0362 308.031 43.0985 308.853L43.2904 311.317V311.369H46.4488V311.302L46.7081 308.837C46.7911 308.016 47.9943 308.031 48.0565 308.853L48.2484 311.317V311.369H48.9953V293.003H49.6072L49.7784 292.3C49.9547 291.592 50.9712 291.623 51.1061 292.336L51.2305 292.998H51.6662L54.2282 285.594L55.224 271.067H55.1877C54.0519 271.067 53.1287 270.147 53.1287 269.01C53.1287 267.874 54.0415 266.954 55.1877 266.954C56.3338 266.954 57.257 267.874 57.257 269.01C57.257 270.059 56.4635 270.927 55.447 271.051L56.5672 285.594L58.8648 292.998H59.176L59.679 291.484C59.8916 290.843 60.82 290.874 60.9808 291.535L61.3386 293.003H61.3853V293.225C61.3905 293.271 61.3905 293.318 61.3853 293.359V311.369H63.2472V311.343V311.302L63.5065 308.837C63.5895 308.016 64.7927 308.031 64.8549 308.853L65.0468 311.317V311.369L65.1765 311.364V311.333C65.1765 311.322 65.1816 311.302 65.1816 311.302L65.4306 308.837C65.5136 308.016 66.7168 308.031 66.7791 308.853L66.971 311.317C66.971 311.333 66.9762 311.369 66.9762 311.369H67.168V331.642H68.2675V322.471H68.532L68.7394 321.113C68.8639 320.338 69.9946 320.358 70.0827 321.138L70.2383 322.471H70.731L70.9384 321.113C71.0629 320.338 72.1935 320.358 72.2817 321.138L72.4373 322.471H77.608L77.8154 321.113C77.9399 320.338 79.0706 320.358 79.1587 321.138L79.2987 322.332H79.8277L80.0196 321.113C80.1441 320.338 81.2747 320.358 81.3629 321.138L81.5029 322.332H81.7467V359.441H90.5011L90.4181 349.031C90.4078 348.231 91.5591 348.086 91.751 348.866L92.3008 351.113H92.835L93.0321 349.285C93.1202 348.494 94.2664 348.473 94.3805 349.259L94.645 351.108H94.868L95.065 349.279C95.1532 348.489 96.2994 348.468 96.4135 349.254L96.678 351.103H96.901L97.0981 349.274C97.1863 348.484 98.3324 348.463 98.4465 349.248L98.711 351.098H99.6134L99.8105 349.269C99.8987 348.479 101.045 348.458 101.159 349.243L101.423 351.093H101.646L101.844 349.264C101.932 348.473 103.078 348.453 103.192 349.238L103.477 351.227H104.343L104.556 349.264C104.644 348.473 105.79 348.453 105.904 349.238L106.19 351.227H106.516L106.973 349.377C107.17 348.603 108.311 348.742 108.306 349.543L108.264 359.416H115.815V337.092C115.815 336.643 115.587 336.219 115.214 335.971L115.037 335.857C114.659 335.604 114.436 335.18 114.436 334.731V333.899C114.436 333.155 115.043 332.551 115.789 332.551H115.904C116.412 332.551 116.884 332.267 117.112 331.817L122.806 320.751C123.04 320.301 123.507 320.017 124.015 320.017H163.14C163.669 320.017 164.152 320.322 164.375 320.797L169.716 332.282C169.799 332.458 169.846 332.654 169.846 332.85V337.139C169.846 337.474 170.121 337.748 170.458 337.748C170.795 337.748 171.075 338.022 171.075 338.358V359.416H210.553L229.94 342.863C230.189 342.656 230.495 342.542 230.821 342.542H237.942C238.269 342.542 238.585 342.661 238.829 342.873L241.796 345.446L246.92 287.191H249.29L258.978 359.416H265.149V334.53C265.149 334.251 265.238 333.977 265.398 333.749L278.597 315.094C278.732 314.903 278.909 314.758 279.1 314.665V314.185H319.092C319.688 314.185 320.217 314.572 320.389 315.14L323.531 325.38C323.703 325.948 324.232 326.336 324.828 326.336H330.943C331.684 326.336 332.296 326.94 332.296 327.684V363.461H344.494V334.493C344.494 334.235 344.572 333.982 344.712 333.765L356.148 316.034C356.775 315.053 358.269 315.275 358.585 316.396L371.935 363.461H386.861V354.508C386.861 354.105 386.539 353.779 386.135 353.779C385.73 353.779 385.404 353.454 385.404 353.051V350.483C385.404 349.894 384.921 349.414 384.325 349.414C383.583 349.414 383.059 348.665 383.324 347.967L389.75 331.084C389.947 330.557 390.445 330.21 391.015 330.21H426.583C426.909 330.21 427.174 329.952 427.174 329.627C427.174 329.301 426.909 329.043 426.583 329.043H426.292C425.81 329.043 425.416 328.65 425.416 328.17V328.025C425.416 327.462 425.877 327.007 426.437 327.007H443.085C443.806 327.007 444.398 327.591 444.398 328.314V328.748C444.398 329.229 444.003 329.622 443.516 329.622H442.935C442.774 329.622 442.645 329.751 442.645 329.911C442.645 330.071 442.774 330.2 442.935 330.2H471.076C471.558 330.2 471.999 330.448 472.243 330.861L482.392 347.967C482.766 348.603 482.314 349.403 481.568 349.403C481.049 349.403 480.613 349.827 480.613 350.354V352.415C480.613 353.159 480.012 353.764 479.26 353.764H479.047C478.306 353.764 477.694 354.368 477.694 355.112V358.718H486.598V325.468C486.598 325.132 486.873 324.858 487.21 324.858C487.548 324.858 487.828 324.584 487.828 324.249V312.144C487.828 311.4 488.429 310.795 489.181 310.795H542.481C543.222 310.795 543.834 311.4 543.834 312.144V324.249C543.834 324.584 544.109 324.858 544.446 324.858C544.783 324.858 545.063 325.132 545.063 325.468V329.668H558.356L561.369 319.847C561.54 319.279 562.069 318.891 562.666 318.891H601.304C602.045 318.891 602.657 319.496 602.657 320.239V329.668H649.095L654.733 318.695C654.966 318.245 655.433 317.961 655.941 317.961H695.067C695.596 317.961 696.078 318.266 696.301 318.741L701.643 330.226C701.726 330.402 701.772 330.598 701.772 330.794V335.082C701.772 335.418 702.047 335.692 702.384 335.692C702.721 335.692 703.001 335.966 703.001 336.302V358.713H740.903L762.25 340.486H770.382L791.386 358.713H797.086V332.478C797.086 332.2 797.174 331.926 797.335 331.698L810.534 313.043C810.669 312.852 810.845 312.707 811.037 312.614V312.134H851.029C851.625 312.134 852.154 312.521 852.325 313.089L855.468 323.329C855.639 323.897 856.168 324.285 856.764 324.285H862.879C863.621 324.285 864.233 324.889 864.233 325.633V358.708H876.431V357.659C876.431 356.915 877.038 356.311 877.784 356.311H888.966V349.264C888.966 348.892 889.272 348.587 889.646 348.587H890.999V333.062C890.626 333.062 890.32 332.757 890.32 332.385V331.037C890.32 330.665 890.626 330.36 890.999 330.36V329.012C890.626 329.012 890.32 328.707 890.32 328.335V326.987C890.32 326.615 890.626 326.31 890.999 326.31V312.134H890.32C889.946 312.134 889.64 311.829 889.64 311.457V306.73C889.64 306.358 889.946 306.053 890.32 306.053H891.673V304.704H890.994C890.621 304.704 890.315 304.4 890.315 304.028V302.679C890.315 302.307 890.621 302.002 890.994 302.002H891.673V301.326H890.994C890.621 301.326 890.315 301.021 890.315 300.649V299.3C890.315 298.928 890.621 298.624 890.994 298.624H891.673V293.225H890.994C890.621 293.225 890.315 292.92 890.315 292.548V291.2C890.315 290.828 890.621 290.523 890.994 290.523H891.673V287.149H890.994C890.621 287.149 890.315 286.844 890.315 286.472V285.796C890.315 285.424 890.621 285.119 890.994 285.119H891.673V279.038C890.496 278.971 889.511 278.082 889.35 276.899C888.868 273.386 888.847 269.832 889.288 266.319L889.34 265.864C889.433 265.151 889.791 264.536 890.315 264.113V261.483C890.315 261.111 890.621 260.806 890.994 260.806H891.673V254.054C891.673 253.682 891.979 253.377 892.353 253.377ZM29.5104 331.698H29.4897V331.724H29.5104V331.698Z",
    fill: "url(#paint4_linear_7001_56018)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1371.35 412.31H-72.0518V431.679H1371.35V412.31Z",
    fill: "#CFCDC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-70.293 418.471L1363.32 418.358",
    stroke: "white",
    strokeWidth: 0.624494,
    strokeDasharray: "3.12 3.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.662 398.663L802.807 400.903C806.365 401.298 809.774 399.391 811.297 396.153L812.291 394.044C812.624 393.336 812.776 392.558 812.736 391.78L812.624 389.684C812.399 385.314 806.482 384.148 804.616 388.104L803.582 384.745C802.234 380.361 796.041 380.335 794.653 384.708C794.094 378.471 785.893 376.578 782.659 381.938L781.817 380.607C779.519 376.972 774.539 376.204 771.248 378.973C768.418 381.359 767.899 385.523 770.055 388.532L772.248 391.588C769.209 392.521 769.58 396.931 772.727 397.346L782.659 398.659L782.662 398.663Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.461 398.662L801.439 400.821C804.976 401.246 808.4 399.379 809.956 396.172L810.65 394.74C810.967 394.09 811.119 393.372 811.081 392.651L811.001 390.939C810.815 386.92 805.391 385.801 803.632 389.417L802.733 386.499C801.496 382.463 795.802 382.405 794.485 386.415C794.006 380.748 786.577 378.965 783.575 383.797L783.458 383.992L782.713 382.83C780.597 379.531 776.076 378.827 773.054 381.324C770.399 383.521 769.91 387.409 771.938 390.195L773.808 392.762C771.163 393.574 771.541 397.432 774.293 397.715L783.454 398.658L783.461 398.662Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.145 402.67L296.213 401.518C299.771 401.292 302.797 398.833 303.744 395.396L304.165 393.863C304.357 393.166 304.37 392.435 304.209 391.731L303.818 390.063C302.905 386.144 297.369 386.03 296.294 389.908L294.883 387.202C292.929 383.459 287.322 384.443 286.753 388.624C285.25 383.139 277.622 382.738 275.554 388.038L275.469 388.25L274.523 387.243C271.844 384.386 267.269 384.517 264.755 387.522C262.545 390.167 262.771 394.076 265.274 396.447L267.582 398.631C265.129 399.911 266.204 403.634 268.964 403.411L278.141 402.667L278.145 402.67Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.75 402.67L394.819 401.518C398.38 401.292 401.399 398.833 402.352 395.396L402.773 393.863C402.962 393.166 402.979 392.435 402.814 391.731L402.426 390.063C401.51 386.144 395.978 386.03 394.899 389.908L393.491 387.202C391.537 383.459 385.927 384.443 385.361 388.624C383.859 383.139 376.231 382.738 374.162 388.038L374.078 388.25L373.131 387.243C370.456 384.386 365.877 384.517 363.364 387.522C361.154 390.167 361.379 394.076 363.883 396.447L366.191 398.631C363.738 399.911 364.813 403.634 367.572 403.411L376.75 402.667V402.67Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.323 402.67L243.392 401.518C246.95 401.292 249.976 398.833 250.922 395.396L251.343 393.863C251.535 393.166 251.549 392.435 251.387 391.731L250.996 390.063C250.083 386.144 244.548 386.03 243.473 389.908L242.061 387.202C240.107 383.459 234.501 384.443 233.932 388.624C232.429 383.139 224.801 382.738 222.732 388.038L222.648 388.25L221.701 387.243C219.023 384.386 214.448 384.517 211.934 387.522C209.724 390.167 209.95 394.076 212.453 396.447L214.761 398.631C212.308 399.911 213.383 403.634 216.142 403.411L225.32 402.667L225.323 402.67Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.058 399.291L344.429 394.187C347.849 393.183 350.258 390.117 350.426 386.556L350.5 384.969C350.534 384.248 350.386 383.53 350.072 382.88L349.325 381.337C347.569 377.718 342.145 378.824 341.949 382.843L339.975 380.515C337.246 377.294 331.993 379.487 332.361 383.692C329.686 378.672 322.155 379.962 321.306 385.589L321.273 385.815L320.127 385.04C316.883 382.843 312.449 383.978 310.663 387.465C309.09 390.531 310.171 394.295 313.136 396.057L315.869 397.681C313.759 399.47 315.626 402.866 318.267 402.041L327.058 399.295V399.291Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.814 399.009L744 394.366C741.14 392.86 739.405 389.845 739.536 386.617L739.664 383.598C739.695 382.816 739.92 382.058 740.321 381.385L741.386 379.579C743.613 375.812 749.394 377.517 749.216 381.89L751.686 379.393C754.913 376.132 760.415 378.979 759.617 383.497C762.996 378.228 771.146 380.35 771.53 386.6L772.891 385.812C776.614 383.655 781.381 385.279 783.016 389.258C784.42 392.685 782.948 396.617 779.643 398.281L776.287 399.976H756.712C755.351 399.976 754.014 399.645 752.811 399.012L752.814 399.009Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.662 397.422L743.815 395.131C741.773 393.49 740.618 390.986 740.695 388.369L740.796 384.979C740.813 384.258 741.015 383.554 741.382 382.931L742.245 381.452C744.27 377.978 749.593 379.494 749.482 383.514L751.625 381.344C754.593 378.342 759.664 380.926 758.976 385.094C762.025 380.293 769.434 382.153 769.855 387.826L769.872 388.055L771.075 387.371C774.474 385.427 778.811 386.9 780.327 390.511C781.661 393.689 780.296 397.358 777.207 398.891L774.36 400.299H758.98L750.796 399.201C749.286 398.998 747.855 398.385 746.665 397.428L746.662 397.422Z",
    fill: "#6F9392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.558 395.488L447.745 390.845C444.884 389.339 443.149 386.324 443.28 383.096L443.408 380.078C443.439 379.296 443.664 378.538 444.065 377.864L445.13 376.058C447.357 372.291 453.139 373.996 452.96 378.369L455.43 375.873C458.657 372.611 464.159 375.458 463.361 379.976C466.74 374.707 474.89 376.83 475.274 383.079L476.635 382.291C480.358 380.135 485.126 381.759 486.76 385.738C488.165 389.164 486.692 393.096 483.387 394.76L480.031 396.455H460.456C459.095 396.455 457.758 396.125 456.555 395.492L456.558 395.488Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.406 393.902L447.559 391.611C445.517 389.97 444.362 387.467 444.439 384.849L444.54 381.46C444.557 380.739 444.759 380.035 445.127 379.411L445.989 377.932C448.014 374.459 453.337 375.975 453.226 379.994L455.369 377.824C458.337 374.822 463.408 377.407 462.72 381.574C465.769 376.773 473.178 378.633 473.599 384.307L473.616 384.536L476.227 382.787C478.737 381.109 482.026 381.167 484.472 382.932L485.361 383.572C487.602 385.189 488.41 388.154 487.302 390.688C486.753 391.955 485.766 392.982 484.529 393.595L478.101 396.779H462.72L454.537 395.681C453.027 395.479 451.595 394.866 450.406 393.909V393.902Z",
    fill: "#6F9392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.484 379.115H352.714V390.961H367.484V379.115Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.558 378.65H352.64V378.944H367.558V378.65Z",
    stroke: "#615E66",
    strokeWidth: 0.222366
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.984 376.749L352.889 378.531H367.312L366.217 376.749C366.096 376.553 365.884 376.436 365.654 376.436H354.546C354.317 376.436 354.105 376.553 353.984 376.749Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.484 386.913H352.714V390.959H367.484V386.913Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.201 388.086H354.082V389.595H355.201V388.086Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.734 388.086H356.615V389.595H357.734V388.086Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.196 388.086H362.077V389.595H363.196V388.086Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.925 388.086H364.807V389.595H365.925V388.086Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.733 383.015H365.002V385.889H365.733V383.015Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.733 379.892H365.002V381.206H365.733V379.892Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.003 383.015H362.468V385.889H363.003V383.015Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.003 379.892H362.468V381.206H363.003V379.892Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.271 383.015H359.735V385.889H360.271V383.015Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.271 379.892H359.735V381.206H360.271V379.892Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.543 383.015H357.007V385.889H357.543V383.015Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.543 379.892H357.007V381.206H357.543V379.892Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.005 383.015H354.47V385.889H355.005V383.015Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.005 379.892H354.47V381.206H355.005V379.892Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.658 388.086H359.539V390.96H360.658V388.086Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.852 373.792H497.736V390.961H540.852V373.792Z",
    fill: "#D8D0C3",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.852 385.838H497.736V390.959H540.852V385.838Z",
    fill: "#D8D0C3",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.543 377.269H499.825V379.378H500.543V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.234 374.964H496.359V375.658H542.234V374.964Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.544 382.134H499.826V384.243H500.544V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.776 386.997H498.667V390.959H500.776V386.997Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.338 386.997H503.07V390.959H506.338V386.997Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.436 386.997H508.168V390.959H511.436V386.997Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.534 386.997H513.266V390.959H516.534V386.997Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.895 387.705C517.895 386.93 518.525 386.304 519.299 386.304C520.074 386.304 520.698 386.93 520.698 387.705V390.96H517.895V387.705Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.337 386.997H522.069V390.959H525.337V386.997Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.435 386.997H527.167V390.959H530.435V386.997Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.762 386.997H532.494V390.959H535.762V386.997Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.7 386.997H537.823V390.959H539.7V386.997Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.482 377.269H503.765V379.378H504.482V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.482 382.134H503.765V384.243H504.482V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.032 377.269H506.314V379.378H507.032V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.032 382.134H506.314V384.243H507.032V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.58 377.269H508.862V379.378H509.58V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.58 382.134H508.862V384.243H509.58V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.894 377.269H511.177V379.378H511.894V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.894 382.134H511.177V384.243H511.894V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.678 377.269H513.96V379.378H514.678V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.678 382.134H513.96V384.243H514.678V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.991 377.269H516.273V379.378H516.991V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.991 382.134H516.273V384.243H516.991V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.774 377.269H519.057V379.378H519.774V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.774 382.134H519.057V384.243H519.774V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.555 377.269H521.837V379.378H522.555V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.555 382.134H521.837V384.243H522.555V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.101 377.269H524.384V379.378H525.101V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.101 382.134H524.384V384.243H525.101V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.416 377.269H526.698V379.378H527.416V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.417 382.134H526.699V384.243H527.417V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.2 377.269H529.482V379.378H530.2V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.2 382.134H529.482V384.243H530.2V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.75 377.269H532.032V379.378H532.75V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.75 382.134H532.032V384.243H532.75V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.064 377.269H534.347V379.378H535.064V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.064 382.134H534.347V384.243H535.064V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.77 377.269H538.053V379.378H538.77V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.77 382.134H538.053V384.243H538.77V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.554 373.792H497.047V374.975H541.554V373.792Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.684 373.792H388.568V390.961H431.684V373.792Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.755 386.997H388.616V390.959H431.755V386.997Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.372 377.269H390.654V379.378H391.372V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.066 374.964H387.191V375.658H433.066V374.964Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.755 382.155H388.616V385.676H431.755V382.155Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.699 386.997H388.616V390.959H391.699V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.755 386.997H388.616V390.959H431.755V386.997Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.167 386.997H393.898V390.959H397.167V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.144 386.997H399.623V390.959H403.144V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.362 386.997H404.094V390.959H407.362V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.727 387.705C408.727 386.93 409.357 386.304 410.132 386.304C410.906 386.304 411.53 386.93 411.53 387.705V390.96H408.727V387.705Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.167 386.997H412.898V390.959H416.167V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.264 386.997H417.996V390.959H421.264V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.59 386.997H423.322V390.959H426.59V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.758 386.997H428.675V390.959H431.758V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.638 376.873H388.616V380.835H432.638V376.873Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.638 376.873H388.616V377.314H432.638V376.873Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.638 382.155H388.616V382.597H432.638V382.155Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.638 386.997H388.616V387.438H432.638V386.997Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.598 382.134H428.881V384.243H429.598V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.385 373.792H387.878V375.413H432.385V373.792Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.638 373.792H388.616V374.233H432.638V373.792Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.19 373.792H878.074V390.961H921.19V373.792Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.259 386.997H878.12V390.959H921.259V386.997Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.877 377.269H880.159V379.378H880.877V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.57 374.964H876.695V375.658H922.57V374.964Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.259 382.155H878.12V385.676H921.259V382.155Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.203 386.997H878.12V390.959H881.203V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.259 386.997H878.12V390.959H921.259V386.997Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.671 386.997H883.403V390.959H886.671V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.645 386.997H889.124V390.959H892.645V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.868 386.997H893.6V390.959H896.868V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.229 387.705C898.229 386.93 898.859 386.304 899.633 386.304C900.408 386.304 901.032 386.93 901.032 387.705V390.96H898.229V387.705Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.67 386.997H902.402V390.959H905.67V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.768 386.997H907.5V390.959H910.768V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.094 386.997H912.826V390.959H916.094V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.264 386.997H918.181V390.959H921.264V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.142 376.873H878.12V380.835H922.142V376.873Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.142 376.873H878.12V377.314H922.142V376.873Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.142 382.155H878.12V382.597H922.142V382.155Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.142 386.997H878.12V387.438H922.142V386.997Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.103 382.134H918.386V384.243H919.103V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.891 373.792H877.384V375.413H921.891V373.792Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.142 373.792H878.12V374.233H922.142V373.792Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.38 364.987H1020.26V390.96H1063.38V364.987Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.45 384.799H1020.31V390.961H1063.45V384.799Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.06 370.202H1022.35V373.585H1023.06V370.202Z",
    fill: "#FFF9DE",
    stroke: "#FFF9DE",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.89 377.534H1019.87V383.036H1063.89V377.534Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.39 384.799H1020.31V390.961H1023.39V384.799Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.45 384.797H1020.31V390.959H1063.45V384.797Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.11 384.797H1025.59V390.959H1029.11V384.797Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.39 384.797H1030.87V390.959H1034.39V384.797Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.67 384.797H1036.15V390.959H1039.67V384.797Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.96 384.797H1041.43V390.959H1044.96V384.797Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.24 384.797H1046.72V390.959H1050.24V384.797Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.52 384.797H1052V390.959H1055.52V384.797Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.8 384.797H1057.28V390.959H1060.8V384.797Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.89 369.607H1019.86V375.77H1063.89V369.607Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.89 369.607H1019.86V370.487H1063.89V369.607Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.89 377.533H1019.86V378.413H1063.89V377.533Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.89 384.797H1019.86V385.676H1063.89V384.797Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.89 364.986H1019.86V367.847H1063.89V364.986Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.89 364.986H1019.86V365.866H1063.89V364.986Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.11 366.749H1019.65V368.07H1064.11V366.749Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.83 369.607H1020.31V373.57H1023.83V369.607Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.79 369.607H1024.27V373.57H1027.79V369.607Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.75 369.607H1028.23V373.57H1031.75V369.607Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.71 369.607H1032.19V373.57H1035.71V369.607Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.67 369.607H1036.15V373.57H1039.67V369.607Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.63 369.607H1040.11V373.57H1043.63V369.607Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.6 369.607H1044.08V373.57H1047.6V369.607Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.56 369.607H1048.04V373.57H1051.56V369.607Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.52 369.607H1052V373.57H1055.52V369.607Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.48 369.607H1055.96V373.57H1059.48V369.607Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.44 369.607H1059.92V373.57H1063.44V369.607Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.83 377.533H1020.31V381.054H1023.83V377.533Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.79 377.533H1024.27V381.054H1027.79V377.533Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.75 377.533H1028.23V381.054H1031.75V377.533Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.71 377.533H1032.19V381.054H1035.71V377.533Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.67 377.533H1036.15V381.054H1039.67V377.533Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.63 377.533H1040.11V381.054H1043.63V377.533Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.6 377.533H1044.08V381.054H1047.6V377.533Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.56 377.533H1048.04V381.054H1051.56V377.533Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.52 377.533H1052V381.054H1055.52V377.533Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.48 377.533H1055.96V381.054H1059.48V377.533Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.44 377.533H1059.92V381.054H1063.44V377.533Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.636 373.792H808.521V390.961H851.636V373.792Z",
    fill: "#E4D4B1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.636 385.838H808.521V390.959H851.636V385.838Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.324 377.269H810.606V379.378H811.324V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.017 374.964H807.143V375.658H853.017V374.964Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.324 382.134H810.606V384.243H811.324V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.559 386.997H809.45V390.959H811.559V386.997Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.119 386.997H813.851V390.959H817.119V386.997Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.216 386.997H818.948V390.959H822.216V386.997Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.313 386.997H824.045V390.959H827.313V386.997Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.678 387.705C828.678 386.93 829.308 386.304 830.083 386.304C830.858 386.304 831.481 386.93 831.481 387.705V390.96H828.678V387.705Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.116 386.997H832.848V390.959H836.116V386.997Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.215 386.997H837.947V390.959H841.215V386.997Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.542 386.997H843.273V390.959H846.542V386.997Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.484 386.997H848.607V390.959H850.484V386.997Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.264 377.269H814.547V379.378H815.264V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.264 382.134H814.547V384.243H815.264V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.812 377.269H817.095V379.378H817.812V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.813 382.134H817.096V384.243H817.813V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.363 377.269H819.646V379.378H820.363V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.363 382.134H819.646V384.243H820.363V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.678 377.269H821.96V379.378H822.678V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.678 382.134H821.96V384.243H822.678V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.461 377.269H824.743V379.378H825.461V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.461 382.134H824.743V384.243H825.461V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.775 377.269H827.058V379.378H827.775V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.775 382.134H827.058V384.243H827.775V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.557 377.269H829.84V379.378H830.557V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.557 382.134H829.84V384.243H830.557V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.335 377.269H832.617V379.378H833.335V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.335 382.134H832.617V384.243H833.335V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.885 377.269H835.167V379.378H835.885V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.886 382.134H835.168V384.243H835.886V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.199 377.269H837.481V379.378H838.199V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.199 382.134H837.481V384.243H838.199V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.981 377.269H840.264V379.378H840.981V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.981 382.134H840.264V384.243H840.981V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.529 377.269H842.812V379.378H843.529V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.53 382.134H842.812V384.243H843.53V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.845 377.269H845.127V379.378H845.845V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.845 382.134H845.127V384.243H845.845V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.555 377.269H848.837V379.378H849.555V377.269Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.555 382.134H848.837V384.243H849.555V382.134Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.336 373.792H807.829V374.975H852.336V373.792Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.887 364.811H205.582V390.959H213.887V364.811Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.712 366.22H214.053V390.96H217.712V366.22Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.701 364.811H207.77V390.959H211.701V364.811Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.185 364.811H217.88V390.959H226.185V364.811Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.998 364.811H220.066V390.959H223.998V364.811Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.995 364.811H222.25V390.959H223.995V364.811Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.697 364.811H209.952V390.959H211.697V364.811Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.121 360.436H208.982V364.701H209.121V360.436Z",
    stroke: "#615E66",
    strokeWidth: 0.104444
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.761 363.251H210.623V364.7H210.761V363.251Z",
    stroke: "#615E66",
    strokeWidth: 0.104444
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.526 366.22H866.867V390.96H870.526V366.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.559 359.703H870.196V390.959H878.559V359.703Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.359 359.703H872.396V390.959H876.359V359.703Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.362 359.703H874.6V390.959H876.362V359.703Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.924 353.104H697.638V390.96H713.924V353.104Z",
    fill: "#D8D1C3",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.369 352.221H697.199V352.662H714.369V352.221Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.816 353.104H697.748V354.866H713.816V353.104Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.816 374.674H697.748V376.436H713.816V374.674Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.111 353.104H699.399V372.032H706.111V353.104Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.124 387.439H699.399V390.96H705.124V387.439Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.124 387.439H702.041V390.96H705.124V387.439Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.947 387.439H706.223V390.96H711.947V387.439Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.166 387.439H709.083V390.96H712.166V387.439Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.711 377.754H699.399V379.075H701.711V377.754Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.012 377.754H702.701V379.075H705.012V377.754Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.166 377.754H706.553V380.395H712.166V377.754Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.864 377.754H706.553V379.075H708.864V377.754Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.165 377.754H709.854V379.075H712.165V377.754Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.111 355.745H699.399V360.149H706.111V355.745Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.111 361.907H699.399V366.311H706.111V361.907Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.111 367.628H699.399V372.031H706.111V367.628Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.002 355.745H704.682V360.149H706.002V355.745Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.002 361.907H704.682V366.311H706.002V361.907Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.002 367.628H704.682V372.031H706.002V367.628Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.816 372.912H697.748V373.353H713.816V372.912Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.165 355.745H709.305V360.149H712.165V355.745Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.165 361.907H709.305V366.311H712.165V361.907Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.165 367.628H709.305V372.031H712.165V367.628Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.165 355.745H711.286V360.149H712.165V355.745Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.165 361.907H711.286V366.311H712.165V361.907Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.165 367.628H711.286V372.031H712.165V367.628Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.911 355.745H701.051V360.149H703.911V355.745Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.911 361.907H701.051V366.311H703.911V361.907Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.911 367.628H701.051V372.031H703.911V367.628Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.249 391.179H451.55C453.665 391.179 455.71 390.374 457.26 388.925L458.749 387.537C459.15 387.16 459.444 386.684 459.598 386.156L459.723 385.741C460.576 382.844 457.062 380.671 454.855 382.729V381.162C454.855 377.975 450.849 376.553 448.841 379.026C449.801 375.165 445.367 372.248 442.203 374.657L441.324 375.324L441.078 374.555C440.229 371.907 437.355 370.492 434.734 371.439C432.136 372.379 430.826 375.283 431.843 377.854L432.305 379.026C428.427 379.026 426.26 383.497 428.656 386.543L430.482 388.861C431.631 390.323 433.393 391.179 435.253 391.179H435.249Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.626 391.178H450.659C452.674 391.178 454.622 390.447 456.141 389.123L457.33 388.085C457.704 387.759 457.981 387.334 458.132 386.859C458.954 384.258 455.848 382.189 453.786 383.982V382.88C453.786 379.989 450.198 378.648 448.301 380.828C449.194 377.483 445.41 374.858 442.587 376.863L441.448 377.675L441.236 377.062C440.444 374.754 437.937 373.521 435.626 374.302C433.183 375.128 431.961 377.853 432.965 380.225L433.221 380.832C429.771 380.832 427.894 384.865 430.121 387.503L431.671 389.342C432.651 390.508 434.1 391.182 435.63 391.182L435.626 391.178Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.062 390.112C400.062 388.232 400.449 386.375 401.197 384.654L401.949 382.929C403.404 379.58 408.161 379.58 409.617 382.929L410.368 384.654C411.116 386.375 411.504 388.232 411.504 390.112C411.504 390.58 411.126 390.961 410.655 390.961H400.908C400.436 390.961 400.059 390.58 400.059 390.112H400.062Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.604 389.896C401.604 388.363 401.925 386.847 402.548 385.445L402.905 384.643C404.27 381.571 408.629 381.571 409.994 384.643L410.351 385.445C410.971 386.847 411.294 388.363 411.294 389.896C411.294 390.361 410.917 390.742 410.449 390.742H402.454C401.985 390.742 401.608 390.364 401.608 389.896H401.604Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.785 387.657V391.178",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.646 386.779L405.785 389.421",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.586 388.1L405.786 390.522",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.046 391.178H419.774C420.907 391.178 421.991 390.75 422.82 389.979L423.413 389.423C423.612 389.241 423.753 389.012 423.828 388.756L423.885 388.567C424.299 387.169 422.605 386.114 421.533 387.108V386.36C421.533 384.82 419.596 384.13 418.622 385.326C419.087 383.466 416.954 382.054 415.421 383.213L414.987 383.544L414.872 383.176C414.458 381.899 413.073 381.215 411.81 381.67C410.55 382.125 409.916 383.53 410.412 384.773L410.631 385.326C408.761 385.326 407.713 387.485 408.875 388.954L409.751 390.066C410.307 390.767 411.149 391.178 412.046 391.178Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.59 390.96L411.948 386.779",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.71 389.197L415.25 385.896",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.332 391.179L420.532 388.318",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.111 387.657L419.651 389.197",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.789 390.959L412.386 383.695",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.521 391.18H872.821C874.937 391.18 876.982 390.375 878.532 388.926L880.021 387.538C880.422 387.161 880.715 386.685 880.87 386.157L880.995 385.742C881.847 382.845 878.333 380.671 876.126 382.73V381.163C876.126 377.976 872.12 376.554 870.112 379.027C871.072 375.166 866.639 372.249 863.475 374.658L862.596 375.325L862.35 374.556C861.501 371.908 858.627 370.493 856.005 371.44C853.408 372.38 852.097 375.284 853.115 377.855L853.576 379.027C849.698 379.027 847.532 383.498 849.927 386.544L851.754 388.862C852.902 390.324 854.664 391.18 856.524 391.18H856.521Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.899 391.178H871.932C873.947 391.178 875.894 390.447 877.414 389.123L878.603 388.085C878.977 387.759 879.253 387.334 879.405 386.859C880.227 384.258 877.12 382.189 875.058 383.982V382.88C875.058 379.989 871.47 378.648 869.573 380.828C870.466 377.483 866.683 374.858 863.859 376.863L862.721 377.675L862.508 377.062C861.717 374.754 859.21 373.521 856.899 374.302C854.456 375.128 853.233 377.853 854.237 380.225L854.493 380.832C851.043 380.832 849.166 384.865 851.393 387.503L852.943 389.342C853.924 390.508 855.372 391.182 856.902 391.182L856.899 391.178Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.355 390.741L871.08 382.598",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.996 387.216L875.92 386.337",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.336 380.617L869.536 384.798",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.117 388.319L864.917 385.236",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1371.35 404.827H-72.0518V409.231H1371.35V404.827Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.127 379.957H256.116V390.961H278.127V379.957Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.127 386.558H256.116V390.961H278.127V386.558Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.952 388.38H259.193V390.961H260.952V388.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.522 388.38H262.764V390.961H264.522V388.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.643 388.38H266.885V390.961H268.643V388.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.215 388.38H270.456V390.961H272.215V388.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.061 388.38H274.303V390.961H276.061V388.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.952 381.234H259.193V385.19H260.952V381.234Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.522 381.234H262.764V385.19H264.522V381.234Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.643 381.234H266.885V385.19H268.643V381.234Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.215 381.234H270.456V385.19H272.215V381.234Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.061 381.234H274.303V385.19H276.061V381.234Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.212 374.343L256.771 379.952H277.484L267.212 374.343Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.674 380.617L254.572 379.865L267.348 373.134L279.71 379.865L278.783 380.839L267.119 374.455L255.674 380.617Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.177 379.957H712.166V390.961H734.177V379.957Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.177 386.558H712.166V390.961H734.177V386.558Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.001 388.38H715.242V390.961H717.001V388.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.571 388.38H718.812V390.961H720.571V388.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.691 388.38H722.933V390.961H724.691V388.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.26 388.38H726.501V390.961H728.26V388.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.107 388.38H730.349V390.961H732.107V388.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.001 381.234H715.242V385.19H717.001V381.234Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.571 381.234H718.812V385.19H720.571V381.234Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.691 381.234H722.933V385.19H724.691V381.234Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.26 381.234H726.501V385.19H728.26V381.234Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.106 381.234H730.348V385.19H732.106V381.234Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.263 374.343L712.822 379.952H733.533L723.263 374.343Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.725 380.617L710.623 379.865L723.399 373.134L735.764 379.865L734.834 380.839L723.17 374.455L711.725 380.617Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.17 379.957H1047.16V390.961H1069.17V379.957Z",
    fill: "#F8E7C3",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.17 386.558H1047.16V390.961H1069.17V386.558Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.99 388.38H1050.24V390.961H1051.99V388.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.57 388.38H1053.81V390.961H1055.57V388.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.68 388.38H1057.92V390.961H1059.68V388.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.25 388.38H1061.49V390.961H1063.25V388.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.1 388.38H1065.34V390.961H1067.1V388.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.99 381.234H1050.24V385.19H1051.99V381.234Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.57 381.234H1053.81V385.19H1055.57V381.234Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.68 381.234H1057.92V385.19H1059.68V381.234Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.25 381.234H1061.49V385.19H1063.25V381.234Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.1 381.234H1065.34V385.19H1067.1V381.234Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.25 374.343L1047.81 379.952H1068.52L1058.25 374.343Z",
    fill: "#F8E7C3",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.72 380.617L1045.62 379.865L1058.39 373.134L1070.76 379.865L1069.83 380.839L1058.16 374.455L1046.72 380.617Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.98 382.374C327.955 382.374 346.579 363.749 346.579 340.775C346.579 317.801 327.955 299.176 304.98 299.176C282.006 299.176 263.381 317.801 263.381 340.775C263.381 363.749 282.006 382.374 304.98 382.374ZM304.98 378.853C326.011 378.853 343.059 361.805 343.059 340.775C343.059 319.745 326.011 302.697 304.98 302.697C283.95 302.697 266.902 319.745 266.902 340.775C266.902 361.805 283.95 378.853 304.98 378.853Z",
    fill: "#CDD9F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.979 363.007C317.256 363.007 327.209 353.152 327.209 340.996C327.209 328.84 317.256 318.985 304.979 318.985C292.702 318.985 282.749 328.84 282.749 340.996C282.749 353.152 292.702 363.007 304.979 363.007ZM304.979 359.928C315.555 359.928 324.129 351.454 324.129 341C324.129 330.545 315.555 322.072 304.979 322.072C294.403 322.072 285.828 330.545 285.828 341C285.828 351.454 294.403 359.928 304.979 359.928Z",
    fill: "#CDD9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.98 382.374C327.955 382.374 346.579 363.75 346.579 340.775C346.579 317.8 327.955 299.176 304.98 299.176C282.005 299.176 263.381 317.8 263.381 340.775C263.381 363.75 282.005 382.374 304.98 382.374Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.418 378.854V382.374",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.715 378.194L297.055 381.496",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.98 378.855C326.01 378.855 343.058 361.807 343.058 340.777C343.058 319.747 326.01 302.698 304.98 302.698C283.95 302.698 266.901 319.747 266.901 340.777C266.901 361.807 283.95 378.855 304.98 378.855Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.98 374.453C323.578 374.453 338.655 359.474 338.655 340.997C338.655 322.52 323.578 307.541 304.98 307.541C286.381 307.541 271.305 322.52 271.305 340.997C271.305 359.474 286.381 374.453 304.98 374.453Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.979 370.051C320.903 370.051 333.812 357.044 333.812 340.999C333.812 324.953 320.903 311.946 304.979 311.946C289.055 311.946 276.146 324.953 276.146 340.999C276.146 357.044 289.055 370.051 304.979 370.051Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.979 366.531C318.958 366.531 330.291 355.1 330.291 340.999C330.291 326.899 318.958 315.468 304.979 315.468C290.999 315.468 279.666 326.899 279.666 340.999C279.666 355.1 290.999 366.531 304.979 366.531Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.979 363.01C317.256 363.01 327.209 353.155 327.209 340.999C327.209 328.843 317.256 318.988 304.979 318.988C292.702 318.988 282.749 328.843 282.749 340.999C282.749 353.155 292.702 363.01 304.979 363.01Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.981 359.927C315.557 359.927 324.131 351.453 324.131 340.999C324.131 330.546 315.557 322.071 304.981 322.071C294.404 322.071 285.83 330.546 285.83 340.999C285.83 351.453 294.404 359.927 304.981 359.927Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.979 352.885C311.665 352.885 317.085 347.563 317.085 340.999C317.085 334.434 311.665 329.112 304.979 329.112C298.294 329.112 292.874 334.434 292.874 340.999C292.874 347.563 298.294 352.885 304.979 352.885Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.73 385.235H328.53C328.001 384.356 328.311 383.254 328.53 382.812H330.73C331.259 383.87 330.949 384.868 330.73 385.235Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.606 387.878H318.406C317.877 386.998 318.187 385.896 318.406 385.455H320.606C321.135 386.513 320.825 387.51 320.606 387.878Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.361 389.639H309.161C308.632 388.76 308.942 387.658 309.161 387.217H311.361C311.89 388.275 311.58 389.272 311.361 389.639Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.678 389.639H299.478C298.949 388.76 299.259 387.658 299.478 387.217H301.678C302.207 388.275 301.897 389.272 301.678 389.639Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.875 388.319H290.674C290.146 387.44 290.455 386.338 290.674 385.896H292.875C293.404 386.954 293.094 387.952 292.875 388.319Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.655 379.514H336.455C335.926 378.635 336.236 377.533 336.455 377.092H338.655C339.184 378.15 338.874 379.147 338.655 379.514Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.696 371.59H343.496C342.967 370.711 343.277 369.609 343.496 369.168H345.696C346.225 370.226 345.915 371.223 345.696 371.59Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.541 362.787H348.34C347.812 361.907 348.121 360.806 348.34 360.364H350.541C351.07 361.422 350.76 362.419 350.541 362.787Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.062 353.103H351.862C351.333 352.224 351.643 351.122 351.862 350.681H354.062C354.591 351.739 354.281 352.736 354.062 353.103Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.941 342.979H352.741C352.212 342.1 352.522 340.998 352.741 340.557H354.941C355.47 341.615 355.16 342.612 354.941 342.979Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.621 332.852H351.421C350.892 331.973 351.202 330.871 351.421 330.43H353.621C354.15 331.488 353.84 332.485 353.621 332.852Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.1 323.169H347.9C347.371 322.289 347.681 321.187 347.9 320.746H350.1C350.629 321.804 350.319 322.801 350.1 323.169Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.258 313.923H343.058C342.529 313.044 342.839 311.942 343.058 311.501H345.258C345.787 312.559 345.477 313.556 345.258 313.923Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.213 306.883H336.013C335.484 306.004 335.794 304.902 336.013 304.461H338.213C338.742 305.519 338.432 306.516 338.213 306.883Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.851 300.72H327.651C327.122 299.841 327.432 298.739 327.651 298.298H329.851C330.38 299.356 330.07 300.353 329.851 300.72Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.606 297.195H318.406C317.877 296.316 318.187 295.214 318.406 294.772H320.606C321.135 295.83 320.825 296.828 320.606 297.195Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.482 294.997H308.282C307.753 294.117 308.063 293.016 308.282 292.574H310.482C311.011 293.632 310.701 294.629 310.482 294.997Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.358 295.437H298.158C297.629 294.558 297.939 293.456 298.158 293.015H300.358C300.887 294.073 300.577 295.07 300.358 295.437Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.233 297.637H288.033C287.504 296.758 287.814 295.656 288.033 295.215H290.233C290.762 296.273 290.452 297.27 290.233 297.637Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.429 301.598H279.229C278.7 300.719 279.01 299.617 279.229 299.176H281.429C281.958 300.234 281.648 301.231 281.429 301.598Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.064 307.761H270.864C270.335 306.882 270.645 305.78 270.864 305.339H273.064C273.593 306.397 273.283 307.394 273.064 307.761Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.46 315.245H264.26C263.731 314.365 264.041 313.264 264.26 312.822H266.46C266.989 313.88 266.679 314.877 266.46 315.245Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.18 324.489H258.98C258.451 323.609 258.761 322.508 258.98 322.066H261.18C261.709 323.124 261.399 324.122 261.18 324.489Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.539 333.735H256.339C255.81 332.856 256.12 331.754 256.339 331.312H258.539C259.068 332.37 258.758 333.368 258.539 333.735Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.656 343.86H255.456C254.927 342.981 255.237 341.879 255.456 341.438H257.656C258.185 342.495 257.875 343.493 257.656 343.86Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.539 353.983H256.339C255.81 353.104 256.12 352.002 256.339 351.561H258.539C259.068 352.618 258.758 353.616 258.539 353.983Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.619 363.665H259.419C258.89 362.785 259.2 361.684 259.419 361.242H261.619C262.148 362.3 261.838 363.297 261.619 363.665Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.902 372.469H264.702C264.173 371.59 264.483 370.488 264.702 370.047H266.902C267.431 371.105 267.121 372.102 266.902 372.469Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.947 379.957H271.747C271.218 379.077 271.528 377.976 271.747 377.534H273.947C274.476 378.592 274.166 379.589 273.947 379.957Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.308 385.678H280.108C279.579 384.799 279.889 383.697 280.108 383.256H282.308C282.837 384.314 282.527 385.311 282.308 385.678Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.682 314.146L304.538 340.78",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.505 306.882L304.538 340.776",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.43 301.38L304.539 340.557",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.232 297.638L304.76 340.558",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.696 295.437L304.76 340.557",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.16 294.994L304.979 339.895",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.624 297.195L304.979 340.557",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.65 300.719L304.979 340.778",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.793 305.998L304.979 340.775",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.835 312.825L304.979 340.779",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.678 321.188L305.418 340.776",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.421 330.434L305.199 340.777",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.62 340.557L304.757 340.998",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.741 350.681L305.421 340.998",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.438 360.146L304.979 340.995",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.598 369.17L304.761 340.778",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.775 377.092L305.202 340.995",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.628 382.817L304.757 340.776",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.727 385.236L304.761 340.776",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.399 322.288L304.761 340.997",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.758 331.753L304.538 340.998",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.879 341.658L304.98 340.778",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.539 351.561L304.761 340.995",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.738 361.246L305.42 340.778",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.8 370.05L304.539 340.998",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.845 377.533L305.199 340.557",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.207 383.254L304.977 340.553",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.112 385.896L304.98 340.335",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.575 387.216L304.979 340.557",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.481 386.997L304.757 340.557",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.089 310.401L280.108 307.541",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.146 315.684L273.505 313.703",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.743 322.289L268.883 320.527",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.44 329.554L265.139 328.675",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.901 337.696L263.818 337.255",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.12 345.618L263.818 346.06",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.883 353.323L265.8 354.644",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.403 360.364L269.543 362.126",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.026 366.749L274.604 369.171",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.188 372.031L281.207 374.892",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.131 306L287.592 303.14",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.614 303.58L295.734 300.278",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.538 299.176V302.697",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.342 300.06L312.682 303.361",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.708 302.701L320.168 305.784",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.191 307.102L327.21 309.743",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.572 312.604L332.931 315.026",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.855 319.867L337.994 321.407",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.376 327.573L341.293 328.675",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.357 336.154L342.836 336.596",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.356 344.957L343.055 344.516",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.817 353.104L341.516 352.225",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.076 361.024L338.216 359.262",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.012 368.069L333.59 366.088",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.628 374.013L327.646 371.371",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.926 378.412L320.605 375.552",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.003 377.975L314.882 381.057",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.648 299.617L290.671 301.598",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.509 304.459L288.252 297.417",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.452 295.437L299.037 299.618",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.874 300.94L297.938 294.777",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.799 293.894L307.402 299.176",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.459 299.397L308.063 293.896",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.203 300.721L310.92 294.336",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.263 299.398L318.187 294.994",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.825 296.759L324.568 304.023",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.625 301.38L327.21 299.398",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.629 300.719L331.61 308.862",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.55 304.902L336.014 304.461",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.591 310.622L343.055 311.501",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.553 314.806V306.882",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.314 317.226L348.779 320.527",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.395 322.508L343.496 313.923",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.277 324.271L352.522 330.433",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.478 330.874L348.56 323.172",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.696 332.413L353.398 340.556",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.422 332.633L346.58 339.455",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.579 341.878L352.741 350.463",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.919 348.258L352.523 342.314",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.696 350.24L349.439 360.146",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.496 356.405L351.639 351.341",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.836 358.384L344.598 368.95",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.534 364.107L348.119 361.246",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.213 365.869L337.994 376.873",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.495 369.389L333.59 370.928",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.27 372.249L330.07 382.815",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.99 375.994L336.454 377.096",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.53 382.817L318.187 380.617",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.229 376.873L320.825 385.677",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.874 380.617L282.309 383.259",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.73 377.313L290.674 385.676",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.524 365.648L261.841 361.905",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.561 359.043L265.58 369.828",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.121 358.165L258.978 352.663",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.701 351.124L260.958 361.248",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.381 340.557L258.539 333.734",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.04 333.734L256.776 341.436",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.26 331.753L261.177 324.271",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.022 325.593L258.758 331.317",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.121 323.387L265.8 315.244",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.422 317.668L261.177 322.071",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.524 315.905V307.762",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.704 311.063L266.24 312.603",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.749 305.562H273.285",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.686 309.302L279.225 301.6",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.26 349.36L257.875 343.198",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.381 342.538L257.438 351.561",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.185 366.749V377.315",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.807 371.372L266.901 370.052",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.848 376.655L273.942 377.535",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.347 372.692L281.207 383.258",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.867 391.179L304.096 340.335L304.976 343.195L285.606 391.176H281.863L281.867 391.179Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.768 392.062L305.64 339.459L304.761 342.319L323.689 392.062H326.772H326.768Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.757 344.96C306.945 344.96 308.719 343.187 308.719 340.998C308.719 338.81 306.945 337.036 304.757 337.036C302.569 337.036 300.795 338.81 300.795 340.998C300.795 343.187 302.569 344.96 304.757 344.96Z",
    fill: "#705895",
    stroke: "#705895",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.753 380.835L299.477 386.997",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.916 382.155L293.094 386.117",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.78 382.375L308.943 387.217",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.942 382.375L301.678 387.439",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.142 381.938L318.183 385.681",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.644 380.835L311.58 387.22",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.155 358.825H848.627V361.908H863.155V358.825Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.627 358.825H741.218V361.467H848.627V358.825Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.301 361.466H741.218V362.787H744.301V361.466Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.752 341.66H849.069V349.584H858.752V341.66Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.865 343.741V349.58H849.065V341.905L846.865 343.738V343.741Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.272 352.221H727.131V354.862H862.272V352.221Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.599 358.824L725.09 356.183H865.15L863.26 358.824H726.599Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.221 358.825H726.693V390.96H741.221V358.825Z",
    fill: "#FFF8E7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.221 358.825H726.693V361.908H741.221V358.825Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.136 379.516H729.773V390.961H738.136V379.516Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.46 376.873H728.895V377.752H739.46V376.873Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.702 379.516L728.998 377.754H739.291L738.233 379.516H729.702Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.935 381.277H732.414V390.96H735.935V381.277Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.817 371.149H731.534V372.911H736.817V371.149Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.055 382.155H733.293V386.559H735.055V382.155Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.155 358.825H848.627V390.96H863.155V358.825Z",
    fill: "#FFF8E7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.627 361.466H741.218V364.987H848.627V361.466Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.501 364.987H741.218V390.96H746.501V364.987Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.029 364.987H755.746V390.96H761.029V364.987Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.875 364.987H771.592V390.96H776.875V364.987Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.843 364.987H786.561V390.96H791.843V364.987Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.609 364.987H799.326V390.96H804.609V364.987Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.014 364.987H813.852V390.96H820.014V364.987Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.42 364.987H827.938V390.96H835.42V364.987Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.627 364.987H841.145V390.96H848.627V364.987Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.859 362.786H741.218V390.959H743.859V362.786Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.631 361.466H845.548V362.787H848.631V361.466Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.627 362.786H845.985V390.959H848.627V362.786Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.824 361.466H755.304V362.787H758.824V361.466Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.387 362.786H755.746V390.959H758.387V362.786Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.674 361.466H771.153V362.787H774.674V361.466Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.233 362.786H771.592V390.959H774.233V362.786Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.64 361.466H786.119V362.787H789.64V361.466Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.202 362.786H786.561V390.959H789.202V362.786Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.047 361.466H801.526V362.787H805.047V361.466Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.609 362.786H801.968V390.959H804.609V362.786Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.454 361.466H816.934V362.787H820.454V361.466Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.016 362.786H817.375V390.959H820.016V362.786Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.862 361.466H832.341V362.787H835.862V361.466Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.424 362.786H832.782V390.959H835.424V362.786Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.024 350.901L726.033 349.58H864.257L863.267 350.901H727.024Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.024 352.221L726.033 350.9H864.257L863.267 352.221H727.024Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.861 356.182L723.84 354.861H866.447L865.426 356.182H724.861Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.177 370.274C735.879 370.274 737.259 368.894 737.259 367.191C737.259 365.489 735.879 364.108 734.177 364.108C732.474 364.108 731.094 365.489 731.094 367.191C731.094 368.894 732.474 370.274 734.177 370.274Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.177 369.389C735.392 369.389 736.377 368.404 736.377 367.189C736.377 365.974 735.392 364.989 734.177 364.989C732.962 364.989 731.977 365.974 731.977 367.189C731.977 368.404 732.962 369.389 734.177 369.389Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.961 342.537L793.383 344.299L796.685 349.582C795.88 349.582 794 349.538 792.942 349.363C790.83 348.13 791.035 345.182 791.402 343.861L790.961 342.54V342.537Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.203 343.414L791.626 344.954L794.927 349.576C794.122 349.576 792.242 349.539 791.184 349.384C789.072 348.306 789.277 345.725 789.645 344.57L789.203 343.414Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.44 343.857L789.863 345.289L793.165 349.582C792.359 349.582 790.479 349.545 789.422 349.403C787.309 348.402 787.515 346.004 787.882 344.932L787.44 343.857Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.24 344.737L787.663 345.947L790.964 349.579C790.159 349.579 788.279 349.548 787.221 349.427C785.109 348.578 785.314 346.553 785.682 345.644L785.24 344.737Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.92 346.5L786.342 347.272L789.644 349.583C788.839 349.583 786.959 349.563 785.901 349.485C783.789 348.946 783.994 347.656 784.361 347.076L783.92 346.5Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.086 342.537L798.663 344.299L795.361 349.582C796.167 349.582 798.047 349.538 799.105 349.363C801.217 348.13 801.011 345.182 800.644 343.861L801.086 342.54V342.537Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.848 343.414L800.426 344.954L797.124 349.576C797.929 349.576 799.809 349.539 800.867 349.384C802.98 348.306 802.774 345.725 802.407 344.57L802.848 343.414Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.609 343.857L802.186 345.289L798.885 349.582C799.69 349.582 801.57 349.545 802.628 349.403C804.74 348.402 804.535 346.004 804.168 344.932L804.609 343.857Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.81 344.737L804.388 345.947L801.086 349.579C801.891 349.579 803.771 349.548 804.829 349.427C806.942 348.578 806.736 346.553 806.369 345.644L806.81 344.737Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.13 346.5L805.708 347.272L802.406 349.583C803.211 349.583 805.091 349.563 806.149 349.485C808.262 348.946 808.056 347.656 807.689 347.076L808.13 346.5Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.024 348.699C797.604 348.699 798.885 347.419 798.885 345.839C798.885 344.259 797.604 342.979 796.024 342.979C794.445 342.979 793.164 344.259 793.164 345.839C793.164 347.419 794.445 348.699 796.024 348.699Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.025 347.82C797.119 347.82 798.006 346.933 798.006 345.838C798.006 344.744 797.119 343.857 796.025 343.857C794.931 343.857 794.044 344.744 794.044 345.838C794.044 346.933 794.931 347.82 796.025 347.82Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.955 365.284L729.712 364.449C729.631 364.169 729.844 363.886 730.14 363.886H731.232C731.289 363.886 731.343 363.876 731.39 363.856L733.994 362.855C734.109 362.811 734.237 362.818 734.348 362.872L737.081 364.236C737.192 364.294 737.323 364.297 737.441 364.25L737.903 364.064C738.145 363.967 738.418 364.102 738.489 364.351L738.758 365.277C738.785 365.372 738.782 365.473 738.742 365.56L738.445 366.305C738.388 366.44 738.405 366.591 738.486 366.713L738.678 367.002C738.752 367.117 738.769 367.258 738.731 367.386L738.425 368.3C738.384 368.428 738.401 368.569 738.479 368.684L738.661 368.953C738.748 369.085 738.758 369.253 738.688 369.394L738.459 369.849C738.398 369.974 738.398 370.119 738.459 370.244L738.715 370.749C738.772 370.86 738.775 370.991 738.728 371.109L738.452 371.81C738.395 371.945 738.411 372.097 738.492 372.218L738.64 372.44C738.738 372.588 738.738 372.781 738.64 372.929L738.502 373.131C738.415 373.262 738.405 373.431 738.475 373.572L738.704 374.027C738.765 374.152 738.765 374.297 738.704 374.421L738.445 374.937C738.391 375.041 738.401 375.166 738.469 375.26C738.61 375.476 738.455 375.766 738.196 375.766H730.238C730.09 375.766 729.951 375.691 729.867 375.57L729.699 375.318C729.611 375.186 729.601 375.018 729.672 374.876L729.901 374.421C729.962 374.297 729.962 374.152 729.901 374.027L729.672 373.572C729.601 373.431 729.611 373.262 729.699 373.131L729.837 372.929C729.934 372.781 729.934 372.588 729.837 372.44L729.689 372.218C729.608 372.097 729.591 371.945 729.648 371.81L729.924 371.109C729.972 370.991 729.968 370.86 729.911 370.749L729.655 370.244C729.594 370.119 729.594 369.974 729.655 369.849L729.901 369.361C729.962 369.236 729.962 369.091 729.901 368.967L729.645 368.461C729.588 368.35 729.584 368.219 729.631 368.101L729.908 367.4C729.965 367.265 729.948 367.114 729.867 366.992L729.682 366.716C729.601 366.595 729.584 366.443 729.641 366.308L729.938 365.564C729.978 365.473 729.982 365.372 729.955 365.281V365.284Z",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.072 379.516H851.71V390.961H860.072V379.516Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.394 376.873H850.828V377.752H861.394V376.873Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.64 379.516L850.936 377.754H861.228L860.17 379.516H851.64Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.872 381.277H854.352V390.96H857.872V381.277Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.753 371.149H853.47V372.911H858.753V371.149Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.994 382.155H855.231V386.559H856.994V382.155Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.111 370.274C857.814 370.274 859.194 368.894 859.194 367.191C859.194 365.489 857.814 364.108 856.111 364.108C854.409 364.108 853.028 365.489 853.028 367.191C853.028 368.894 854.409 370.274 856.111 370.274Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.11 369.389C857.325 369.389 858.31 368.404 858.31 367.189C858.31 365.974 857.325 364.989 856.11 364.989C854.895 364.989 853.91 365.974 853.91 367.189C853.91 368.404 854.895 369.389 856.11 369.389Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.889 365.284L851.647 364.449C851.566 364.169 851.778 363.886 852.075 363.886H853.166C853.224 363.886 853.277 363.876 853.325 363.856L855.932 362.855C856.047 362.811 856.175 362.818 856.283 362.872L859.015 364.236C859.126 364.294 859.258 364.297 859.376 364.25L859.837 364.064C860.08 363.967 860.353 364.102 860.423 364.351L860.693 365.277C860.72 365.372 860.717 365.473 860.676 365.56L860.38 366.305C860.322 366.44 860.339 366.591 860.42 366.713L860.612 367.002C860.686 367.117 860.703 367.258 860.666 367.386L860.359 368.3C860.319 368.428 860.336 368.569 860.413 368.684L860.595 368.953C860.683 369.085 860.693 369.253 860.622 369.394L860.393 369.849C860.332 369.974 860.332 370.119 860.393 370.244L860.649 370.749C860.706 370.86 860.71 370.991 860.663 371.109L860.386 371.81C860.329 371.945 860.346 372.097 860.427 372.218L860.575 372.44C860.673 372.588 860.673 372.781 860.575 372.929L860.44 373.131C860.353 373.262 860.343 373.431 860.413 373.572L860.642 374.027C860.703 374.152 860.703 374.297 860.642 374.421L860.383 374.937C860.329 375.041 860.339 375.166 860.407 375.26C860.548 375.476 860.393 375.766 860.134 375.766H852.176C852.027 375.766 851.889 375.691 851.805 375.57L851.637 375.318C851.549 375.186 851.539 375.018 851.61 374.876L851.839 374.421C851.899 374.297 851.899 374.152 851.839 374.027L851.61 373.572C851.539 373.431 851.549 373.262 851.637 373.131L851.771 372.929C851.869 372.781 851.869 372.588 851.771 372.44L851.623 372.218C851.542 372.097 851.525 371.945 851.583 371.81L851.859 371.109C851.906 370.991 851.903 370.86 851.846 370.749L851.589 370.244C851.529 370.119 851.529 369.974 851.589 369.849L851.835 369.361C851.896 369.236 851.896 369.091 851.835 368.967L851.579 368.461C851.522 368.35 851.519 368.219 851.566 368.101L851.842 367.4C851.899 367.265 851.883 367.114 851.802 366.992L851.616 366.716C851.536 366.595 851.519 366.443 851.576 366.308L851.872 365.564C851.913 365.473 851.916 365.372 851.889 365.281V365.284Z",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.777 341.66H731.094V349.584H740.777V341.66Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.98 343.741V349.58H740.78V341.905L742.98 343.738V343.741Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.082 344.845L729.924 349.225C729.964 349.434 730.15 349.582 730.359 349.582H777.756C777.999 349.582 778.197 349.384 778.197 349.141V347.975C778.197 347.874 778.164 347.776 778.1 347.699L777.396 346.82C777.342 346.752 777.311 346.671 777.305 346.587L777.103 344.576C777.099 344.535 777.089 344.498 777.076 344.461L776.499 342.965C776.368 342.615 775.853 342.672 775.799 343.046C775.741 343.437 775.196 343.474 775.084 343.093L775.068 343.023C774.956 342.649 774.424 342.659 774.333 343.036L774.205 343.545C774.107 343.936 773.545 343.922 773.464 343.528L773.403 343.211C773.336 342.891 772.884 342.881 772.803 343.198L772.776 343.309C772.702 343.599 772.288 343.589 772.231 343.295C772.173 343.019 771.786 342.989 771.688 343.255L771.486 343.821C771.382 344.104 770.974 344.087 770.897 343.797C770.806 343.471 770.334 343.504 770.29 343.838L770.28 343.892C770.236 344.246 769.734 344.269 769.65 343.922L769.438 343.016C769.357 342.692 768.905 342.669 768.801 342.989L768.72 343.221C768.622 343.511 768.201 343.461 768.174 343.157C768.147 342.857 767.733 342.8 767.632 343.083L767.517 343.39C767.406 343.7 766.968 343.7 766.857 343.39L766.685 342.915C766.57 342.601 766.122 342.625 766.038 342.948L765.991 343.14C765.917 343.45 765.469 343.434 765.415 343.117C765.361 342.81 764.93 342.78 764.839 343.08L764.647 343.717C764.559 343.996 764.158 343.979 764.098 343.696L764.071 343.572C764.017 343.332 763.686 343.309 763.599 343.538C763.508 343.781 763.151 343.733 763.124 343.477V343.437C763.093 343.167 762.72 343.12 762.625 343.376L762.541 343.605C762.43 343.909 761.992 343.865 761.941 343.545L761.901 343.295C761.857 342.996 761.436 342.982 761.365 343.275L761.355 343.312C761.288 343.602 760.87 343.582 760.833 343.289L760.809 343.12C760.769 342.844 760.368 342.837 760.331 343.117C760.287 343.38 759.916 343.396 759.856 343.14L759.795 342.894C759.721 342.595 759.29 342.601 759.222 342.905L759.168 343.147C759.088 343.518 758.562 343.518 758.481 343.147L758.468 343.09C758.387 342.719 757.868 342.702 757.763 343.066L757.683 343.339C757.565 343.754 756.978 343.757 756.85 343.343C756.722 342.921 756.123 342.932 756.008 343.356L755.974 343.491C755.856 343.932 755.226 343.925 755.122 343.477L754.991 342.911C754.906 342.568 754.414 342.574 754.347 342.921L754.32 343.036C754.253 343.373 753.771 343.363 753.717 343.023C753.67 342.709 753.239 342.665 753.127 342.958L752.966 343.38C752.831 343.74 752.302 343.676 752.248 343.295C752.194 342.891 751.621 342.854 751.517 343.248L751.456 343.491C751.352 343.875 750.813 343.898 750.681 343.525L750.621 343.363C750.503 343.039 750.041 343.06 749.95 343.39C749.853 343.744 749.347 343.733 749.263 343.376L749.162 342.928C749.081 342.591 748.626 342.547 748.485 342.864L748.36 343.137C748.259 343.366 747.919 343.332 747.868 343.087C747.808 342.81 747.41 342.817 747.356 343.093L747.265 343.548C747.204 343.855 746.76 343.841 746.719 343.531C746.679 343.221 746.234 343.208 746.173 343.514L746.14 343.683C746.072 344.01 745.607 344.01 745.54 343.683L745.506 343.514C745.439 343.174 744.95 343.181 744.89 343.521C744.829 343.875 744.314 343.848 744.27 343.491C744.229 343.151 743.748 343.103 743.657 343.437C743.576 343.723 743.182 343.75 743.067 343.477L743.054 343.447C742.939 343.188 742.568 343.184 742.454 343.444L742.205 344.013C742.063 344.33 741.628 344.367 741.433 344.077L740.857 343.211C740.725 343.012 740.426 343.029 740.314 343.245C740.183 343.514 739.782 343.457 739.728 343.161L739.718 343.103C739.651 342.756 739.162 342.733 739.068 343.076L739.051 343.151C738.963 343.467 738.532 343.501 738.394 343.204L738.04 342.426C737.922 342.17 737.548 342.2 737.471 342.47L737.36 342.871C737.292 343.113 736.939 343.083 736.915 342.83C736.891 342.581 736.544 342.547 736.47 342.787L736.41 343.002C736.329 343.258 735.968 343.258 735.891 343.002L735.833 342.81C735.736 342.49 735.278 342.5 735.2 342.824L735.16 342.975C735.086 343.285 734.641 343.268 734.584 342.955C734.53 342.659 734.122 342.625 734.014 342.908L733.913 343.188C733.788 343.531 733.293 343.511 733.195 343.157L733.135 342.935C733.051 342.618 732.606 342.608 732.501 342.918C732.404 343.221 731.972 343.221 731.875 342.918L731.858 342.871C731.753 342.554 731.302 342.554 731.197 342.871L731.043 343.336C730.968 343.562 730.669 343.615 730.524 343.43C730.342 343.208 729.988 343.332 729.988 343.619V344.468C729.988 344.71 729.685 344.818 729.53 344.633C729.358 344.427 729.028 344.586 729.075 344.849L729.082 344.845Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.205 344.845L860.362 349.225C860.322 349.434 860.137 349.582 859.928 349.582H812.53C812.288 349.582 812.089 349.384 812.089 349.141V347.975C812.089 347.874 812.123 347.776 812.187 347.699L812.891 346.82C812.945 346.752 812.975 346.671 812.982 346.587L813.184 344.576C813.187 344.535 813.197 344.498 813.211 344.461L813.787 342.965C813.918 342.615 814.434 342.672 814.488 343.046C814.545 343.437 815.091 343.474 815.202 343.093L815.219 343.023C815.33 342.649 815.862 342.659 815.953 343.036L816.081 343.545C816.179 343.936 816.742 343.922 816.823 343.528L816.883 343.211C816.951 342.891 817.402 342.881 817.483 343.198L817.51 343.309C817.584 343.599 817.998 343.589 818.056 343.295C818.113 343.019 818.5 342.989 818.598 343.255L818.8 343.821C818.905 344.104 819.312 344.087 819.39 343.797C819.481 343.471 819.953 343.504 819.996 343.838L820.006 343.892C820.05 344.246 820.552 344.269 820.636 343.922L820.849 343.016C820.93 342.692 821.381 342.669 821.485 342.989L821.566 343.221C821.664 343.511 822.085 343.461 822.112 343.157C822.139 342.857 822.553 342.8 822.655 343.083L822.769 343.39C822.88 343.7 823.318 343.7 823.429 343.39L823.601 342.915C823.716 342.601 824.164 342.625 824.248 342.948L824.295 343.14C824.37 343.45 824.818 343.434 824.872 343.117C824.925 342.81 825.357 342.78 825.448 343.08L825.64 343.717C825.727 343.996 826.128 343.979 826.189 343.696L826.216 343.572C826.27 343.332 826.6 343.309 826.687 343.538C826.778 343.781 827.136 343.733 827.163 343.477V343.437C827.193 343.167 827.567 343.12 827.661 343.376L827.745 343.605C827.857 343.909 828.295 343.865 828.345 343.545L828.386 343.295C828.429 342.996 828.851 342.982 828.921 343.275L828.931 343.312C828.999 343.602 829.417 343.582 829.454 343.289L829.477 343.12C829.518 342.844 829.919 342.837 829.956 343.117C829.999 343.38 830.37 343.396 830.431 343.14L830.491 342.894C830.565 342.595 830.997 342.601 831.064 342.905L831.118 343.147C831.199 343.518 831.724 343.518 831.805 343.147L831.819 343.09C831.9 342.719 832.418 342.702 832.523 343.066L832.604 343.339C832.722 343.754 833.308 343.757 833.436 343.343C833.564 342.921 834.164 342.932 834.278 343.356L834.312 343.491C834.43 343.932 835.06 343.925 835.164 343.477L835.296 342.911C835.38 342.568 835.872 342.574 835.939 342.921L835.966 343.036C836.034 343.373 836.515 343.363 836.569 343.023C836.616 342.709 837.048 342.665 837.159 342.958L837.321 343.38C837.459 343.74 837.984 343.676 838.038 343.295C838.092 342.891 838.665 342.854 838.769 343.248L838.83 343.491C838.934 343.875 839.474 343.898 839.605 343.525L839.666 343.363C839.783 343.039 840.245 343.06 840.336 343.39C840.434 343.744 840.939 343.733 841.023 343.376L841.124 342.928C841.205 342.591 841.66 342.547 841.802 342.864L841.926 343.137C842.027 343.366 842.368 343.332 842.418 343.087C842.479 342.81 842.876 342.817 842.93 343.093L843.021 343.548C843.082 343.855 843.527 343.841 843.567 343.531C843.607 343.221 844.052 343.208 844.113 343.514L844.147 343.683C844.214 344.01 844.679 344.01 844.746 343.683L844.78 343.514C844.847 343.174 845.336 343.181 845.397 343.521C845.457 343.875 845.973 343.848 846.016 343.491C846.057 343.151 846.539 343.103 846.63 343.437C846.711 343.723 847.105 343.75 847.219 343.477L847.233 343.447C847.347 343.188 847.718 343.184 847.832 343.444L848.082 344.013C848.223 344.33 848.658 344.367 848.853 344.077L849.429 343.211C849.561 343.012 849.861 343.029 849.972 343.245C850.103 343.514 850.504 343.457 850.558 343.161L850.568 343.103C850.636 342.756 851.124 342.733 851.218 343.076L851.235 343.151C851.323 343.467 851.754 343.501 851.892 343.204L852.246 342.426C852.364 342.17 852.738 342.2 852.815 342.47L852.927 342.871C852.994 343.113 853.348 343.083 853.371 342.83C853.395 342.581 853.742 342.547 853.816 342.787L853.877 343.002C853.958 343.258 854.318 343.258 854.396 343.002L854.453 342.81C854.551 342.49 855.009 342.5 855.086 342.824L855.127 342.975C855.201 343.285 855.646 343.268 855.703 342.955C855.757 342.659 856.164 342.625 856.272 342.908L856.373 343.188C856.498 343.531 856.993 343.511 857.091 343.157L857.152 342.935C857.236 342.618 857.681 342.608 857.785 342.918C857.883 343.221 858.314 343.221 858.412 342.918L858.429 342.871C858.533 342.554 858.984 342.554 859.089 342.871L859.244 343.336C859.318 343.562 859.618 343.615 859.763 343.43C859.945 343.208 860.298 343.332 860.298 343.619V344.468C860.298 344.71 860.602 344.818 860.757 344.633C860.928 344.427 861.259 344.586 861.211 344.849L861.205 344.845Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.311 349.361L812.391 345.644C812.405 345.018 812.914 344.519 813.54 344.519C814.157 344.519 814.666 345.008 814.689 345.624L814.831 349.361L814.955 345.574C814.979 344.987 815.461 344.519 816.047 344.519C816.633 344.519 817.115 344.984 817.139 345.57L817.28 349.361L817.425 345.604C817.449 344.997 817.944 344.519 818.55 344.519C819.157 344.519 819.655 344.997 819.676 345.604L819.817 349.361L819.992 345.472C820.019 344.937 820.461 344.516 820.996 344.516C821.545 344.516 821.997 344.964 821.997 345.516V349.357",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.994 349.361L822.075 345.644C822.088 345.018 822.597 344.519 823.224 344.519C823.84 344.519 824.349 345.008 824.373 345.624L824.514 349.361L824.639 345.574C824.663 344.987 825.144 344.519 825.731 344.519C826.317 344.519 826.799 344.984 826.822 345.57L826.964 349.361L827.109 345.604C827.132 344.997 827.627 344.519 828.234 344.519C828.84 344.519 829.339 344.997 829.359 345.604L829.501 349.361L829.676 345.472C829.703 344.937 830.144 344.516 830.68 344.516C831.229 344.516 831.681 344.964 831.681 345.516V349.357",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.68 349.361L831.761 345.644C831.774 345.018 832.286 344.519 832.909 344.519C833.526 344.519 834.035 345.008 834.058 345.624L834.2 349.361L834.325 345.574C834.348 344.987 834.83 344.519 835.416 344.519C836.002 344.519 836.484 344.984 836.508 345.57L836.649 349.361L836.794 345.604C836.818 344.997 837.313 344.519 837.919 344.519C838.526 344.519 839.025 344.997 839.045 345.604L839.186 349.361L839.361 345.472C839.388 344.937 839.83 344.516 840.365 344.516C840.915 344.516 841.366 344.964 841.366 345.516V349.357",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.363 349.361L841.444 345.644C841.458 345.018 841.97 344.519 842.593 344.519C843.21 344.519 843.718 345.008 843.742 345.624L843.883 349.361L844.008 345.574C844.032 344.987 844.513 344.519 845.1 344.519C845.686 344.519 846.168 344.984 846.191 345.57L846.333 349.361L846.478 345.604C846.501 344.997 846.997 344.519 847.603 344.519C848.209 344.519 848.708 344.997 848.728 345.604L848.87 349.361L849.045 345.472C849.072 344.937 849.513 344.516 850.049 344.516C850.598 344.516 851.05 344.964 851.05 345.516V349.357",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.05 349.361L851.131 345.644C851.144 345.018 851.656 344.519 852.28 344.519C852.896 344.519 853.405 345.008 853.428 345.624L853.57 349.361L853.695 345.574C853.718 344.987 854.2 344.519 854.786 344.519C855.372 344.519 855.854 344.984 855.878 345.57L856.019 349.361L856.164 345.604C856.188 344.997 856.683 344.519 857.29 344.519C857.896 344.519 858.395 344.997 858.415 345.604L858.556 349.361L858.732 345.472C858.758 344.937 859.2 344.516 859.736 344.516C860.285 344.516 860.736 344.964 860.736 345.516V349.357",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.112 349.361L729.193 345.644C729.207 345.018 729.715 344.519 730.342 344.519C730.959 344.519 731.467 345.008 731.491 345.624L731.632 349.361L731.757 345.574C731.781 344.987 732.263 344.519 732.849 344.519C733.435 344.519 733.917 344.984 733.94 345.57L734.082 349.361L734.227 345.604C734.25 344.997 734.746 344.519 735.352 344.519C735.958 344.519 736.457 344.997 736.477 345.604L736.619 349.361L736.794 345.472C736.821 344.937 737.262 344.516 737.798 344.516C738.347 344.516 738.799 344.964 738.799 345.516V349.357",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.799 349.361L738.88 345.644C738.893 345.018 739.402 344.519 740.029 344.519C740.645 344.519 741.154 345.008 741.177 345.624L741.319 349.361L741.444 345.574C741.467 344.987 741.949 344.519 742.535 344.519C743.122 344.519 743.603 344.984 743.627 345.57L743.768 349.361L743.913 345.604C743.937 344.997 744.432 344.519 745.039 344.519C745.645 344.519 746.144 344.997 746.164 345.604L746.305 349.361L746.481 345.472C746.508 344.937 746.949 344.516 747.485 344.516C748.034 344.516 748.485 344.964 748.485 345.516V349.357",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.481 349.361L748.562 345.644C748.576 345.018 749.084 344.519 749.711 344.519C750.328 344.519 750.837 345.008 750.86 345.624L751.002 349.361L751.126 345.574C751.15 344.987 751.632 344.519 752.218 344.519C752.804 344.519 753.286 344.984 753.31 345.57L753.451 349.361L753.596 345.604C753.619 344.997 754.115 344.519 754.721 344.519C755.328 344.519 755.826 344.997 755.846 345.604L755.988 349.361L756.163 345.472C756.19 344.937 756.631 344.516 757.167 344.516C757.716 344.516 758.168 344.964 758.168 345.516V349.357",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.165 349.361L758.246 345.644C758.259 345.018 758.768 344.519 759.395 344.519C760.011 344.519 760.52 345.008 760.544 345.624L760.685 349.361L760.81 345.574C760.833 344.987 761.315 344.519 761.901 344.519C762.488 344.519 762.97 344.984 762.993 345.57L763.135 349.361L763.279 345.604C763.303 344.997 763.798 344.519 764.405 344.519C765.011 344.519 765.51 344.997 765.53 345.604L765.672 349.361L765.847 345.472C765.874 344.937 766.315 344.516 766.851 344.516C767.4 344.516 767.851 344.964 767.851 345.516V349.357",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.851 349.361L767.931 345.644C767.945 345.018 768.454 344.519 769.08 344.519C769.697 344.519 770.206 345.008 770.229 345.624L770.371 349.361L770.495 345.574C770.519 344.987 771.001 344.519 771.587 344.519C772.173 344.519 772.655 344.984 772.679 345.57L772.82 349.361L772.965 345.604C772.989 344.997 773.484 344.519 774.09 344.519C774.697 344.519 775.195 344.997 775.216 345.604L775.357 349.361L775.532 345.472C775.559 344.937 776.001 344.516 776.536 344.516C777.086 344.516 777.537 344.964 777.537 345.516V349.357",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.136 350.9H729.773V353.542H738.136V350.9Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.184 352.221H757.505C758.232 352.221 758.825 352.81 758.825 353.541C758.825 354.269 758.236 354.862 757.505 354.862H756.184C755.456 354.862 754.863 354.273 754.863 353.541C754.863 352.814 755.453 352.221 756.184 352.221Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.069 346.069C850.548 346.181 851.711 347.417 851.711 348.923V349.583H849.069V346.069Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.272 346.069C860.793 346.181 859.631 347.417 859.631 348.923V349.583H862.272V346.069Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.016 347.379C820.016 346.652 819.427 346.059 818.696 346.059C817.965 346.059 817.375 346.648 817.375 347.379V349.579H820.016V347.379Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.421 347.379C835.421 346.652 834.831 346.059 834.1 346.059C833.369 346.059 832.779 346.648 832.779 347.379V349.579H835.421V347.379Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.032 352.221H773.352C774.08 352.221 774.673 352.81 774.673 353.541C774.673 354.269 774.084 354.862 773.352 354.862H772.032C771.304 354.862 770.711 354.273 770.711 353.541C770.711 352.814 771.301 352.221 772.032 352.221Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.254 352.221H819.575C820.303 352.221 820.896 352.81 820.896 353.541C820.896 354.269 820.306 354.862 819.575 354.862H818.254C817.527 354.862 816.934 354.273 816.934 353.541C816.934 352.814 817.523 352.221 818.254 352.221Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.662 352.221H834.982C835.71 352.221 836.303 352.81 836.303 353.541C836.303 354.269 835.71 354.862 834.982 354.862H833.662C832.934 354.862 832.341 354.273 832.341 353.541C832.341 352.814 832.934 352.221 833.662 352.221Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.572 346.069C729.051 346.181 730.214 347.417 730.214 348.923V349.583H727.572V346.069Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.78 346.069C739.301 346.181 738.139 347.417 738.139 348.923V349.583H740.78V346.069Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.945 347.379C757.945 346.652 757.356 346.059 756.624 346.059C755.893 346.059 755.304 346.648 755.304 347.379V349.579H757.945V347.379Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.795 347.379C773.795 346.652 773.205 346.059 772.474 346.059C771.743 346.059 771.153 346.648 771.153 347.379V349.579H773.795V347.379Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.072 350.9H851.71V353.542H860.072V350.9Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.595 350.901L362.865 377.093V379.293L385.536 374.889L476.659 356.399L481.942 358.161L460.814 371.368L450.248 380.613C455.972 377.753 468.428 371.635 472.478 370.048C477.542 368.067 498.01 358.161 500.87 356.841C506.372 354.3 504.613 350.897 500.87 350.237C491.009 348.124 477.245 349.796 471.595 350.897V350.901Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.555 391.179H376.733L378.283 385.623C378.832 383.659 377.353 381.715 375.314 381.715H362.865V379.293L474.041 357.056C477.687 356.328 481.383 355.88 485.099 355.722C486.406 355.668 486.942 357.376 485.837 358.077L450.157 380.765C448.267 381.964 447.448 384.303 448.173 386.419L449.8 391.176H444.298V384.788C444.298 383.848 443.341 383.208 442.472 383.568L437.917 385.455V381.712L462.788 364.323C463.708 363.821 463.102 362.295 462.087 362.561C443.904 367.312 415.37 373.43 406.442 375.55C398.312 377.48 390.371 379.579 385.722 381.068C383.886 381.655 382.797 383.457 382.983 385.374L383.552 391.176L383.555 391.179Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.732 376.432V382.156",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.234 375.552V381.054",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.76 372.692V377.756",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.857 374.45V380.393",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.48 373.57V379.072",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.952 382.155L387.296 380.174",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.623 391.18V385.152C445.623 383.815 446.226 382.551 447.277 381.722C449.588 379.9 452.624 377.545 455.481 375.372C457.28 373.926 459.46 372.299 462.084 370.483C462.445 370.23 462.762 370.011 463.041 369.826C467.977 366.467 474.375 362.501 482.599 357.939C472.478 363.553 466.36 367.619 463.045 369.823H463.041C462.714 370.048 462.398 370.264 462.084 370.48C460.457 371.625 458.038 373.424 455.481 375.368C450.572 379.303 448.5 381.864 448.042 383.03V391.173H445.619L445.623 391.18Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.945 384.504L379.594 390.96H383.556C383.411 390.373 383.468 388.493 383.115 385.677C382.761 382.86 384.29 381.715 385.315 381.496L402.922 376.432L384.567 380.785C382.741 381.219 381.326 382.668 380.945 384.504Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.921 383.254L474.237 362.125L482.822 357.944",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.595 350.901L362.865 377.093V375.772L471.595 347.818C477.98 346.571 492.771 344.826 500.87 347.818C504.04 348.876 505.638 349.873 506.153 350.24C506.153 352.002 506.372 353.984 505.274 354.863C504.394 355.567 468.223 372.325 450.248 380.614C455.972 377.753 468.428 371.635 472.478 370.048C477.542 368.067 498.01 358.161 500.87 356.841C506.372 354.3 504.613 350.897 500.87 350.237C491.009 348.125 477.245 349.796 471.595 350.897V350.901Z",
    fill: "#FBDC99",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.865 373.571V375.771L393.899 367.847C418.473 361.024 470.847 347.157 483.701 346.278C496.554 345.398 504.024 348.552 506.15 350.24V345.897C506.15 344.852 505.853 343.805 505.041 343.154C502.946 341.487 498.899 339.853 495.146 339.674C483.526 338.616 470.349 341.581 465.211 343.195L362.865 373.568V373.571Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.865 376.873V379.295",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.132 362.567L482.6 357.944",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.901 349.36L482.818 355.745",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.995 350.24L480.618 355.964",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.147 349.36L484.581 355.745",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.279 349.58V355.965",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.648 391.18V366.09H993.013L1003.14 360.147L1013.7 364.328L1026.25 356.845L1028.67 391.18H892.652H892.648Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.29 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.932 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.569 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.211 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.853 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.494 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.136 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.776 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.418 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.061 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.701 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.343 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.983 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.625 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.267 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.907 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.547 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.188 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.829 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.471 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.111 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.753 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.395 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.036 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.678 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.319 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.96 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.602 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.243 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.885 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.526 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.165 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.806 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.447 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.088 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.73 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.372 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.014 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.654 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.296 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.94 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.58 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.22 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.86 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.5 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.14 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.78 369.608V391.178",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.42 368.95V391.18",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022.07 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.71 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.35 367.851V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.867 358.384C888.113 358.56 880.907 356.845 877.901 355.962C889.127 367.407 890.886 369.607 892.867 370.709C902.112 371.588 899.909 369.388 911.795 369.388C923.682 369.388 930.285 372.471 936.448 372.69C942.61 372.909 944.15 369.388 951.636 369.388C959.122 369.388 963.081 374.452 968.145 374.452C973.209 374.452 972.986 369.169 979.809 368.95C986.632 368.731 989.714 375.773 993.016 375.773C999.401 375.773 996.099 368.509 1002.48 368.29C1008.86 368.071 1008.64 376.652 1012.82 376.652C1017 376.652 1016.79 368.509 1022.07 367.848C1027.35 367.188 1027.13 386.338 1028.67 390.958C1032.85 378.852 1034.83 355.962 1028.67 355.962C1022.51 355.962 1022.95 369.388 1017.67 369.607C1012.39 369.826 1015.69 358.381 1008.65 357.502C1001.6 356.622 1001.6 367.407 996.099 367.845C990.597 368.286 991.695 357.502 983.993 357.502C976.291 357.502 975.409 365.645 969.466 365.645C963.522 365.645 961.764 357.502 951.636 357.502C944.813 357.502 941.292 362.566 935.127 362.566C928.961 362.566 921.987 357.626 913.557 356.841C904.093 355.962 898.811 358.162 892.867 358.381V358.384Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.74 368.07C1028.31 353.279 1029.18 376.873 1028.67 390.519C1027.13 373.349 1025.59 371.547 1024.71 369.61C1023.6 367.187 1022.06 367.847 1020.74 368.07Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.868 377.975H895.291",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.868 385.017H895.291",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.569 374.45H902.992",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.569 381.496H902.992",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.569 388.537H902.992",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.853 374.45H908.275",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.853 381.496H908.275",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.853 388.537H908.275",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.136 374.45H913.558",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.136 381.496H913.558",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.136 388.537H913.558",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.418 374.45H918.84",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.418 381.496H918.84",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.418 388.537H918.84",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.701 374.45H924.124",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.701 381.496H924.124",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.701 388.537H924.124",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.983 374.45H929.406",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.983 381.496H929.406",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.983 388.537H929.406",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.267 374.45H934.689",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.267 381.496H934.689",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.267 388.537H934.689",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.547 374.45H939.969",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.547 381.496H939.969",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.547 388.537H939.969",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.829 374.45H945.252",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.83 381.496H945.252",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.829 388.537H945.252",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.111 374.45H950.534",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.111 381.496H950.534",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.111 388.537H950.534",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.395 374.45H955.817",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.395 381.496H955.817",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.395 388.537H955.817",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.678 374.45H961.1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.678 381.496H961.1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.678 388.537H961.1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.96 374.45H966.382",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.96 381.496H966.382",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.96 388.537H966.382",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.243 374.45H971.666",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.244 381.496H971.667",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.243 388.537H971.666",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.526 374.45H976.949",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.526 381.496H976.949",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.526 388.537H976.949",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.806 374.45H982.228",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.806 381.496H982.228",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.806 388.537H982.228",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.088 374.45H987.51",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.088 381.496H987.51",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.088 388.537H987.51",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.94 374.45H1003.36",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.94 381.496H1003.36",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.94 388.537H1003.36",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.22 374.45H1008.64",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.22 381.496H1008.64",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.22 388.537H1008.64",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.78 374.45H1019.2",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.78 381.496H1019.2",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.78 388.537H1019.2",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.372 381.496H992.794",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.372 388.537H992.794",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.654 381.496H998.077",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.654 388.537H998.077",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.509 374.45H897.931",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.509 381.496H897.931",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.509 388.537H897.931",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.15 377.975H900.573",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.15 385.017H900.573",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.434 377.975H905.856",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.434 385.017H905.856",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.717 377.975H911.139",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.717 385.017H911.139",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.995 377.975H916.418",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.995 385.017H916.418",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.279 377.975H921.702",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.279 385.017H921.702",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.562 377.975H926.984",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.562 385.017H926.984",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.844 377.975H932.266",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.844 385.017H932.266",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.127 377.975H937.549",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.127 385.017H937.549",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.41 377.975H942.833",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.41 385.017H942.833",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.693 377.975H948.116",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.693 385.017H948.116",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.973 377.975H953.395",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.973 385.017H953.395",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.256 377.975H958.678",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.256 385.017H958.678",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.538 377.975H963.961",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.538 385.017H963.961",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.82 377.975H969.243",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.82 385.017H969.243",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.104 377.975H974.526",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.104 385.017H974.526",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.387 377.975H979.809",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.387 385.017H979.809",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.67 377.975H985.092",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.67 385.017H985.092",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.953 377.975H990.376",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.953 385.017H990.376",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.232 377.975H995.655",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.232 385.017H995.655",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.515 377.975H1000.94",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.515 385.017H1000.94",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.8 377.975H1006.22",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.8 385.017H1006.22",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.08 377.975H1011.5",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.08 385.017H1011.5",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.36 377.975H1016.79",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.36 385.017H1016.79",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.65 377.975H1022.07",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.65 385.017H1022.07",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.93 377.975H1026.91",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.93 385.017H1027.35",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.76 368.069C1006.12 366.563 1001.6 366.088 998.957 369.609C1003.36 366.526 1005.54 368.777 1006.88 370.269C1008.86 372.47 1008.86 377.018 1013.27 376.432C1009.3 373.13 1010.41 370.488 1007.76 368.069H1007.76Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.164 368.205C983.741 366.54 976.727 366.749 973.425 371.591C977.606 367.628 982.316 369.161 984.21 369.829C987.953 371.149 989.051 376.139 993.455 375.553C989.998 374.673 989.688 370.627 986.164 368.205Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.576 368.07C954.749 367.262 949.214 367.41 942.61 371.372C950.312 368.289 955.022 369.384 956.916 370.051C960.659 371.372 963.301 374.013 967.92 374.232C964.463 373.353 962.195 369.391 957.576 368.07Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.94 367.627C915.317 367.186 909.145 366.984 898.812 370.71C910.038 368.51 916.257 369.41 919.279 369.608C925.223 369.999 929.215 372.482 936.449 372.691C931.044 371.862 927.247 368.325 919.94 367.627Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.045 373.57H538.066V391.178H667.045V373.57Z",
    fill: "#D8D0C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.189 324.488L670.785 347.597L679.147 348.258L675.185 324.488H675.189Z",
    fill: "#B7594C",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.189 324.488L673.649 348.258H679.151L675.189 324.488Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.988 348.258C672.988 347.53 673.578 346.938 674.309 346.938C675.04 346.938 675.63 347.527 675.63 348.258V355.522H672.988V348.258Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.785 348.039C670.785 347.433 671.277 346.938 671.887 346.938C672.497 346.938 672.989 347.429 672.989 348.039V355.522H670.789V348.039H670.785Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.63 348.7C675.63 347.726 676.418 346.938 677.392 346.938C678.366 346.938 679.154 347.726 679.154 348.7V355.522H675.633V348.7H675.63Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.309 354.644C674.309 353.063 675.589 351.783 677.169 351.783C678.75 351.783 680.03 353.063 680.03 354.644V359.485H674.306V354.644H674.309Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.905 354.425C669.905 353.208 670.892 352.225 672.105 352.225C673.318 352.225 674.305 353.212 674.305 354.425V361.689H669.901V354.425H669.905Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.63 355.416C675.63 354.625 676.273 353.984 677.062 353.984H677.281C678.069 353.984 678.713 354.625 678.713 355.416C678.713 356.208 678.069 356.848 677.281 356.848H677.062C676.273 356.848 675.63 356.208 675.63 355.416Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.227 355.745C671.227 355.259 671.624 354.865 672.106 354.865C672.588 354.865 672.985 355.259 672.985 355.745V356.405C672.985 356.89 672.588 357.284 672.106 357.284C671.624 357.284 671.227 356.89 671.227 356.405V355.745Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.887 365.87L678.709 357.285L693.898 365.87H671.887Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.709 357.285L665.502 363.889L665.943 364.33V368.292L671.887 366.092L678.709 357.289V357.285Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.675 391.62V365.869H672.106L665.943 368.292V391.623H693.675V391.62Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.943 373.792H539.164V391.399H665.943V373.792Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.165 366.308V373.791H665.944V364.108H537.43L539.114 366.17L539.161 366.231V366.308H539.165Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.133 299.838H599.254C598.889 299.838 598.594 300.134 598.594 300.498V365.207C598.594 365.571 598.889 365.867 599.254 365.867H600.133C600.498 365.867 600.794 365.571 600.794 365.207V300.498C600.794 300.134 600.498 299.838 600.133 299.838Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.417 299.838H604.537C604.173 299.838 603.877 300.134 603.877 300.498V365.207C603.877 365.571 604.173 365.867 604.537 365.867H605.417C605.781 365.867 606.077 365.571 606.077 365.207V300.498C606.077 300.134 605.781 299.838 605.417 299.838Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.209 379.957H540.047V391.402H546.209V379.957Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.209 379.957H540.047V382.157H546.209V379.957Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.368 375.11H540.047V378.193H541.368V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.009 375.11H542.247V378.193H544.009V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.209 375.11H544.889V378.193H546.209V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.334 379.957H550.172V391.402H556.334V379.957Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.493 375.11H550.172V378.193H551.493V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.134 375.11H552.372V378.193H554.134V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.334 375.11H555.014V378.193H556.334V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.703 379.957H569.541V391.402H575.703V379.957Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.862 375.11H569.541V378.193H570.862V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.503 375.11H571.741V378.193H573.503V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.704 375.11H574.383V378.193H575.704V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.828 379.957H579.666V391.402H585.828V379.957Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.986 375.11H579.665V378.193H580.986V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.627 375.11H581.865V378.193H583.627V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.828 375.11H584.507V378.193H585.828V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.951 379.957H589.789V391.402H595.951V379.957Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.111 375.11H589.79V378.193H591.111V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.751 375.11H591.989V378.193H593.751V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.952 375.11H594.631V378.193H595.952V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.759 379.957H609.597V391.402H615.759V379.957Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.917 375.11H609.597V378.193H610.917V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.562 375.11H611.8V378.193H613.562V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.759 375.11H614.438V378.193H615.759V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.884 379.957H619.722V391.402H625.884V379.957Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.042 375.11H619.722V378.193H621.042V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.687 375.11H621.925V378.193H623.687V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.887 375.11H624.566V378.193H625.887V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.064 379.957H658.901V391.402H665.064V379.957Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.222 375.11H658.901V378.193H660.222V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.865 375.11H661.103V378.193H662.865V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.829 383.477H675.188V391.401H677.829V383.477Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.227 383.915H669.906V388.757H671.227V383.915Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.584 383.915H667.264V388.757H668.584V383.915Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.905 381.714H671.226V376.492L669.905 376.822V381.714Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.264 381.713H668.584V376.933L667.264 377.263V381.713Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.905 369.781V373.103L671.226 372.938V369.451L669.905 369.781Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.264 370.223V373.545L668.584 373.38V369.893L667.264 370.223Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.037 383.915H688.396V388.757H691.037V383.915Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.064 375.11H663.743V378.193H665.064V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.939 379.957H648.777V391.402H654.939V379.957Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.098 375.11H648.777V378.193H650.098V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.739 375.11H650.977V378.193H652.739V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.94 375.11H653.619V378.193H654.94V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.008 379.957H629.846V391.402H636.008V379.957Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.166 375.11H629.846V378.193H631.166V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.811 375.11H632.049V378.193H633.811V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.011 375.11H634.69V378.193H636.011V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.019 372.031H655.819V391.401H658.019V372.031Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.967 372.031H626.767V391.401H628.967V372.031Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.842 372.031H616.642V391.401H618.842V372.031Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.907 372.031H586.707V391.401H588.907V372.031Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.783 372.031H576.583V391.401H578.783V372.031Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.289 372.031H547.089V391.401H549.289V372.031Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.654 374.012C557.654 370.973 560.121 368.51 563.156 368.51C566.192 368.51 568.658 370.973 568.658 374.012V391.4H557.654V374.012Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.891 374.012C636.891 370.973 639.357 368.51 642.392 368.51C645.428 368.51 647.894 370.973 647.894 374.012V391.4H636.891V374.012Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.106 364.549C672.106 364.064 672.503 363.67 672.985 363.67C673.467 363.67 673.865 364.064 673.865 364.549V391.621H672.103V364.549H672.106Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.833 369.831C688.833 369.345 689.231 368.951 689.713 368.951C690.195 368.951 690.592 369.345 690.592 369.831V372.691H688.83V369.831H688.833Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.63 369.831C675.63 369.345 676.028 368.951 676.51 368.951C676.991 368.951 677.389 369.345 677.389 369.831V372.691H675.627V369.831H675.63Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.188 376.872C675.188 376.145 675.777 375.552 676.508 375.552C677.239 375.552 677.829 376.141 677.829 376.872V381.054H675.188V376.872Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.396 376.872C688.396 376.145 688.985 375.552 689.716 375.552C690.447 375.552 691.037 376.141 691.037 376.872V381.054H688.396V376.872Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.272 371.809C597.272 368.77 599.739 366.308 602.774 366.308C605.81 366.308 608.276 368.77 608.276 371.809V391.398H597.272V371.809Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.164 391.402V371.372L533.882 370.271H513.633V391.399H539.164V391.402Z",
    fill: "#D8D0C3",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.734 370.27L528.821 360.364L534.104 370.27H514.734Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.884 370.051L529.043 360.587L537.405 364.33L539.167 366.311V371.594L533.884 370.054V370.051Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.157 387.878H519.799V380.836C519.799 380.109 519.209 379.516 518.478 379.516C517.747 379.516 517.157 380.105 517.157 380.836V387.878Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.596 376.433H519.358V374.233C519.358 373.748 518.96 373.354 518.478 373.354C517.997 373.354 517.599 373.748 517.599 374.233V376.433H517.596Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.04 376.433H530.802V374.233C530.802 373.748 530.405 373.354 529.923 373.354C529.441 373.354 529.043 373.748 529.043 374.233V376.433H529.04Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.602 387.878H531.243V380.836C531.243 380.109 530.653 379.516 529.922 379.516C529.191 379.516 528.602 380.105 528.602 380.836V387.878Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.557 370.05C521.557 368.47 522.837 367.189 524.418 367.189C525.998 367.189 527.278 368.47 527.278 370.05V391.4H521.554V370.05H521.557Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.633 368.29C513.633 367.684 514.125 367.188 514.735 367.188C515.344 367.188 515.836 367.68 515.836 368.29V391.399H513.636V368.29H513.633Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.564 368.069C532.564 367.584 532.961 367.189 533.443 367.189C533.925 367.189 534.323 367.584 534.323 368.069V391.4H532.561V368.069H532.564Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.318 376.433H525.08V374.233C525.08 373.748 524.683 373.354 524.201 373.354C523.719 373.354 523.322 373.748 523.322 374.233V376.433H523.318Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.878 387.878H525.961V381.055C525.961 380.203 525.27 379.516 524.421 379.516C523.572 379.516 522.881 380.206 522.881 381.055V387.878H522.878Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.533 374.451C558.533 371.897 560.602 369.828 563.156 369.828C565.71 369.828 567.778 371.897 567.778 374.451V391.398H558.533V374.451Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.855 391.402H566.017V383.04C566.017 381.338 564.639 379.957 562.934 379.957C561.23 379.957 559.852 381.335 559.852 383.04V391.402H559.855Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.175 375.11H559.854V378.193H561.175V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.817 375.11H562.055V378.193H563.817V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.017 375.11H564.696V378.193H566.017V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.771 374.451C637.771 371.897 639.839 369.828 642.393 369.828C644.947 369.828 647.016 371.897 647.016 374.451V391.398H637.771V374.451Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.152 372.25C598.152 369.697 600.221 367.628 602.775 367.628C605.329 367.628 607.397 369.697 607.397 372.25V391.401H598.152V372.25Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.472 391.402H605.634V383.04C605.634 381.338 604.256 379.957 602.552 379.957C600.847 379.957 599.469 381.335 599.469 383.04V391.402H599.472Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.793 375.11H599.473V378.193H600.793V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.436 375.11H601.674V378.193H603.436V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.635 375.11H604.314V378.193H605.635V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.09 391.402H645.252V383.04C645.252 381.338 643.874 379.957 642.17 379.957C640.465 379.957 639.087 381.335 639.087 383.04V391.402H639.09Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.09 391.402H645.252V384.799C645.252 383.097 643.874 381.716 642.17 381.716C640.465 381.716 639.087 383.094 639.087 384.799V391.402H639.09Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.473 391.402H605.635V384.799C605.635 383.097 604.257 381.716 602.552 381.716C600.848 381.716 599.47 383.094 599.47 384.799V391.402H599.473Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.855 391.402H566.017V384.799C566.017 383.097 564.639 381.716 562.934 381.716C561.23 381.716 559.852 383.094 559.852 384.799V391.402H559.855Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.412 375.11H639.091V378.193H640.412V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.053 375.11H641.291V378.193H643.053V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.252 375.11H643.932V378.193H645.252V375.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.151 366.53C679.151 364.219 681.021 362.349 683.332 362.349C685.644 362.349 687.514 364.222 687.514 366.53V391.62H679.151V366.53Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.313 383.915H681.792V388.757H685.313V383.915Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.91 369.831C680.91 369.345 681.307 368.951 681.789 368.951C682.271 368.951 682.668 369.345 682.668 369.831V372.691H680.906V369.831H680.91Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.993 369.831C683.993 369.345 684.39 368.951 684.872 368.951C685.354 368.951 685.751 369.345 685.751 369.831V372.691H683.989V369.831H683.993Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.792 377.091C681.792 376.239 682.483 375.552 683.332 375.552C684.181 375.552 684.872 376.242 684.872 377.091V381.054H681.789V377.091H681.792Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.334 379.957H550.172V382.157H556.334V379.957Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.703 379.957H569.541V382.157H575.703V379.957Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.828 379.957H579.666V382.157H585.828V379.957Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.951 379.957H589.789V382.157H595.951V379.957Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.759 379.957H609.597V382.157H615.759V379.957Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.884 379.957H619.722V382.157H625.884V379.957Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.008 379.957H629.846V382.157H636.008V379.957Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.939 379.957H648.777V382.157H654.939V379.957Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.064 379.957H658.901V382.157H665.064V379.957Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.355 364.549C692.355 364.064 692.753 363.67 693.234 363.67C693.716 363.67 694.114 364.064 694.114 364.549V391.621H692.352V364.549H692.355Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5126 366.308H-14.165V391.398H65.5126V366.308Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.328 366.308H107.33V391.398H188.328V366.308Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.39995 372.032C-1.39995 370.816 -0.412779 369.832 0.800125 369.832C2.01303 369.832 3.0002 370.819 3.0002 372.032V375.553H-1.40332V372.032H-1.39995Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.88324 372.032C3.88324 370.816 4.87041 369.832 6.08332 369.832C7.29622 369.832 8.28339 370.819 8.28339 372.032V375.553H3.87988V372.032H3.88324Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16255 372.032C9.16255 370.816 10.1497 369.832 11.3626 369.832C12.5755 369.832 13.5627 370.819 13.5627 372.032V375.553H9.15918V372.032H9.16255Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4458 372.032C14.4458 370.816 15.4329 369.832 16.6458 369.832C17.8587 369.832 18.8459 370.819 18.8459 372.032V375.553H14.4424V372.032H14.4458Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1694 372.032C20.1694 370.816 21.1565 369.832 22.3695 369.832C23.5824 369.832 24.5695 370.819 24.5695 372.032V375.553H20.166V372.032H20.1694Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4526 372.032C25.4526 370.816 26.4398 369.832 27.6527 369.832C28.8656 369.832 29.8527 370.819 29.8527 372.032V375.553H25.4492V372.032H25.4526Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7358 372.032C30.7358 370.816 31.723 369.832 32.9359 369.832C34.1488 369.832 35.1359 370.819 35.1359 372.032V375.553H30.7324V372.032H30.7358Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0151 372.032C36.0151 370.816 37.0023 369.832 38.2152 369.832C39.4281 369.832 40.4152 370.819 40.4152 372.032V375.553H36.0117V372.032H36.0151Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2983 372.032C41.2983 370.816 42.2855 369.832 43.4984 369.832C44.7113 369.832 45.6984 370.819 45.6984 372.032V375.553H41.2949V372.032H41.2983Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5805 372.032C46.5805 370.816 47.5677 369.832 48.7806 369.832C49.9935 369.832 50.9807 370.819 50.9807 372.032V375.553H46.5771V372.032H46.5805Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8627 372.032C51.8627 370.816 52.8499 369.832 54.0628 369.832C55.2757 369.832 56.2629 370.819 56.2629 372.032V375.553H51.8594V372.032H51.8627Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1469 372.032C57.1469 370.816 58.1341 369.832 59.347 369.832C60.5599 369.832 61.5471 370.819 61.5471 372.032V375.553H57.1436V372.032H57.1469Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4292 372.032C62.4292 370.816 63.4163 369.832 64.6292 369.832C65.8421 369.832 66.8293 370.819 66.8293 372.032V375.553H62.4258V372.032H62.4292Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.768 372.032C107.768 370.816 108.755 369.832 109.968 369.832C111.181 369.832 112.168 370.819 112.168 372.032V375.553H107.765V372.032H107.768Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.051 372.032C113.051 370.816 114.038 369.832 115.251 369.832C116.464 369.832 117.451 370.819 117.451 372.032V375.553H113.048V372.032H113.051Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.333 372.032C118.333 370.816 119.321 369.832 120.534 369.832C121.746 369.832 122.734 370.819 122.734 372.032V375.553H118.33V372.032H118.333Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.607 354.861H72.9922V366.306H101.607V354.861Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.617 372.032C123.617 370.816 124.604 369.832 125.817 369.832C127.03 369.832 128.017 370.819 128.017 372.032V375.553H123.613V372.032H123.617Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.9 372.032C128.9 370.816 129.887 369.832 131.1 369.832C132.313 369.832 133.3 370.819 133.3 372.032V375.553H128.896V372.032H128.9Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.182 372.032C134.182 370.816 135.169 369.832 136.382 369.832C137.595 369.832 138.582 370.819 138.582 372.032V375.553H134.179V372.032H134.182Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.904 372.032C139.904 370.816 140.891 369.832 142.104 369.832C143.317 369.832 144.304 370.819 144.304 372.032V375.553H139.9V372.032H139.904Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.186 372.032C145.186 370.816 146.173 369.832 147.386 369.832C148.599 369.832 149.586 370.819 149.586 372.032V375.553H145.183V372.032H145.186Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.47 372.032C150.47 370.816 151.457 369.832 152.67 369.832C153.883 369.832 154.87 370.819 154.87 372.032V375.553H150.467V372.032H150.47Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.752 372.032C155.752 370.816 156.74 369.832 157.952 369.832C159.165 369.832 160.153 370.819 160.153 372.032V375.553H155.749V372.032H155.752Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.032 372.032C161.032 370.816 162.019 369.832 163.232 369.832C164.445 369.832 165.432 370.819 165.432 372.032V375.553H161.028V372.032H161.032Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.314 372.032C166.314 370.816 167.301 369.832 168.514 369.832C169.727 369.832 170.714 370.819 170.714 372.032V375.553H166.311V372.032H166.314Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.597 372.032C171.597 370.816 172.584 369.832 173.797 369.832C175.01 369.832 175.997 370.819 175.997 372.032V375.553H171.594V372.032H171.597Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.88 372.032C176.88 370.816 177.867 369.832 179.08 369.832C180.293 369.832 181.28 370.819 181.28 372.032V375.553H176.877V372.032H176.88Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.164 372.032C182.164 370.816 183.151 369.832 184.364 369.832C185.576 369.832 186.564 370.819 186.564 372.032V375.553H182.16V372.032H182.164Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.874 361.248C73.874 359.91 74.9589 358.825 76.2965 358.825C77.634 358.825 78.7189 359.91 78.7189 361.248V364.991H73.8774V361.248H73.874Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5957 361.248C79.5957 359.91 80.6806 358.825 82.0181 358.825C83.3557 358.825 84.4406 359.91 84.4406 361.248V364.991H79.5991V361.248H79.5957Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4365 361.248C84.4365 359.91 85.5214 358.825 86.859 358.825C88.1965 358.825 89.2814 359.91 89.2814 361.248V364.991H84.4399V361.248H84.4365Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1602 361.248C90.1602 359.91 91.245 358.825 92.5826 358.825C93.9202 358.825 95.005 359.91 95.005 361.248V364.991H90.1635V361.248H90.1602Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0029 361.248C95.0029 359.91 96.0878 358.825 97.4254 358.825C98.7629 358.825 99.8478 359.91 99.8478 361.248V364.991H95.0063V361.248H95.0029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2405 340.776H80.916V354.863H93.2405V340.776Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8816 342.097H81.7988V353.1H84.8816V342.097Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8406 342.097H85.7578V353.1H88.8406V342.097Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3612 342.097H89.7197V353.1H92.3612V342.097Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8816 342.097H81.7988V342.976H84.8816V342.097Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8406 342.097H85.7578V342.976H88.8406V342.097Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8596 336.376C87.2235 336.376 87.5199 336.672 87.5199 337.036V338.798C87.5199 339.162 87.2235 339.459 86.8596 339.459C86.4957 339.459 86.1992 339.162 86.1992 338.798V337.036C86.1992 336.672 86.4957 336.376 86.8596 336.376Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.916 337.036C80.916 336.672 81.2125 336.376 81.5764 336.376C81.9403 336.376 82.2367 336.672 82.2367 337.036V337.916C82.2367 338.691 81.664 339.334 80.916 339.442V337.036Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9229 337.036C91.9229 336.672 92.2193 336.376 92.5832 336.376C92.9471 336.376 93.2436 336.672 93.2436 337.036V339.442C92.4956 339.334 91.9229 338.694 91.9229 337.916V337.036Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3612 342.097H89.7197V342.976H92.3612V342.097Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8817 353.104H78.2744V354.866H95.8817V353.104Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1161 362.786H80.916V364.986H83.1161V362.786Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.00369 364.108H-0.0791016V366.308H3.00369V364.108Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1775 364.108H28.0947V366.308H31.1775V364.108Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3494 364.108H56.2666V366.308H59.3494V364.108Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.896 364.108H114.813V366.308H117.896V364.108Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.069 364.108H142.986V366.308H146.069V364.108Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.242 364.108H171.159V366.308H174.242V364.108Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.01969 361.907H1.89905C2.5055 361.907 3.00076 362.399 3.00076 363.009C3.00076 363.615 2.50887 364.111 1.89905 364.111H1.01969C0.413234 364.111 -0.0820312 363.619 -0.0820312 363.009C-0.0820312 362.403 0.409865 361.907 1.01969 361.907Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1916 361.907H30.0709C30.6774 361.907 31.1726 362.399 31.1726 363.009C31.1726 363.615 30.6807 364.111 30.0709 364.111H29.1916C28.5851 364.111 28.0898 363.619 28.0898 363.009C28.0898 362.403 28.5817 361.907 29.1916 361.907Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3654 361.907H58.2447C58.8512 361.907 59.3465 362.399 59.3465 363.009C59.3465 363.615 58.8546 364.111 58.2447 364.111H57.3654C56.7589 364.111 56.2637 363.619 56.2637 363.009C56.2637 362.403 56.7556 361.907 57.3654 361.907Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.911 361.907H116.791C117.397 361.907 117.892 362.399 117.892 363.009C117.892 363.615 117.4 364.111 116.791 364.111H115.911C115.305 364.111 114.81 363.619 114.81 363.009C114.81 362.403 115.301 361.907 115.911 361.907Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.084 361.907H144.963C145.57 361.907 146.065 362.399 146.065 363.009C146.065 363.615 145.573 364.111 144.963 364.111H144.084C143.478 364.111 142.982 363.619 142.982 363.009C142.982 362.403 143.474 361.907 144.084 361.907Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.258 361.907H173.137C173.744 361.907 174.239 362.399 174.239 363.009C174.239 363.615 173.747 364.111 173.137 364.111H172.258C171.652 364.111 171.156 363.619 171.156 363.009C171.156 362.403 171.648 361.907 172.258 361.907Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9579 362.786H85.7578V364.986H87.9579V362.786Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6815 362.786H91.4814V364.986H93.6815V362.786Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2405 339.897H80.916V340.777H93.2405V339.897Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6021 323.168H83.1191V340.775H90.6021V323.168Z",
    fill: "#FEF6E0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1602 313.485H83.5566V323.168H90.1602V313.485Z",
    fill: "#FEF6E0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1479 313.485C90.0367 312.494 89.1978 311.723 88.1803 311.723H85.5389C84.518 311.723 83.6791 312.494 83.5713 313.485H90.1513H90.1479Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7598 311.724L86.1944 273.427H87.0805L87.5151 311.724H85.7598Z",
    fill: "#B7594C",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6396 268.144V273.426",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.84082 387.877H1.67997V391.398H-1.84082V387.877Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.88281 387.877H7.40361V391.398H3.88281V387.877Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60449 387.877H13.1253V391.398H9.60449V387.877Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8867 387.877H18.4075V391.398H14.8867V387.877Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8867 387.877H18.4075V391.398H14.8867V387.877Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4902 386.997H23.2523V391.401H21.4902V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.332 386.997H28.9735V391.401H26.332V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0527 386.997H34.2528V391.401H32.0527V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3359 386.997H39.536V391.401H37.3359V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0596 386.997H45.2596V391.401H43.0596V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3428 386.997H50.9842V391.401H48.3428V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.625 386.997H56.2664V391.401H53.625V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9043 386.997H61.5457V391.401H58.9043V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.75 386.997H65.5121V391.401H63.75V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.21 386.997H109.972V391.401H108.21V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.051 386.997H115.692V391.401H113.051V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.775 386.997H120.975V391.401H118.775V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.055 386.997H126.255V391.401H124.055V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.779 386.997H131.979V391.401H129.779V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.62 386.997H137.262V391.401H134.62V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.903 386.997H142.545V391.401H139.903V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.628 386.997H148.269V391.401H145.628V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.349 386.997H153.111V391.401H151.349V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.752 386.997H158.835V391.401H155.752V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.914 386.997H164.556V391.401H161.914V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.197 386.997H170.28V391.401H167.197V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.918 386.997H176.001V391.401H172.918V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.642 386.997H181.724V391.401H178.642V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.925 386.997H187.008V391.401H183.925V386.997Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.7207 378.636H1.6828V384.36H-2.7207V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.520508 372.47H2.12093V375.553H-0.520508V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7627 372.47H7.40413V375.553H4.7627V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4834 372.47H12.6835V375.553H10.4834V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7656 372.47H17.9657V375.553H15.7656V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4902 372.47H23.6903V375.553H21.4902V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7734 372.47H28.9735V375.553H26.7734V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0527 372.47H34.2528V375.553H32.0527V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3359 372.47H39.536V375.553H37.3359V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6191 372.47H44.8192V375.553H42.6191V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9014 372.47H50.1014V375.553H47.9014V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1836 372.47H55.3837V375.553H53.1836V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4678 372.47H60.6679V375.553H58.4678V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3086 372.47H65.5087V375.553H63.3086V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.651 372.47H111.293V375.553H108.651V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.93 372.47H116.571V375.553H113.93V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.654 372.47H121.854V375.553H119.654V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.938 372.47H127.138V375.553H124.938V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.22 372.47H132.42V375.553H130.22V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.5 372.47H137.7V375.553H135.5V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.225 372.47H143.425V375.553H141.225V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.507 372.47H148.707V375.553H146.507V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.79 372.47H153.99V375.553H151.79V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.072 372.47H159.272V375.553H157.072V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.353 372.47H164.553V375.553H162.353V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.635 372.47H169.835V375.553H167.635V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.48 372.47H174.681V375.553H172.48V372.47Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.88281 378.636H8.28633V384.36H3.88281V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16309 378.636H13.5666V384.36H9.16309V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4453 378.636H18.8488V384.36H14.4453V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1699 378.636H24.5734V384.36H20.1699V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4521 378.636H29.8557V384.36H25.4521V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7354 378.636H35.1389V384.36H30.7354V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0146 378.636H40.4182V384.36H36.0146V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2979 378.636H45.7014V384.36H41.2979V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5811 378.636H50.9846V384.36H46.5811V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8633 378.636H56.2668V384.36H51.8633V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1465 378.636H61.55V384.36H57.1465V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4297 378.636H65.5125V384.36H62.4297V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.33 378.636H111.734V384.36H107.33V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.61 378.636H117.014V384.36H112.61V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.892 378.636H122.295V384.36H117.892V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.496 378.636H128.9V384.36H124.496V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.779 378.636H134.183V384.36H129.779V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.062 378.636H139.466V384.36H135.062V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.783 378.636H145.187V384.36H140.783V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.066 378.636H150.47V384.36H146.066V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.349 378.636H155.752V384.36H151.349V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.179 373.354H188.326V390.961H215.179V373.354Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.631 378.636H161.034V384.36H156.631V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.914 378.636H166.318V384.36H161.914V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.197 378.636H171.601V384.36H167.197V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.48 378.636H176.884V384.36H172.48V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.76 378.636H182.163V384.36H177.76V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.043 378.636H187.446V384.36H183.043V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.204 378.636H193.608V384.36H189.204V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.487 378.636H198.891V384.36H194.487V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.771 378.636H204.174V384.36H199.771V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.053 378.636H209.456V384.36H205.053V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.336 378.636H214.739V384.36H210.336V378.636Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.179 373.354H188.326V390.961H215.179V373.354Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.179 373.354H188.326V375.554H215.179V373.354Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.859 332.855C88.1968 332.855 89.2814 331.77 89.2814 330.432C89.2814 329.094 88.1968 328.01 86.859 328.01C85.5211 328.01 84.4365 329.094 84.4365 330.432C84.4365 331.77 85.5211 332.855 86.859 332.855Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8589 331.311C87.3445 331.311 87.7382 330.918 87.7382 330.432C87.7382 329.946 87.3445 329.553 86.8589 329.553C86.3732 329.553 85.9795 329.946 85.9795 330.432C85.9795 330.918 86.3732 331.311 86.8589 331.311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0182 361.905C82.8686 361.905 83.5579 361.215 83.5579 360.365C83.5579 359.515 82.8686 358.825 82.0182 358.825C81.1679 358.825 80.4785 359.515 80.4785 360.365C80.4785 361.215 81.1679 361.905 82.0182 361.905Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8591 361.905C87.7094 361.905 88.3988 361.215 88.3988 360.365C88.3988 359.515 87.7094 358.825 86.8591 358.825C86.0087 358.825 85.3193 359.515 85.3193 360.365C85.3193 361.215 86.0087 361.905 86.8591 361.905Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5837 361.905C93.434 361.905 94.1234 361.215 94.1234 360.365C94.1234 359.515 93.434 358.825 92.5837 358.825C91.7333 358.825 91.0439 359.515 91.0439 360.365C91.0439 361.215 91.7333 361.905 92.5837 361.905Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6395 263.793L87.2696 265.734L87.3201 265.885H89.5202L87.8693 267.085L87.7413 267.179L87.7918 267.331L88.4218 269.271L86.7709 268.072L86.6429 267.977L86.5149 268.072L84.864 269.271L85.494 267.331L85.5445 267.179L85.4165 267.085L83.7656 265.885H85.9657L86.0162 265.734L86.6463 263.793H86.6395Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8403 314.806H87.9609V317.447H88.8403V314.806Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3159 314.806H84.4365V317.447H85.3159V314.806Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.960938 381.277H1.68051V384.36H-0.960938V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7627 381.277H7.40413V384.36H4.7627V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4834 381.277H12.6835V384.36H10.4834V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7656 381.277H17.9657V384.36H15.7656V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4902 381.277H23.6903V384.36H21.4902V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7734 381.277H28.9735V384.36H26.7734V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0527 381.277H34.2528V384.36H32.0527V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3359 381.277H39.536V384.36H37.3359V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6191 381.277H44.8192V384.36H42.6191V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9014 381.277H50.1014V384.36H47.9014V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1836 381.277H55.3837V384.36H53.1836V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4678 381.277H60.6679V384.36H58.4678V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3086 381.277H65.5087V384.36H63.3086V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.651 381.277H111.293V384.36H108.651V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.93 381.277H116.571V384.36H113.93V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.654 381.277H121.854V384.36H119.654V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.938 381.277H127.138V384.36H124.938V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.22 381.277H132.42V384.36H130.22V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.5 381.277H137.7V384.36H135.5V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.225 381.277H143.425V384.36H141.225V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.507 381.277H148.707V384.36H146.507V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.79 381.277H153.99V384.36H151.79V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.072 381.277H159.272V384.36H157.072V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.352 381.277H164.552V384.36H162.352V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.635 381.277H169.835V384.36H167.635V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.48 381.277H174.681V384.36H172.48V381.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.327 366.308H65.5088V391.398H107.327V366.308Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4336 374.673C73.4336 372.971 74.8116 371.59 76.5164 371.59C78.2212 371.59 79.5992 372.968 79.5992 374.673V384.356H73.437V374.673H73.4336Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.999 374.673C83.999 372.971 85.377 371.59 87.0818 371.59C88.7866 371.59 90.1646 372.968 90.1646 374.673V384.356H84.0024V374.673H83.999Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0029 374.673C95.0029 372.971 96.3809 371.59 98.0857 371.59C99.7905 371.59 101.169 372.968 101.169 374.673V384.356H95.0063V374.673H95.0029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.327 384.357H65.5088V391.399H107.327V384.357Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.327 384.357H65.5088V385.237H107.327V384.357Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.327 386.119H65.5088V386.998H107.327V386.119Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.327 387.877H65.5088V388.756H107.327V387.877Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.327 389.639H65.5088V390.518H107.327V389.639Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.326 366.308H-14.165V368.07H188.326V366.308Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.326 366.308H110.41V368.07H188.326V366.308Z",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9506 366.308H-14.165V368.07H65.9506V366.308Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4367 371.149H69.0332V384.357H73.4367V371.149Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9992 371.149H79.5957V384.357H83.9992V371.149Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0017 371.149H90.1602V384.357H95.0017V371.149Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.007 371.149H101.165V384.357H106.007V371.149Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9647 377.754H96.7646V384.357H98.9647V377.754Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3983 377.754H86.1982V384.357H88.3983V377.754Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3954 377.754H75.1953V384.357H77.3954V377.754Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0109 374.673C71.6194 374.673 72.1126 374.18 72.1126 373.571C72.1126 372.963 71.6194 372.47 71.0109 372.47C70.4024 372.47 69.9092 372.963 69.9092 373.571C69.9092 374.18 70.4024 374.673 71.0109 374.673Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0109 378.194C71.6194 378.194 72.1126 377.7 72.1126 377.092C72.1126 376.483 71.6194 375.99 71.0109 375.99C70.4024 375.99 69.9092 376.483 69.9092 377.092C69.9092 377.7 70.4024 378.194 71.0109 378.194Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0109 381.719C71.6194 381.719 72.1126 381.226 72.1126 380.617C72.1126 380.009 71.6194 379.516 71.0109 379.516C70.4024 379.516 69.9092 380.009 69.9092 380.617C69.9092 381.226 70.4024 381.719 71.0109 381.719Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5763 374.673C82.1848 374.673 82.678 374.18 82.678 373.571C82.678 372.963 82.1848 372.47 81.5763 372.47C80.9679 372.47 80.4746 372.963 80.4746 373.571C80.4746 374.18 80.9679 374.673 81.5763 374.673Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5763 378.194C82.1848 378.194 82.678 377.7 82.678 377.092C82.678 376.483 82.1848 375.99 81.5763 375.99C80.9679 375.99 80.4746 376.483 80.4746 377.092C80.4746 377.7 80.9679 378.194 81.5763 378.194Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5763 381.719C82.1848 381.719 82.678 381.226 82.678 380.617C82.678 380.009 82.1848 379.516 81.5763 379.516C80.9679 379.516 80.4746 380.009 80.4746 380.617C80.4746 381.226 80.9679 381.719 81.5763 381.719Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5832 374.673C93.1916 374.673 93.6849 374.18 93.6849 373.571C93.6849 372.963 93.1916 372.47 92.5832 372.47C91.9747 372.47 91.4814 372.963 91.4814 373.571C91.4814 374.18 91.9747 374.673 92.5832 374.673Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5832 378.194C93.1916 378.194 93.6849 377.7 93.6849 377.092C93.6849 376.483 93.1916 375.99 92.5832 375.99C91.9747 375.99 91.4814 376.483 91.4814 377.092C91.4814 377.7 91.9747 378.194 92.5832 378.194Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5832 381.719C93.1916 381.719 93.6849 381.226 93.6849 380.617C93.6849 380.009 93.1916 379.516 92.5832 379.516C91.9747 379.516 91.4814 380.009 91.4814 380.617C91.4814 381.226 91.9747 381.719 92.5832 381.719Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.587 374.673C104.196 374.673 104.689 374.18 104.689 373.571C104.689 372.963 104.196 372.47 103.587 372.47C102.979 372.47 102.485 372.963 102.485 373.571C102.485 374.18 102.979 374.673 103.587 374.673Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.587 378.194C104.196 378.194 104.689 377.7 104.689 377.092C104.689 376.483 104.196 375.99 103.587 375.99C102.979 375.99 102.485 376.483 102.485 377.092C102.485 377.7 102.979 378.194 103.587 378.194Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.587 381.719C104.196 381.719 104.689 381.226 104.689 380.617C104.689 380.009 104.196 379.516 103.587 379.516C102.979 379.516 102.485 380.009 102.485 380.617C102.485 381.226 102.979 381.719 103.587 381.719Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5954 373.13C79.5954 373.493 79.3157 373.878 78.7463 374.181C78.1871 374.481 77.3987 374.669 76.516 374.669C75.6332 374.669 74.8448 374.477 74.2856 374.181C73.7162 373.878 73.4365 373.497 73.4365 373.13C73.4365 372.762 73.7162 372.382 74.2856 372.078C74.8448 371.779 75.6332 371.59 76.516 371.59C77.3987 371.59 78.1871 371.782 78.7463 372.078C79.3157 372.382 79.5954 372.762 79.5954 373.13Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1608 373.13C90.1608 373.493 89.8812 373.878 89.3118 374.181C88.7525 374.481 87.9641 374.669 87.0814 374.669C86.1987 374.669 85.4103 374.477 84.851 374.181C84.2816 373.878 84.002 373.497 84.002 373.13C84.002 372.762 84.2816 372.382 84.851 372.078C85.4103 371.779 86.1987 371.59 87.0814 371.59C87.9641 371.59 88.7525 371.782 89.3118 372.078C89.8812 372.382 90.1608 372.762 90.1608 373.13Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.165 373.13C101.165 373.493 100.885 373.878 100.316 374.181C99.7564 374.481 98.968 374.669 98.0853 374.669C97.2026 374.669 96.4142 374.477 95.8549 374.181C95.2855 373.878 95.0059 373.497 95.0059 373.13C95.0059 372.762 95.2855 372.382 95.8549 372.078C96.4142 371.779 97.2026 371.59 98.0853 371.59C98.968 371.59 99.7564 371.782 100.316 372.078C100.885 372.382 101.165 372.762 101.165 373.13Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9292 339.897C81.0403 338.906 81.8793 338.135 82.8968 338.135H91.2591C92.2799 338.135 93.1188 338.906 93.2266 339.897H80.9258H80.9292Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0347 323.169L80.6123 318.327H93.1052L90.6828 323.169H83.0314H83.0347Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3159 319.648H84.4365V322.29H85.3159V319.648Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0786 319.648H86.1992V322.29H87.0786V319.648Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8403 319.648H87.9609V322.29H88.8403V319.648Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2744 352.001C78.2744 351.637 78.5709 351.341 78.9348 351.341C79.2987 351.341 79.5951 351.637 79.5951 352.001V352.881C79.5951 353.655 79.0224 354.299 78.2744 354.407V352.001Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5645 352.001C94.5645 351.637 94.8609 351.341 95.2248 351.341C95.5887 351.341 95.8852 351.637 95.8852 352.001V354.407C95.1372 354.299 94.5645 353.659 94.5645 352.881V352.001Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140.92 357.946H1058.61V390.961H1140.92V357.946Z",
    fill: "#F4D7C9",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140.92 380.837H1058.61V390.961H1140.92V380.837Z",
    fill: "#D7C7A3",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.33 364.549H1062.57V368.952H1064.33V364.549Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.34 360.364H1056.18V361.685H1143.34V360.364Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.33 373.792H1062.57V378.196H1064.33V373.792Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.77 383.037H1060.36V390.961H1064.77V383.037Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.33 383.037H1068.73V390.961H1075.33V383.037Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.02 383.037H1078.41V390.961H1085.02V383.037Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.77 384.358H1060.36V390.962H1064.77V384.358Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.33 384.358H1068.73V390.962H1075.33V384.358Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.02 384.358H1078.41V390.962H1085.02V384.358Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.81 364.549H1070.05V368.952H1071.81V364.549Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.81 373.792H1070.05V378.196H1071.81V373.792Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.65 364.549H1074.89V368.952H1076.65V364.549Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.65 373.792H1074.89V378.196H1076.65V373.792Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.49 364.549H1079.73V368.952H1081.49V364.549Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.49 373.792H1079.73V378.196H1081.49V373.792Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.24 357.946H1057.28V360.588H1142.24V357.946Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.09 358.826H1058.61V359.706H1066.09V358.826Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.65 358.826H1069.17V359.706H1076.65V358.826Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.22 358.826H1079.73V359.706H1087.22V358.826Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.865 369.392C227.783 369.392 230.148 371.757 230.148 374.674V381.278C230.148 384.196 227.783 386.561 224.865 386.561C221.947 386.561 219.582 384.196 219.582 381.278V374.674C219.582 371.757 221.947 369.392 224.865 369.392Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.525 370.931C227.957 370.931 229.928 372.902 229.928 375.334V381.496C229.928 383.929 227.957 385.9 225.525 385.9C223.092 385.9 221.121 383.929 221.121 381.496V375.334C221.121 372.902 223.092 370.931 225.525 370.931Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.643 375.333V391.62",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.944 376.655L224.861 379.738",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.781 380.175L224.864 383.258",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.781 376.655L224.864 379.738",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.513 369.392C252.431 369.392 254.796 371.757 254.796 374.674C254.796 377.592 252.431 379.957 249.513 379.957C246.596 379.957 244.23 377.592 244.23 374.674C244.23 371.757 246.596 369.392 249.513 369.392Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.513 371.373H249.955C252.266 371.373 254.136 373.246 254.136 375.554C254.136 377.865 252.262 379.735 249.955 379.735H249.513C247.202 379.735 245.332 377.862 245.332 375.554C245.332 373.243 247.205 371.373 249.513 371.373Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.294 375.333V391.62",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.374 375.772L249.291 378.855",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.435 375.772L249.517 378.855",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.906 383.07C231.906 381.19 232.293 379.333 233.041 377.612L233.792 375.887C235.251 372.538 240.002 372.538 241.461 375.887L242.212 377.612C242.963 379.333 243.347 381.19 243.347 383.07C243.347 383.538 242.967 383.919 242.498 383.919H232.751C232.283 383.919 231.902 383.538 231.902 383.07H231.906Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.446 382.855C233.446 381.322 233.766 379.806 234.39 378.404L234.747 377.602C236.111 374.53 240.471 374.53 241.836 377.602L242.193 378.404C242.813 379.806 243.136 381.322 243.136 382.855C243.136 383.32 242.759 383.701 242.29 383.701H234.295C233.83 383.701 233.45 383.323 233.45 382.855H233.446Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.63 380.619V391.404",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.49 379.735L237.63 382.377",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.427 381.056L237.627 383.478",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.968 391.373C205.923 389.53 206.213 386.241 208.551 384.786L212.429 382.374C213.029 382.003 213.79 382.017 214.37 382.414L217.81 384.762C220.037 386.285 220.333 389.456 218.426 391.363C218.403 391.386 218.369 391.4 218.335 391.4H208.042C208.015 391.4 207.985 391.39 207.965 391.369L207.968 391.373Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.965 391.369C207.985 391.39 208.015 391.4 208.042 391.4H218.335C218.369 391.4 218.403 391.386 218.426 391.363C220.333 389.456 220.037 386.285 217.81 384.762L214.37 382.414C213.79 382.017 213.029 382.003 212.429 382.374L208.551 384.786C206.213 386.241 205.923 389.53 207.968 391.373L207.965 391.369ZM207.965 391.369L207.817 391.534",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.278 391.09C206.937 389.483 207.368 387.057 209.177 386.006L213.52 383.489C213.999 383.213 214.592 383.219 215.067 383.506L218.042 385.322C220.158 386.612 220.306 389.627 218.332 391.123C218.284 391.16 218.227 391.177 218.166 391.177H208.473C208.396 391.177 208.322 391.144 208.275 391.083L208.278 391.09Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.756 387.66V391.181",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.619 386.779L212.759 389.421",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.557 388.1L212.757 390.522",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.173 391.621H256.902C258.034 391.621 259.122 391.194 259.947 390.422L260.544 389.866C260.739 389.684 260.881 389.455 260.958 389.199L261.012 389.01C261.426 387.612 259.732 386.558 258.66 387.551V386.803C258.66 385.264 256.726 384.573 255.753 385.769C256.218 383.909 254.082 382.498 252.555 383.657L252.121 383.987L252.003 383.62C251.592 382.343 250.204 381.659 248.944 382.114C247.684 382.568 247.05 383.973 247.542 385.217L247.761 385.769C245.888 385.769 244.843 387.929 246.006 389.398L246.885 390.51C247.441 391.21 248.287 391.621 249.179 391.621H249.173Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 391.401L249.072 387.22",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.834 389.64L252.374 386.338",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.456 391.621L257.656 388.761",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.238 388.1L256.778 389.639",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.917 391.402L249.514 384.138",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.481 385.005C352.987 383.422 353.287 381.043 352.219 379.136L346.161 368.291C345.571 367.236 344.058 367.236 343.469 368.291L337.233 379.456C336.262 381.195 336.471 383.358 337.765 384.877C338.671 385.945 340.002 386.559 341.404 386.559H347.862C349.23 386.559 350.537 385.996 351.481 385.005Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.117 385.227C352.569 383.873 352.856 381.676 351.794 379.995L346.744 371.979C346.053 370.884 344.453 370.884 343.762 371.979L337.994 381.137C337.344 382.168 337.482 383.509 338.324 384.391C339.521 385.638 341.171 386.342 342.896 386.342H348.287C349.335 386.342 350.346 385.945 351.11 385.23L351.117 385.227Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.816 375.336V391.623",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.515 376.656L344.597 379.739",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.118 380.177L345.035 383.26",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.678 376.656L344.595 379.739",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.494 391.375C363.539 389.532 363.25 386.243 360.911 384.788L357.033 382.376C356.434 382.005 355.672 382.018 355.093 382.416L351.653 384.764C349.426 386.287 349.129 389.458 351.036 391.365C351.06 391.388 351.094 391.402 351.127 391.402H361.42C361.447 391.402 361.477 391.392 361.498 391.371L361.494 391.375Z",
    fill: "#FFD6D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.498 391.371C361.477 391.392 361.447 391.402 361.42 391.402H351.127C351.094 391.402 351.06 391.388 351.036 391.365C349.129 389.458 349.426 386.287 351.653 384.764L355.093 382.416C355.672 382.018 356.434 382.005 357.033 382.376L360.911 384.788C363.25 386.243 363.539 389.532 361.494 391.375L361.498 391.371ZM361.498 391.371L361.646 391.536",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.064 391.09C363.405 389.483 362.974 387.057 361.165 386.006L356.822 383.489C356.343 383.213 355.75 383.219 355.275 383.506L352.3 385.322C350.184 386.612 350.036 389.627 352.011 391.123C352.058 391.16 352.115 391.177 352.176 391.177H361.869C361.946 391.177 362.02 391.144 362.068 391.083L362.064 391.09Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.703 387.661V391.182",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.843 386.781L356.703 389.423",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.902 388.101L356.702 390.523",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.886 385.002C714.392 383.419 714.692 381.04 713.624 379.133L707.566 368.288C706.976 367.233 705.46 367.233 704.871 368.288L698.638 379.453C697.664 381.192 697.876 383.355 699.166 384.874C700.073 385.942 701.404 386.556 702.809 386.556H709.267C710.635 386.556 711.942 385.993 712.886 385.002Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.523 385.227C713.975 383.873 714.262 381.676 713.207 379.995L708.153 371.979C707.466 370.884 705.866 370.884 705.178 371.979L699.407 381.137C698.76 382.168 698.895 383.509 699.737 384.391C700.933 385.638 702.584 386.342 704.312 386.342H709.706C710.754 386.342 711.762 385.945 712.53 385.23L712.523 385.227Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.223 375.334V391.621",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.92 376.655L706.003 379.738",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.524 380.174L706.441 383.257",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.083 376.655L706 379.738",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.896 391.371C724.945 389.528 724.652 386.24 722.317 384.784L718.439 382.372C717.839 382.001 717.078 382.015 716.498 382.412L713.055 384.76C710.828 386.283 710.532 389.454 712.439 391.361C712.465 391.384 712.496 391.398 712.53 391.398H722.822C722.849 391.398 722.876 391.388 722.896 391.367V391.371Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.896 391.367C722.876 391.388 722.849 391.398 722.822 391.398H712.53C712.496 391.398 712.465 391.384 712.439 391.361C710.532 389.454 710.828 386.283 713.055 384.76L716.498 382.412C717.078 382.015 717.839 382.001 718.439 382.372L722.317 384.784C724.652 386.24 724.945 389.528 722.896 391.371V391.367ZM722.896 391.367L723.045 391.533",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.469 391.088C724.806 389.481 724.375 387.055 722.566 386.004L718.226 383.487C717.748 383.211 717.152 383.217 716.68 383.504L713.705 385.32C711.589 386.61 711.437 389.625 713.415 391.121C713.459 391.158 713.516 391.175 713.577 391.175H723.267C723.347 391.175 723.415 391.142 723.469 391.081V391.088Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.108 387.658V391.179",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.248 386.779L718.109 389.421",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.308 388.1L718.108 390.522",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1371.35 390.961H-71.832V404.606H1371.35V390.961Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1371.35 393.82H-72.0518V404.386H1371.35V393.82Z",
    fill: "#A9D395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-71.2998 404.387H227.155L127.67 401.304H9.25723L-71.2998 404.387Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.522 404.387H482.602L397.645 401.304H279.232L133.525 404.387H133.522Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.699 404.387H972.984L830.798 401.304H553.912L437.699 404.387Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.33 404.387H1371.35V401.304H1145.54L1029.33 404.387Z",
    fill: "#6F9392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.04 398.224C747.915 399.474 746.864 400.424 745.611 400.424H745.291C743.997 400.424 742.892 399.497 742.666 398.224C742.464 399.49 741.356 400.424 740.069 400.424C738.778 400.424 737.656 399.494 737.431 398.224C737.201 399.497 736.093 400.424 734.799 400.424H734.627C733.334 400.424 732.229 399.497 732.003 398.224L731.922 398.598C731.693 399.666 730.75 400.427 729.658 400.427H729.547C728.33 400.427 727.347 399.44 727.347 398.227",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M536.833 408.275C533.956 407.315 531.766 408.676 531.035 409.475C530.765 409.606 530.193 409.754 530.034 409.276C531.631 407.477 534.832 406.877 536.83 408.275H536.833Z",
    fill: "url(#paint5_linear_7001_56018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.523 398.392V399.817L191.189 399.652C190.785 398.844 189.96 398.335 189.057 398.335H176.581C176.55 398.335 176.523 398.362 176.523 398.392Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.07 382.598H1047.77L1077.23 396.684H1033.07V382.598Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.08 382.598H1033.07V396.684H1044.08V382.598Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.56 386.119H1036.59V396.685H1040.56V386.119Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.33 381.641L1040.03 377.992H1039.98L1039.04 380.003L1038.06 377.972L1036.72 381.637H1036.37V381.93H1038.27V381.637H1037.89L1038.27 380.492L1039.04 381.934L1039.77 380.492L1040.15 381.637H1039.77V381.93H1041.65V381.637H1041.33L1041.33 381.641Z",
    fill: "#B7594C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.129 397.593C635.129 395.713 635.517 393.857 636.265 392.135L637.016 390.41C638.472 387.061 643.229 387.061 644.684 390.41L645.436 392.135C646.184 393.857 646.571 395.713 646.571 397.593C646.571 398.062 646.194 398.442 645.722 398.442H635.975C635.503 398.442 635.126 398.062 635.126 397.593H635.129Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.672 397.377C636.672 395.844 636.992 394.328 637.615 392.927L637.972 392.125C639.337 389.052 643.697 389.052 645.061 392.125L645.418 392.927C646.038 394.328 646.362 395.844 646.362 397.377C646.362 397.842 645.984 398.223 645.516 398.223H637.521C637.053 398.223 636.675 397.846 636.675 397.377H636.672Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.854 395.141V398.661",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.714 394.262L640.854 396.903",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.653 395.582L640.853 398.004",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.908 398.412C603.86 396.569 604.153 393.281 606.488 391.825L610.366 389.413C610.965 389.042 611.727 389.056 612.306 389.453L615.75 391.801C617.977 393.324 618.273 396.495 616.366 398.402C616.339 398.425 616.309 398.439 616.275 398.439H605.982C605.955 398.439 605.929 398.429 605.908 398.408V398.412Z",
    fill: "#FFD6D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.908 398.408C605.929 398.429 605.955 398.439 605.982 398.439H616.275C616.309 398.439 616.339 398.425 616.366 398.402C618.273 396.495 617.977 393.324 615.75 391.801L612.306 389.453C611.727 389.056 610.965 389.042 610.366 389.413L606.488 391.825C604.153 393.281 603.86 396.569 605.908 398.412V398.408ZM605.908 398.408L605.76 398.574",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.218 398.13C604.88 396.523 605.311 394.097 607.121 393.046L611.46 390.529C611.939 390.253 612.535 390.259 613.007 390.546L615.982 392.362C618.097 393.652 618.249 396.667 616.271 398.163C616.228 398.2 616.17 398.217 616.11 398.217H606.42C606.339 398.217 606.272 398.184 606.218 398.123V398.13Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.699 394.703V398.224",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.56 393.819L610.699 396.461",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.499 395.141L610.699 397.563",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.113 398.662H654.842C655.974 398.662 657.059 398.235 657.888 397.463L658.481 396.907C658.679 396.725 658.821 396.496 658.895 396.24L658.952 396.051C659.367 394.653 657.672 393.599 656.601 394.592V393.845C656.601 392.305 654.663 391.614 653.69 392.81C654.155 390.95 652.022 389.539 650.489 390.698L650.054 391.028L649.94 390.661C649.525 389.384 648.141 388.7 646.877 389.155C645.617 389.609 644.984 391.014 645.479 392.258L645.698 392.81C643.828 392.81 642.78 394.97 643.943 396.439L644.819 397.551C645.375 398.251 646.217 398.662 647.113 398.662Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.657 398.443L647.016 394.262",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.777 396.681L650.317 393.379",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.397 398.661L655.598 395.801",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.178 395.141L654.717 396.68",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.857 398.443L647.453 391.179",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5659 397.594C13.5659 395.714 13.9533 393.858 14.7013 392.136L15.4526 390.411C16.9115 387.062 21.662 387.062 23.1209 390.411L23.8722 392.136C24.6235 393.858 25.0076 395.714 25.0076 397.594C25.0076 398.063 24.6269 398.443 24.1586 398.443H14.4115C13.9432 398.443 13.5625 398.063 13.5625 397.594H13.5659Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1055 397.377C15.1055 395.844 15.4255 394.328 16.0488 392.927L16.406 392.125C17.7705 389.052 22.1302 389.052 23.4947 392.125L23.8519 392.927C24.4718 394.328 24.7952 395.844 24.7952 397.377C24.7952 397.842 24.4179 398.223 23.9496 398.223H15.9545C15.4896 398.223 15.1088 397.846 15.1088 397.377H15.1055Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2871 395.142V398.662",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1505 394.262L19.29 396.903",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0869 395.583L19.287 398.005",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5506 398.662H33.2795C34.4116 398.662 35.4998 398.235 36.3253 397.463L36.9216 396.907C37.117 396.725 37.2585 396.496 37.336 396.24L37.3899 396.051C37.8043 394.653 36.1096 393.599 35.0382 394.592V393.845C35.0382 392.305 33.1043 391.614 32.1306 392.81C32.5956 390.95 30.4595 389.539 28.9333 390.698L28.4987 391.028L28.3807 390.661C27.9697 389.384 26.5816 388.7 25.3215 389.155C24.0614 389.609 23.428 391.014 23.9199 392.258L24.1389 392.81C22.2657 392.81 21.2212 394.97 22.3836 396.439L23.263 397.551C23.8189 398.251 24.6645 398.662 25.5574 398.662H25.5506Z",
    fill: "#62AE80",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0936 398.443L25.4521 394.262",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2109 396.68L28.7506 393.378",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.834 398.661L34.034 395.801",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6143 395.142L33.154 396.681",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2941 398.443L25.8906 391.179",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083.25 395.834C1083.25 393.954 1082.86 392.098 1082.12 390.376L1081.37 388.651C1079.91 385.302 1075.15 385.302 1073.7 388.651L1072.95 390.376C1072.2 392.098 1071.81 393.954 1071.81 395.834C1071.81 396.303 1072.19 396.683 1072.66 396.683H1082.41C1082.88 396.683 1083.26 396.303 1083.26 395.834H1083.25Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.71 395.62C1081.71 394.087 1081.39 392.57 1080.77 391.169L1080.41 390.367C1079.05 387.294 1074.69 387.294 1073.32 390.367L1072.97 391.169C1072.35 392.57 1072.02 394.087 1072.02 395.62C1072.02 396.085 1072.4 396.465 1072.87 396.465H1080.86C1081.33 396.465 1081.71 396.088 1081.71 395.62H1081.71Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.53 393.381V396.902",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.67 392.499L1077.53 395.14",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.73 393.82L1077.53 396.243",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.27 396.903H1063.54C1062.41 396.903 1061.32 396.475 1060.5 395.703L1059.9 395.147C1059.71 394.965 1059.56 394.736 1059.49 394.48L1059.43 394.292C1059.02 392.893 1060.71 391.839 1061.78 392.833V392.085C1061.78 390.545 1063.72 389.854 1064.7 391.05C1064.23 389.191 1066.36 387.779 1067.9 388.938L1068.33 389.268L1068.45 388.901C1068.86 387.624 1070.24 386.94 1071.51 387.395C1072.77 387.85 1073.4 389.255 1072.91 390.498L1072.69 391.05C1074.56 391.05 1075.61 393.21 1074.44 394.679L1073.57 395.791C1073.01 396.492 1072.17 396.903 1071.27 396.903Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.73 396.68L1071.37 392.499",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.61 394.922L1068.07 391.62",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.99 396.903L1062.79 394.043",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.21 393.381L1063.67 394.921",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.53 396.682L1070.93 389.418",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.758 388.979C582.061 388.979 582.31 389.224 582.31 389.531V398.365C582.31 398.668 582.064 398.918 581.758 398.918C581.454 398.918 581.205 398.672 581.205 398.365V389.531C581.205 389.228 581.451 388.979 581.758 388.979Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.08 389.712H582.311V393.391H601.08V389.712Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.08 392.289H582.311V392.656H601.08V392.289Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.08 390.819H582.311V391.187H601.08V390.819Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.975 389.531C599.975 389.224 600.221 388.979 600.524 388.979C600.827 388.979 601.08 389.224 601.08 389.531V398.365C601.08 398.668 600.834 398.918 600.524 398.918C600.214 398.918 599.975 398.672 599.975 398.365V389.531Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.701 395.234C585.004 395.234 585.254 395.48 585.254 395.787V399.099C585.254 399.402 585.008 399.651 584.701 399.651C584.398 399.651 584.148 399.405 584.148 399.099V395.787C584.148 395.484 584.394 395.234 584.701 395.234Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.101 395.234C603.405 395.234 603.654 395.48 603.654 395.787V399.099C603.654 399.402 603.408 399.651 603.101 399.651C602.798 399.651 602.549 399.405 602.549 399.099V395.787C602.549 395.484 602.795 395.234 603.101 395.234Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.31 395.235L581.205 394.315H601.08L603.654 395.235V396.34H584.15L582.31 395.235Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.656 395.234H584.148V396.339H603.656V395.234Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.205 394.315L584.15 395.235V396.708L581.205 395.421V394.315Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.988 388.979C996.291 388.979 996.541 389.224 996.541 389.531V398.365C996.541 398.668 996.295 398.918 995.988 398.918C995.685 398.918 995.436 398.672 995.436 398.365V389.531C995.436 389.228 995.681 388.979 995.988 388.979Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.31 389.712H996.541V393.391H1015.31V389.712Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.31 392.289H996.541V392.656H1015.31V392.289Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.31 390.819H996.541V391.187H1015.31V390.819Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.21 389.531C1014.21 389.224 1014.45 388.979 1014.75 388.979C1015.06 388.979 1015.31 389.224 1015.31 389.531V398.365C1015.31 398.668 1015.06 398.918 1014.75 398.918C1014.44 398.918 1014.21 398.672 1014.21 398.365V389.531Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.933 395.233C999.237 395.233 999.486 395.479 999.486 395.786V399.098C999.486 399.401 999.24 399.65 998.933 399.65C998.63 399.65 998.381 399.404 998.381 399.098V395.786C998.381 395.483 998.627 395.233 998.933 395.233Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.33 395.233C1017.64 395.233 1017.88 395.479 1017.88 395.786V399.098C1017.88 399.401 1017.64 399.65 1017.33 399.65C1017.03 399.65 1016.78 399.404 1016.78 399.098V395.786C1016.78 395.483 1017.03 395.233 1017.33 395.233Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.541 395.235L995.436 394.315H1015.31L1017.88 395.235V396.34H998.38L996.541 395.235Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.89 395.233H998.381V396.338H1017.89V395.233Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.436 394.315L998.38 395.235V396.708L995.436 395.421V394.315Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1371.35 430.797H-72.0518V436.036H1371.35V430.797Z",
    fill: "#C3E1B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1371.35 435.567H-72.0518V439.158H1371.35V435.567Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.36 394.263C392.231 395.024 391.571 395.583 390.8 395.583H388.748C387.929 395.583 387.211 395.044 386.982 394.263C386.777 395.041 386.076 395.583 385.271 395.583H383.515C382.697 395.583 381.979 395.044 381.75 394.263C381.518 395.048 380.793 395.583 379.974 395.583H378.084C377.266 395.583 376.548 395.044 376.319 394.263C376.036 395.054 375.285 395.583 374.449 395.583H372.987C372.256 395.583 371.666 394.994 371.666 394.263",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.141 398.225C357.016 399.475 355.965 400.425 354.708 400.425H354.388C353.094 400.425 351.989 399.498 351.767 398.225C351.568 399.491 350.453 400.425 349.169 400.425C347.879 400.425 346.754 399.495 346.531 398.225C346.302 399.498 345.194 400.425 343.9 400.425H343.728C342.434 400.425 341.329 399.498 341.107 398.225L341.026 398.599C340.797 399.667 339.857 400.428 338.765 400.428H338.654C337.438 400.428 336.454 399.441 336.454 398.228",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.326 394.263C142.198 395.024 141.541 395.583 140.766 395.583H138.714C137.899 395.583 137.181 395.044 136.949 394.263C136.743 395.041 136.039 395.583 135.237 395.583H133.478C132.663 395.583 131.945 395.044 131.713 394.263C131.477 395.048 130.756 395.583 129.937 395.583H128.047C127.232 395.583 126.514 395.044 126.282 394.263C125.999 395.054 125.251 395.583 124.408 395.583H122.95C122.222 395.583 121.629 394.994 121.629 394.263",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.108 398.225C106.983 399.475 105.932 400.425 104.675 400.425H104.355C103.061 400.425 101.956 399.498 101.734 398.225C101.535 399.491 100.42 400.425 99.1362 400.425C97.8458 400.425 96.7205 399.495 96.4981 398.225C96.269 399.498 95.1606 400.425 93.8668 400.425H93.695C92.4012 400.425 91.2961 399.498 91.0738 398.225L90.9929 398.599C90.7638 399.667 89.8238 400.428 88.7322 400.428H88.621C87.4047 400.428 86.4209 399.441 86.4209 398.228",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.138 394.263C519.01 395.024 518.349 395.583 517.578 395.583H515.526C514.707 395.583 513.99 395.044 513.761 394.263C513.555 395.041 512.854 395.583 512.049 395.583H510.294C509.475 395.583 508.757 395.044 508.528 394.263C508.296 395.048 507.571 395.583 506.753 395.583H504.863C504.044 395.583 503.326 395.044 503.097 394.263C502.814 395.054 502.063 395.583 501.227 395.583H499.765C499.034 395.583 498.444 394.994 498.444 394.263",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.919 398.225C483.794 399.475 482.743 400.425 481.49 400.425H481.17C479.876 400.425 478.771 399.498 478.545 398.225C478.343 399.491 477.235 400.425 475.948 400.425C474.657 400.425 473.535 399.495 473.31 398.225C473.08 399.498 471.972 400.425 470.678 400.425H470.506C469.213 400.425 468.108 399.498 467.882 398.225L467.801 398.599C467.572 399.667 466.628 400.428 465.537 400.428H465.426C464.209 400.428 463.226 399.441 463.226 398.228",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.258 394.263C783.13 395.024 782.47 395.583 781.698 395.583H779.646C778.827 395.583 778.11 395.044 777.881 394.263C777.675 395.041 776.974 395.583 776.169 395.583H774.414C773.595 395.583 772.877 395.044 772.648 394.263C772.416 395.048 771.692 395.583 770.873 395.583H768.983C768.164 395.583 767.446 395.044 767.217 394.263C766.934 395.054 766.183 395.583 765.347 395.583H763.885C763.154 395.583 762.564 394.994 762.564 394.263",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.873 396.077C969.745 396.839 969.085 397.398 968.313 397.398H966.261C965.443 397.398 964.725 396.859 964.496 396.077C964.29 396.855 963.59 397.398 962.784 397.398H961.029C960.21 397.398 959.493 396.859 959.264 396.077C959.031 396.862 958.307 397.398 957.488 397.398H955.598C954.779 397.398 954.062 396.859 953.833 396.077C953.55 396.869 952.798 397.398 951.963 397.398H950.5C949.769 397.398 949.18 396.808 949.18 396.077",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.863 398.225C881.739 399.475 880.688 400.425 879.434 400.425H879.114C877.82 400.425 876.715 399.498 876.49 398.225C876.287 399.491 875.179 400.425 873.892 400.425C872.602 400.425 871.48 399.495 871.254 398.225C871.025 399.498 869.916 400.425 868.623 400.425H868.451C867.157 400.425 866.052 399.498 865.826 398.225L865.745 398.599C865.516 399.667 864.573 400.428 863.481 400.428H863.37C862.154 400.428 861.17 399.441 861.17 398.228",
    stroke: "#615E66",
    strokeWidth: 0.336918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.86 365.87C481.778 365.87 484.143 368.235 484.143 371.153V377.757C484.143 380.674 481.778 383.039 478.86 383.039C475.942 383.039 473.577 380.674 473.577 377.757V371.153C473.577 368.235 475.942 365.87 478.86 365.87Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.521 367.409C481.953 367.409 483.924 369.38 483.924 371.813V377.975C483.924 380.407 481.953 382.378 479.521 382.378C477.088 382.378 475.117 380.407 475.117 377.975V371.813C475.117 369.38 477.088 367.409 479.521 367.409Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.638 371.809V391.178",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.94 373.13L478.638 376.802",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.776 376.655L478.637 379.516",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.776 373.13L478.637 375.99",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.705 373.791C497.622 373.791 499.988 376.156 499.988 379.074C499.988 381.992 497.622 384.357 494.705 384.357C491.787 384.357 489.422 381.992 489.422 379.074C489.422 376.156 491.787 373.791 494.705 373.791Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.705 375.772H495.146C497.457 375.772 499.327 377.646 499.327 379.954C499.327 382.265 497.454 384.135 495.146 384.135H494.705C492.393 384.135 490.523 382.261 490.523 379.954C490.523 377.642 492.397 375.772 494.705 375.772Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.486 379.735V390.961",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.565 380.175L494.482 383.258",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.625 380.175L494.708 383.258",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.645 390.962C464.645 390.962 464.568 390.867 464.531 390.82C463.068 388.93 463.506 386.107 465.626 384.786L469.504 382.374C470.103 382.003 470.865 382.017 471.444 382.414L474.887 384.762C476.899 386.137 477.334 388.856 475.996 390.776C475.952 390.837 475.861 390.962 475.861 390.962H464.649H464.645Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.342 390.701C464.021 389.114 464.446 386.722 466.232 385.684L470.514 383.201C470.989 382.928 471.575 382.935 472.037 383.218L474.971 385.01C477.06 386.284 477.208 389.259 475.258 390.735C475.214 390.768 475.157 390.789 475.096 390.789H465.538C465.46 390.789 465.389 390.755 465.339 390.698L465.342 390.701Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.834 387.659V390.961",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.693 386.778L469.833 389.42",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.634 388.1L469.834 390.522",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.866 390.96C493.866 390.96 494.354 390.627 494.573 390.421L495.166 389.865C495.365 389.683 495.506 389.454 495.581 389.198L495.638 389.009C496.052 387.611 494.357 386.557 493.286 387.55V386.803C493.286 385.263 491.349 384.572 490.375 385.768C490.84 383.908 488.707 382.497 487.174 383.656L486.74 383.986L486.625 383.619C486.211 382.342 484.826 381.658 483.563 382.113C482.303 382.567 481.669 383.972 482.164 385.216L482.383 385.768C480.514 385.768 479.466 387.928 480.628 389.397L481.504 390.509C481.635 390.677 481.949 390.96 481.949 390.96H493.866Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.063 390.96L483.701 387.217",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.133 389.487L487.003 386.337",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.592 390.961L492.287 388.761",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.863 388.1L491.548 389.717",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.277 390.962L484.143 384.14",
    stroke: "#615E66",
    strokeWidth: 0.336918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.294 269.05H106.614L110.749 267.329C112.124 266.755 113.685 266.807 115.019 267.474C115.722 266.771 117.856 265.582 120.798 266.424C117.014 267.267 115.37 269.577 115.019 270.627C113.654 269.603 111.995 269.05 110.289 269.05H110.294Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.685 224.895H500.005L504.14 223.174C505.52 222.6 507.076 222.652 508.409 223.319C509.112 222.621 511.247 221.427 514.188 222.269C510.405 223.112 508.761 225.422 508.409 226.472C507.045 225.448 505.386 224.895 503.68 224.895H503.685Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.685 184.895H142.005L146.14 183.174C147.52 182.6 149.076 182.652 150.409 183.319C151.112 182.621 153.247 181.427 156.188 182.269C152.405 183.112 150.761 185.422 150.409 186.472C149.045 185.448 147.386 184.895 145.68 184.895H145.685Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.899 196.972H756.579L752.444 195.251C751.064 194.677 749.508 194.729 748.175 195.396C747.472 194.698 745.337 193.504 742.396 194.346C746.179 195.189 747.823 197.499 748.175 198.549C749.539 197.525 751.198 196.972 752.904 196.972H752.899Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.29 295.128H922.97L918.835 293.407C917.46 292.833 915.899 292.885 914.565 293.552C913.862 292.849 911.728 291.66 908.786 292.502C912.57 293.345 914.214 295.655 914.565 296.705C915.93 295.681 917.589 295.128 919.295 295.128H919.29Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.476 256.546H731.913C730.53 256.546 729.409 257.667 729.409 259.05C729.409 260.432 730.53 261.554 731.913 261.554H739.645C740.408 261.554 741.027 262.173 741.027 262.935C741.027 263.697 740.408 264.317 739.645 264.317H735.6C734.408 264.317 733.441 265.284 733.441 266.476C733.441 267.669 734.408 268.636 735.6 268.636H778.102C779.294 268.636 780.261 267.669 780.261 266.476C780.261 265.284 779.294 264.317 778.102 264.317H766.709C765.945 264.317 765.326 263.698 765.326 262.935C765.326 262.171 765.945 261.554 766.709 261.554H771.476C772.858 261.554 773.98 260.432 773.98 259.05C773.98 257.667 772.858 256.546 771.476 256.546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.5 239.252H310.398C312.385 239.252 314 237.641 314 235.65C314 233.662 312.389 232.048 310.398 232.048H305.688V230.671C305.688 224.412 298.977 220.442 293.492 223.455L290.693 224.992V224.153C290.693 217.865 285.708 212.603 279.421 212.501C272.998 212.393 267.76 217.569 267.76 223.964V224.992L266.118 223.989C260.818 220.748 254.611 226.535 257.472 232.048H252.401C250.351 232.048 248.706 233.755 248.802 235.823C248.894 237.761 250.561 239.249 252.5 239.249V239.252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.639 275.034H415.326C414.389 275.034 413.59 274.284 413.607 273.349C413.625 272.384 412.849 271.597 411.889 271.597H401.463C400.551 271.597 399.78 270.97 399.534 270.091C398.609 266.78 394.711 264.977 391.5 266.808L390.14 267.582C389.602 267.889 388.915 267.656 388.675 267.085C387.427 264.127 384.403 262.318 381.206 262.623L380.784 262.664C377.011 263.023 374.13 266.191 374.13 269.979C374.13 270.873 373.405 271.595 372.514 271.595H370.752C369.814 271.595 369.015 272.345 369.033 273.28C369.051 274.215 368.275 275.032 367.315 275.032H366.744C365.481 275.032 364.377 275.985 364.295 277.245C364.206 278.625 365.299 279.773 366.662 279.773H371.582C372.388 279.773 373.08 280.418 373.065 281.225C373.049 282.057 373.718 282.736 374.545 282.736H403.885C405.522 282.736 406.849 281.409 406.849 279.773H417.554C418.817 279.773 419.921 278.82 420.003 277.56C420.092 276.179 418.999 275.032 417.636 275.032L417.639 275.034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2002 216.352H19.0351C17.0743 216.352 15.4824 214.76 15.4824 212.8C15.4824 210.839 17.0704 209.247 19.0351 209.247H37.6601V207.888C37.6601 201.719 44.2762 197.805 49.6847 200.775L52.4453 202.289V201.276C52.4453 195.033 57.5083 189.97 63.7516 189.97C69.9949 189.97 75.0579 195.033 75.0579 201.276V202.289L76.677 201.299C81.903 198.104 88.0221 203.808 85.2033 209.247H90.2041C92.1649 209.247 93.7568 210.839 93.7568 212.8C93.7568 214.76 92.1687 216.352 90.2041 216.352H90.2002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.75 225.893H1024.26C1027.01 225.893 1029.23 223.67 1029.23 220.926C1029.23 218.183 1027.01 215.96 1024.26 215.96H998.218V214.059C998.218 205.429 988.969 199.958 981.406 204.11L977.547 206.231V204.811C977.547 196.079 970.468 189 961.736 189C953.004 189 945.926 196.079 945.926 204.811V206.231L943.658 204.847C936.351 200.378 927.795 208.356 931.735 215.96H924.742C921.998 215.96 919.775 218.183 919.775 220.926C919.775 223.67 921.998 225.893 924.742 225.893H924.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.987 400.633V401.429L288.296 401.27L277.493 400H264.624C264.273 400 263.987 400.286 263.987 400.637V400.633Z",
    fill: "#CDD9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223 403.335C223 402.108 223.997 401.11 225.225 401.11H307.587C309.533 401.11 311.352 402.075 312.443 403.689C313.921 405.879 315.087 408.263 315.902 410.777L315.951 410.929C316.471 412.531 316.737 414.2 316.737 415.883V423.353C316.737 424.581 315.74 425.578 314.512 425.578H225.225C223.997 425.578 223 424.581 223 423.353V403.335Z",
    fill: "#CDD9F4",
    stroke: "#76736C",
    strokeWidth: 0.32481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.656 405.009L317.847 405.88L316.737 406.357C316.737 404.905 315.372 403.84 313.963 404.191L312.923 404.451L311.812 403.021H315.174C316.366 403.021 317.396 403.85 317.656 405.013V405.009Z",
    fill: "#FFF9DE",
    stroke: "#76736C",
    strokeWidth: 0.32481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.633 416.522H305.115",
    stroke: "#76736C",
    strokeWidth: 0.32481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.548 416.68V425.576",
    stroke: "#76736C",
    strokeWidth: 0.32481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.942 417.635H239.202",
    stroke: "#76736C",
    strokeWidth: 0.32481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.942 418.589H239.202",
    stroke: "#76736C",
    strokeWidth: 0.32481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.942 419.541H239.202",
    stroke: "#76736C",
    strokeWidth: 0.32481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.942 420.493H239.202",
    stroke: "#76736C",
    strokeWidth: 0.32481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.942 421.447H239.202",
    stroke: "#76736C",
    strokeWidth: 0.32481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.942 422.399H239.202",
    stroke: "#76736C",
    strokeWidth: 0.32481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.942 423.353H239.202",
    stroke: "#76736C",
    strokeWidth: 0.32481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.942 424.306H239.202",
    stroke: "#76736C",
    strokeWidth: 0.32481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.943 416.68V425.576",
    stroke: "#76736C",
    strokeWidth: 0.32481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.335 416.68V425.576",
    stroke: "#76736C",
    strokeWidth: 0.32481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.407 416.68V425.576",
    stroke: "#76736C",
    strokeWidth: 0.32481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.204 416.68V425.576",
    stroke: "#76736C",
    strokeWidth: 0.32481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.513 417.314V425.574",
    stroke: "#76736C",
    strokeWidth: 0.32481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.222 413.98V412.073H293.221C296.524 412.073 298.2 412.603 298.623 412.869L307.042 416.364L312.443 417.316H316.734C316.841 417.738 316.987 418.745 316.734 419.381C314.191 419.541 308.156 419.222 307.042 418.586C302.085 415.026 297.56 414.032 295.92 413.977H225.219L225.222 413.98Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.513 429.711C248.971 429.711 250.963 427.648 250.963 425.102C250.963 422.557 248.971 420.493 246.513 420.493C244.056 420.493 242.063 422.557 242.063 425.102C242.063 427.648 244.056 429.711 246.513 429.711Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.355 427.167C247.496 427.167 248.421 426.242 248.421 425.101C248.421 423.96 247.496 423.035 246.355 423.035C245.214 423.035 244.289 423.96 244.289 425.101C244.289 426.242 245.214 427.167 246.355 427.167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.446 429.711C297.904 429.711 299.896 427.648 299.896 425.102C299.896 422.557 297.904 420.493 295.446 420.493C292.988 420.493 290.996 422.557 290.996 425.102C290.996 427.648 292.988 429.711 295.446 429.711Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.286 427.167C296.427 427.167 297.352 426.242 297.352 425.101C297.352 423.96 296.427 423.035 295.286 423.035C294.146 423.035 293.221 423.96 293.221 425.101C293.221 426.242 294.146 427.167 295.286 427.167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.86 423.991H257.316V425.261H259.86V423.991Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.251 423.991H269.708V425.261H272.251V423.991Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.328 423.991H281.785V425.261H284.328V423.991Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.934 419.222H304.027V420.492H305.934V419.222Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.934 422.084H304.027V423.354H305.934V422.084Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.221 404.288C225.221 403.586 225.789 403.018 226.491 403.018H307.356C308.726 403.018 310.091 403.229 311.396 403.644L311.494 403.677C312.41 403.969 313.176 404.599 313.641 405.444L314.836 407.62C316.486 410.628 317.204 414.061 316.892 417.478H312.442L307.041 416.526L299.892 413.512C297.897 412.671 295.757 412.239 293.594 412.239H225.218V404.294L225.221 404.288Z",
    fill: "url(#paint6_linear_7001_56018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.117 403.5L313.121 405.77C314.771 409.509 315.622 413.55 315.622 417.636",
    stroke: "white",
    strokeWidth: 0.32481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.998 412.243L300.531 401.846H303.844L290.998 414.614V412.243Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.933 412.871L298.943 401.908L299.353 402.477L288.936 413.439V412.871H288.933Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.693 412.243L277.227 401.846V404.766L267.693 414.617V412.246V412.243Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.628 412.871L275.639 401.908L276.048 402.477L265.631 413.439V412.871H265.628Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.121 412.243L252.654 401.846V404.766L243.121 414.617V412.246V412.243Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.548 403.018V412.625",
    stroke: "white",
    strokeWidth: 0.32481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.838 403.018V413.048",
    stroke: "white",
    strokeWidth: 0.32481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.942 403.018V412.625",
    stroke: "white",
    strokeWidth: 0.32481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.333 403.018V413.048",
    stroke: "white",
    strokeWidth: 0.32481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.407 403.018V412.837",
    stroke: "white",
    strokeWidth: 0.32481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.203 403.018V416.682",
    stroke: "white",
    strokeWidth: 0.32481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.274 409.584V406.303C318.274 406.07 318.082 405.878 317.848 405.878H317.371C316.844 405.878 316.419 406.303 316.419 406.83V409.055C316.419 409.581 316.844 410.01 317.371 410.01H317.848C318.082 410.01 318.274 409.818 318.274 409.584Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.681 426.267C739.986 426.267 740.835 421.643 737.681 418.286C734.527 414.929 729.067 408 725.71 408H700.359C697.731 408 697.432 426.279 698.806 426.279H737.681V426.267Z",
    fill: "#F5DDC0",
    stroke: "#222B54",
    strokeWidth: 0.388163
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.819 425.479C725.819 427.629 727.563 429.373 729.714 429.373C731.864 429.373 733.608 427.629 733.608 425.479C733.608 423.328 731.864 421.584 729.714 421.584C727.563 421.584 725.819 423.328 725.819 425.479Z",
    fill: "#6B6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.896 425.478C727.896 426.482 728.708 427.294 729.711 427.294C730.715 427.294 731.527 426.482 731.527 425.478C731.527 424.474 730.715 423.662 729.711 423.662C728.708 423.662 727.896 424.474 727.896 425.478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.188 425.479C699.188 427.629 700.932 429.373 703.083 429.373C705.233 429.373 706.978 427.629 706.978 425.479C706.978 423.328 705.233 421.584 703.083 421.584C700.932 421.584 699.188 423.328 699.188 425.479Z",
    fill: "#6B6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.267 425.478C701.267 426.482 702.079 427.294 703.083 427.294C704.086 427.294 704.898 426.482 704.898 425.478C704.898 424.474 704.086 423.662 703.083 423.662C702.079 423.662 701.267 424.474 701.267 425.478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.438 418.059C735.507 417.366 732.58 413.507 727.896 409.744C727.622 409.529 727.729 409.003 727.777 408.645C731.026 410.448 735.124 415.55 737.681 418.286C737.896 418.513 736.725 418.286 736.438 418.059Z",
    fill: "url(#paint7_linear_7001_56018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.476 418.058C733.81 418.058 734.109 417.855 734.229 417.556C734.36 417.246 734.276 416.899 734.049 416.66L727.419 410.137C727.168 409.886 726.833 409.755 726.475 409.755H720.908C720.454 409.755 720.096 410.125 720.096 410.567V417.246C720.096 417.7 720.466 418.058 720.908 418.058H733.476Z",
    fill: "url(#paint8_linear_7001_56018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.189 418.058H718.423C718.877 418.058 719.235 417.688 719.235 417.246V410.567C719.235 410.113 718.865 409.755 718.423 409.755H701.04C700.67 409.755 700.359 410.006 700.264 410.352C699.929 411.654 699.189 414.856 699.189 418.07V418.058Z",
    fill: "url(#paint9_linear_7001_56018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.381 397.156C952.665 397.913 957.492 400.567 960.168 401.898L960.233 405.829C960.418 406.059 960.811 406.719 960.857 407.505C960.899 408.151 960.405 409.207 960.022 409.892C959.886 410.136 959.622 410.278 959.343 410.278H919.843C919.391 410.278 919.024 409.915 919.024 409.463V407.677C919.024 406.059 920.782 404.727 921.974 404.266C922.929 403.896 926.173 402.571 928.688 401.954C928.688 401.954 932.511 398.657 938.091 397.211C941.79 396.253 946.12 396.403 949.384 397.153L949.381 397.156Z",
    fill: "#CDD9F4",
    stroke: "#76736C",
    strokeWidth: 0.295577
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M953.73 404.829C950.956 403.903 948.844 405.215 948.139 405.985C947.88 406.112 947.327 406.254 947.175 405.793C948.714 404.059 951.8 403.481 953.726 404.829H953.73Z",
    fill: "url(#paint10_linear_7001_56018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.527 406.949C944.828 408.027 933.365 408.17 928.097 408.105V409.648H960.087C960.347 409.135 960.86 407.991 960.86 407.527C960.86 407.063 960.347 406.179 960.087 405.792C957.775 405.728 952.227 405.87 948.527 406.949Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.063 402.532L960.168 401.837L960.198 404.497L957.005 403.315C956.628 403.172 956.66 402.623 957.06 402.535L957.063 402.532Z",
    fill: "#B7594C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.111 412.302C928.07 412.302 929.657 410.787 929.657 408.918C929.657 407.049 928.07 405.533 926.111 405.533C924.153 405.533 922.565 407.049 922.565 408.918C922.565 410.787 924.153 412.302 926.111 412.302Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.112 410.454C927 410.454 927.72 409.766 927.72 408.917C927.72 408.068 927 407.38 926.112 407.38C925.224 407.38 924.504 408.068 924.504 408.917C924.504 409.766 925.224 410.454 926.112 410.454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.856 412.302C953.815 412.302 955.402 410.787 955.402 408.918C955.402 407.049 953.815 405.533 951.856 405.533C949.898 405.533 948.311 407.049 948.311 408.918C948.311 410.787 949.898 412.302 951.856 412.302Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.854 410.454C952.742 410.454 953.462 409.766 953.462 408.917C953.462 408.068 952.742 407.38 951.854 407.38C950.966 407.38 950.246 408.068 950.246 408.917C950.246 409.766 950.966 410.454 951.854 410.454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.729 402.069C938.919 402.495 931.377 402.069 931.377 402.069C935.457 398.889 939.283 397.928 942.04 397.85C950.066 397.619 952.074 399.99 952.074 399.99C952.074 399.99 947.371 401.553 942.729 402.072V402.069Z",
    fill: "url(#paint11_linear_7001_56018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.662 402.202L944.054 397.661V399.868L942.053 402.202H939.662Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.078 402.258L941.97 397.783H942.943L938.801 402.258H938.078Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.811 403.379C137.131 401.268 139.444 400 141.941 400H151.53C154.016 400 156.33 401.279 157.659 403.379L159.831 406.829H133.66L135.832 403.379H135.811Z",
    fill: "#E4BE82",
    stroke: "#222B54",
    strokeWidth: 0.301026
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.95 413.933C164.468 413.933 164.884 413.517 164.884 413V407.398C164.884 406.799 164.437 406.302 163.849 406.231L157.912 405.541H134.502L128.129 406.038C125.419 406.251 123.278 408.443 123.146 411.163L123.045 413.213C123.045 413.395 123.106 413.578 123.228 413.72C123.359 413.852 123.532 413.933 123.725 413.933H163.95Z",
    fill: "#CFD284",
    stroke: "#222B54",
    strokeWidth: 0.301026
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.948 405.552H145.938V400.447H143.138C139.647 400.447 138.226 403.004 136.938 405.552H136.948Z",
    fill: "url(#paint12_linear_7001_56018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.502 405.552H146.648V400.447H150.312C152.169 400.447 153.904 401.401 154.888 402.974L156.512 405.552H156.502Z",
    fill: "url(#paint13_linear_7001_56018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.812 403.38C136.796 401.817 138.329 400.711 140.064 400.244C140.46 400.335 140.602 400.538 139.841 400.995C137.872 402.152 136.39 405.562 136.39 405.562H134.452L135.822 403.39L135.812 403.38Z",
    fill: "url(#paint14_linear_7001_56018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.479 413.932C153.479 415.759 154.96 417.24 156.787 417.24C158.613 417.24 160.095 415.759 160.095 413.932C160.095 412.106 158.613 410.624 156.787 410.624C154.96 410.624 153.479 412.106 153.479 413.932Z",
    fill: "#6B6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.786 415.476C157.638 415.476 158.328 414.785 158.328 413.933C158.328 413.081 157.638 412.391 156.786 412.391C155.934 412.391 155.243 413.081 155.243 413.933C155.243 414.785 155.934 415.476 156.786 415.476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.236 413.932C127.236 415.759 128.718 417.24 130.544 417.24C132.371 417.24 133.853 415.759 133.853 413.932C133.853 412.106 132.371 410.624 130.544 410.624C128.718 410.624 127.236 412.106 127.236 413.932Z",
    fill: "#6B6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.002 413.933C129.002 414.785 129.692 415.476 130.544 415.476C131.397 415.476 132.087 414.785 132.087 413.933C132.087 413.081 131.397 412.391 130.544 412.391C129.692 412.391 129.002 413.081 129.002 413.933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 413.161H124.75V411.619H122V413.161Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.134 413.161H165.817V411.619H162.134V413.161Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.745 413.706C818.694 412.915 810.581 412.979 807.322 413.023C806.484 413.035 805.69 413.384 805.113 413.987L801.995 417.251C801.995 417.251 793.624 418.353 793.624 419.165V422.262C793.439 422.491 793.052 423.147 793.002 423.926C792.961 424.568 793.451 425.614 793.835 426.297C793.969 426.54 794.23 426.681 794.509 426.681H833.747C834.195 426.681 834.556 426.32 834.556 425.872V420.888C834.556 420.088 832.818 419.739 831.631 419.563C830.442 419.388 827.456 419.027 824.962 418.415C824.962 418.415 823.248 414.096 821.745 413.706Z",
    fill: "#D7D0B3",
    stroke: "#382456",
    strokeWidth: 0.293021
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M800.082 421.272C802.839 420.352 804.932 421.656 805.635 422.421C805.893 422.549 806.438 422.687 806.593 422.23C805.06 420.507 801.998 419.933 800.085 421.272H800.082Z",
    fill: "url(#paint15_linear_7001_56018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.997 422.802C816.741 422.802 831.283 422.802 833.964 423.376V426.057H793.765C793.507 425.547 793 424.41 793 423.95C793 423.49 793.51 422.611 793.765 422.227C796.062 422.163 807.165 422.802 810.991 422.802H810.994H810.997Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.455 419.449L793.691 419.065L793.662 420.941L796.499 420.243C796.932 420.138 796.9 419.511 796.457 419.449H796.455Z",
    fill: "#C86A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.041 428.691C831.088 428.691 832.747 426.997 832.747 424.908C832.747 422.819 831.088 421.125 829.041 421.125C826.994 421.125 825.334 422.819 825.334 424.908C825.334 426.997 826.994 428.691 829.041 428.691Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.041 426.624C829.97 426.624 830.723 425.856 830.723 424.908C830.723 423.96 829.97 423.191 829.041 423.191C828.112 423.191 827.359 423.96 827.359 424.908C827.359 425.856 828.112 426.624 829.041 426.624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.131 428.691C804.178 428.691 805.837 426.997 805.837 424.908C805.837 422.819 804.178 421.125 802.131 421.125C800.083 421.125 798.424 422.819 798.424 424.908C798.424 426.997 800.083 428.691 802.131 428.691Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.131 426.624C803.06 426.624 803.813 425.856 803.813 424.908C803.813 423.96 803.06 423.191 802.131 423.191C801.202 423.191 800.449 423.96 800.449 424.908C800.449 425.856 801.202 426.624 802.131 426.624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.004 418.588H824.279L821.715 414.38L813.484 413.806H806.592L802.956 417.635C802.956 417.635 808.315 418.588 813.007 418.588H813.004Z",
    fill: "url(#paint16_linear_7001_56018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.004 418.588H824.279L821.715 414.38L813.484 413.806H806.592L802.956 417.635C802.956 417.635 808.315 418.588 813.007 418.588H813.004Z",
    fill: "url(#paint17_linear_7001_56018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.264 413.95H813.994V418.794H814.264V413.95Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.205115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.186 418.531L821.252 414.418V416.449L817.884 418.531H816.186Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.249 418.586L819.044 414.166L820.172 414.317L815.132 418.586H814.249Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.095 407.509C870.241 407.509 872.791 410.059 872.791 413.205C872.791 416.351 870.241 418.901 867.095 418.901C863.949 418.901 861.399 416.351 861.399 413.205C861.399 410.059 863.949 407.509 867.095 407.509Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.363261
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.096 409.645H867.572C870.064 409.645 872.08 411.664 872.08 414.153C872.08 416.645 870.06 418.661 867.572 418.661H867.096C864.604 418.661 862.588 416.641 862.588 414.153C862.588 411.661 864.608 409.645 867.096 409.645Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.859 413.915V431.475",
    stroke: "#382456",
    strokeWidth: 0.363261
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.183 414.393L866.859 417.716",
    stroke: "#382456",
    strokeWidth: 0.363261
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.775 414.393L867.099 417.716",
    stroke: "#382456",
    strokeWidth: 0.363261
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.691 407.509C877.837 407.509 880.387 410.059 880.387 413.205C880.387 416.351 877.837 418.901 874.691 418.901C871.545 418.901 868.995 416.351 868.995 413.205C868.995 410.059 871.545 407.509 874.691 407.509Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.363261
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.692 409.645H875.168C877.659 409.645 879.676 411.664 879.676 414.153C879.676 416.645 877.656 418.661 875.168 418.661H874.692C872.2 418.661 870.184 416.641 870.184 414.153C870.184 411.661 872.203 409.645 874.692 409.645Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.455 413.915V431.475",
    stroke: "#382456",
    strokeWidth: 0.363261
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.775 414.393L874.451 417.716",
    stroke: "#382456",
    strokeWidth: 0.363261
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.368 414.393L874.692 417.716",
    stroke: "#382456",
    strokeWidth: 0.363261
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.284 407.509C885.43 407.509 887.98 410.059 887.98 413.205C887.98 416.351 885.43 418.901 882.284 418.901C879.138 418.901 876.588 416.351 876.588 413.205C876.588 410.059 879.138 407.509 882.284 407.509Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.363261
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.283 409.645H882.759C885.251 409.645 887.267 411.664 887.267 414.153C887.267 416.645 885.248 418.661 882.759 418.661H882.283C879.791 418.661 877.775 416.641 877.775 414.153C877.775 411.661 879.795 409.645 882.283 409.645Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.047 413.915V431.475",
    stroke: "#382456",
    strokeWidth: 0.363261
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.371 414.393L882.047 417.716",
    stroke: "#382456",
    strokeWidth: 0.363261
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.963 414.393L882.287 417.716",
    stroke: "#382456",
    strokeWidth: 0.363261
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.257 407.039C968.464 407.039 971.064 409.639 971.064 412.847C971.064 416.054 968.464 418.654 965.257 418.654C962.049 418.654 959.449 416.054 959.449 412.847C959.449 409.639 962.049 407.039 965.257 407.039Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.370384
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.257 409.216H965.742C968.283 409.216 970.338 411.275 970.338 413.812C970.338 416.353 968.279 418.409 965.742 418.409H965.257C962.716 418.409 960.66 416.349 960.66 413.812C960.66 411.271 962.72 409.216 965.257 409.216Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.016 413.571V431.476",
    stroke: "#382456",
    strokeWidth: 0.370384
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.402 414.058L965.013 417.447",
    stroke: "#382456",
    strokeWidth: 0.370384
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.871 414.058L965.26 417.447",
    stroke: "#382456",
    strokeWidth: 0.370384
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.002 407.039C976.209 407.039 978.81 409.639 978.81 412.847C978.81 416.054 976.209 418.654 973.002 418.654C969.794 418.654 967.194 416.054 967.194 412.847C967.194 409.639 969.794 407.039 973.002 407.039Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.370384
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.001 409.216H973.486C976.027 409.216 978.082 411.275 978.082 413.812C978.082 416.353 976.023 418.409 973.486 418.409H973.001C970.46 418.409 968.404 416.349 968.404 413.812C968.404 411.271 970.464 409.216 973.001 409.216Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.757 413.571V431.476",
    stroke: "#382456",
    strokeWidth: 0.370384
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.146 414.058L972.757 417.447",
    stroke: "#382456",
    strokeWidth: 0.370384
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.611 414.058L973 417.447",
    stroke: "#382456",
    strokeWidth: 0.370384
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.742 407.039C983.95 407.039 986.55 409.639 986.55 412.847C986.55 416.054 983.95 418.654 980.742 418.654C977.535 418.654 974.935 416.054 974.935 412.847C974.935 409.639 977.535 407.039 980.742 407.039Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.370384
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.742 409.216H981.227C983.768 409.216 985.824 411.275 985.824 413.812C985.824 416.353 983.764 418.409 981.227 418.409H980.742C978.201 418.409 976.146 416.349 976.146 413.812C976.146 411.271 978.205 409.216 980.742 409.216Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.501 413.571V431.476",
    stroke: "#382456",
    strokeWidth: 0.370384
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.887 414.058L980.498 417.447",
    stroke: "#382456",
    strokeWidth: 0.370384
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.357 414.058L980.746 417.447",
    stroke: "#382456",
    strokeWidth: 0.370384
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.378 408.64C758.376 408.64 760.806 411.069 760.806 414.067C760.806 417.064 758.376 419.494 755.378 419.494C752.381 419.494 749.951 417.064 749.951 414.067C749.951 411.069 752.381 408.64 755.378 408.64Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.346124
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.378 410.675H755.832C758.206 410.675 760.127 412.599 760.127 414.97C760.127 417.345 758.203 419.266 755.832 419.266H755.378C753.004 419.266 751.083 417.341 751.083 414.97C751.083 412.596 753.007 410.675 755.378 410.675Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.149 414.743V431.475",
    stroke: "#382456",
    strokeWidth: 0.346124
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.316 415.199L755.149 418.366",
    stroke: "#382456",
    strokeWidth: 0.346124
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.211 415.199L755.378 418.366",
    stroke: "#382456",
    strokeWidth: 0.346124
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.613 408.64C765.61 408.64 768.04 411.069 768.04 414.067C768.04 417.064 765.61 419.494 762.613 419.494C759.615 419.494 757.186 417.064 757.186 414.067C757.186 411.069 759.615 408.64 762.613 408.64Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.346124
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.612 410.675H763.065C765.44 410.675 767.361 412.599 767.361 414.97C767.361 417.345 765.436 419.266 763.065 419.266H762.612C760.237 419.266 758.316 417.341 758.316 414.97C758.316 412.596 760.241 410.675 762.612 410.675Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.387 414.743V431.475",
    stroke: "#382456",
    strokeWidth: 0.346124
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.555 415.199L762.388 418.366",
    stroke: "#382456",
    strokeWidth: 0.346124
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.448 415.199L762.615 418.366",
    stroke: "#382456",
    strokeWidth: 0.346124
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.85 408.64C772.847 408.64 775.277 411.069 775.277 414.067C775.277 417.064 772.847 419.494 769.85 419.494C766.853 419.494 764.423 417.064 764.423 414.067C764.423 411.069 766.853 408.64 769.85 408.64Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.346124
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.849 410.675H770.303C772.677 410.675 774.598 412.599 774.598 414.97C774.598 417.345 772.673 419.266 770.303 419.266H769.849C767.475 419.266 765.554 417.341 765.554 414.97C765.554 412.596 767.478 410.675 769.849 410.675Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.788 415.199L769.621 418.366",
    stroke: "#382456",
    strokeWidth: 0.346124
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.683 415.199L769.85 418.366",
    stroke: "#382456",
    strokeWidth: 0.346124
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.621 414.743V431.475",
    stroke: "#382456",
    strokeWidth: 0.346124
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8738 408.64C82.1476 408.64 84.8015 411.293 84.8015 414.567C84.8015 417.841 82.1476 420.495 78.8738 420.495C75.6001 420.495 72.9463 417.841 72.9463 414.567C72.9463 411.293 75.6001 408.64 78.8738 408.64Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.378035
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.874 410.862H79.3693C81.9626 410.862 84.0607 412.964 84.0607 415.554C84.0607 418.147 81.9588 420.245 79.3693 420.245H78.874C76.2807 420.245 74.1826 418.143 74.1826 415.554C74.1826 412.96 76.2845 410.862 78.874 410.862Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.624 415.306V433.58",
    stroke: "#382456",
    strokeWidth: 0.378035
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.084 415.804L78.625 419.263",
    stroke: "#382456",
    strokeWidth: 0.378035
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.415 415.804L78.8741 419.263",
    stroke: "#382456",
    strokeWidth: 0.378035
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7753 408.64C90.049 408.64 92.7029 411.293 92.7029 414.567C92.7029 417.841 90.049 420.495 86.7753 420.495C83.5015 420.495 80.8477 417.841 80.8477 414.567C80.8477 411.293 83.5015 408.64 86.7753 408.64Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.378035
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7744 410.862H87.2697C89.863 410.862 91.9611 412.964 91.9611 415.554C91.9611 418.147 89.8592 420.245 87.2697 420.245H86.7744C84.1811 420.245 82.083 418.143 82.083 415.554C82.083 412.96 84.1849 410.862 86.7744 410.862Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5283 415.306V433.58",
    stroke: "#382456",
    strokeWidth: 0.378035
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9834 415.804L86.5244 419.263",
    stroke: "#382456",
    strokeWidth: 0.378035
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3164 415.804L86.7754 419.263",
    stroke: "#382456",
    strokeWidth: 0.378035
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6796 408.64C97.9533 408.64 100.607 411.293 100.607 414.567C100.607 417.841 97.9533 420.495 94.6796 420.495C91.4058 420.495 88.752 417.841 88.752 414.567C88.752 411.293 91.4058 408.64 94.6796 408.64Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.378035
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6787 410.862H95.1739C97.7672 410.862 99.8654 412.964 99.8654 415.554C99.8654 418.147 97.7635 420.245 95.1739 420.245H94.6787C92.0854 420.245 89.9873 418.143 89.9873 415.554C89.9873 412.96 92.0892 410.862 94.6787 410.862Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4297 415.306V433.58",
    stroke: "#382456",
    strokeWidth: 0.378035
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8887 415.804L94.4297 419.263",
    stroke: "#382456",
    strokeWidth: 0.378035
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2207 415.804L94.6797 419.263",
    stroke: "#382456",
    strokeWidth: 0.378035
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.099 408.64C200.279 408.64 202.856 411.217 202.856 414.396C202.856 417.576 200.279 420.153 197.099 420.153C193.92 420.153 191.343 417.576 191.343 414.396C191.343 411.217 193.92 408.64 197.099 408.64Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.367128
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.099 410.799H197.58C200.098 410.799 202.136 412.84 202.136 415.355C202.136 417.873 200.095 419.911 197.58 419.911H197.099C194.58 419.911 192.543 417.87 192.543 415.355C192.543 412.836 194.584 410.799 197.099 410.799Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.86 415.114V432.861",
    stroke: "#382456",
    strokeWidth: 0.367128
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.216 415.597L196.856 418.956",
    stroke: "#382456",
    strokeWidth: 0.367128
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.74 415.597L197.099 418.956",
    stroke: "#382456",
    strokeWidth: 0.367128
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.772 408.64C207.952 408.64 210.529 411.217 210.529 414.396C210.529 417.576 207.952 420.153 204.772 420.153C201.593 420.153 199.016 417.576 199.016 414.396C199.016 411.217 201.593 408.64 204.772 408.64Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.367128
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.772 410.799H205.253C207.771 410.799 209.809 412.84 209.809 415.355C209.809 417.873 207.768 419.911 205.253 419.911H204.772C202.253 419.911 200.216 417.87 200.216 415.355C200.216 412.836 202.257 410.799 204.772 410.799Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.533 415.114V432.861",
    stroke: "#382456",
    strokeWidth: 0.367128
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.892 415.597L204.533 418.956",
    stroke: "#382456",
    strokeWidth: 0.367128
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.416 415.597L204.775 418.956",
    stroke: "#382456",
    strokeWidth: 0.367128
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.449 408.64C215.628 408.64 218.205 411.217 218.205 414.396C218.205 417.576 215.628 420.153 212.449 420.153C209.27 420.153 206.692 417.576 206.692 414.396C206.692 411.217 209.27 408.64 212.449 408.64Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.367128
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.449 410.799H212.93C215.448 410.799 217.486 412.84 217.486 415.355C217.486 417.873 215.444 419.911 212.93 419.911H212.449C209.93 419.911 207.893 417.87 207.893 415.355C207.893 412.836 209.934 410.799 212.449 410.799Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.206 415.114V432.861",
    stroke: "#382456",
    strokeWidth: 0.367128
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.565 415.597L212.206 418.956",
    stroke: "#382456",
    strokeWidth: 0.367128
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.09 415.597L212.449 418.956",
    stroke: "#382456",
    strokeWidth: 0.367128
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.776 397.984C176.195 397.984 176.536 398.325 176.536 398.745V402.807H178.186C178.492 402.807 178.736 403.055 178.736 403.358C178.736 403.661 178.489 403.909 178.186 403.909H176.536V431.773C176.536 432.193 176.195 432.534 175.776 432.534H175.464C175.044 432.534 174.703 432.193 174.703 431.773V403.909H173.095C172.789 403.909 172.544 403.661 172.544 403.358C172.544 403.055 172.792 402.807 173.095 402.807H174.703V398.745C174.703 398.325 175.044 397.984 175.464 397.984H175.776Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.093 398.024H174.187C173.882 398.024 173.637 398.272 173.637 398.575C173.637 398.881 173.884 399.126 174.187 399.126H177.093C177.399 399.126 177.644 398.878 177.644 398.575C177.644 398.269 177.396 398.024 177.093 398.024Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.882 386.989H174.393C173.973 386.989 173.633 387.33 173.633 387.75V389.172C173.633 389.592 173.973 389.932 174.393 389.932H176.882C177.302 389.932 177.643 389.592 177.643 389.172V387.75C177.643 387.33 177.302 386.989 176.882 386.989Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.001 398.394L171.268 392.324L175.822 390.485V398.394H174.001Z",
    fill: "#FFFDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.63 390.765L171.521 392.423L174.124 398.198H175.633V390.762L175.63 390.765Z",
    stroke: "#615E66",
    strokeWidth: 0.291408,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.822 390.853V387.727H174.613C174.114 387.727 173.648 387.971 173.362 388.382L170.233 392.893C170.16 392.998 170.268 393.132 170.384 393.083L175.819 390.853H175.822Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.279 398.394L180.013 392.324L175.458 390.485V398.394H177.279Z",
    fill: "#FFFDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.647 390.765L179.756 392.423L177.154 398.198H175.645V390.762L175.647 390.765Z",
    stroke: "#615E66",
    strokeWidth: 0.291408,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.457 390.853V387.727H176.666C177.165 387.727 177.631 387.971 177.917 388.382L181.046 392.893C181.119 392.998 181.011 393.132 180.895 393.083L175.46 390.853H175.457Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.593 430.219H173.682C173.051 430.219 172.54 430.73 172.54 431.361V433.226C172.54 433.857 173.051 434.368 173.682 434.368H177.593C178.224 434.368 178.735 433.857 178.735 433.226V431.361C178.735 430.73 178.224 430.219 177.593 430.219Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.439 398.911C560.858 398.911 561.199 399.252 561.199 399.672V403.734H562.849C563.155 403.734 563.399 403.982 563.399 404.285C563.399 404.588 563.152 404.835 562.849 404.835H561.199V432.7C561.199 433.119 560.855 433.46 560.439 433.46H560.127C559.707 433.46 559.366 433.119 559.366 432.7V404.835H557.761C557.455 404.835 557.21 404.588 557.21 404.285C557.21 403.982 557.458 403.734 557.761 403.734H559.366V399.672C559.366 399.252 559.71 398.911 560.127 398.911H560.439Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.757 398.951H558.852C558.546 398.951 558.301 399.199 558.301 399.502C558.301 399.808 558.548 400.053 558.852 400.053H561.757C562.063 400.053 562.308 399.805 562.308 399.502C562.308 399.196 562.06 398.951 561.757 398.951Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.55 387.916H559.061C558.641 387.916 558.301 388.257 558.301 388.677V390.099C558.301 390.519 558.641 390.859 559.061 390.859H561.55C561.97 390.859 562.311 390.519 562.311 390.099V388.677C562.311 388.257 561.97 387.916 561.55 387.916Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.665 399.319L555.932 393.249L560.486 391.41V399.319H558.665Z",
    fill: "#FFFDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.296 391.689L556.188 393.348L558.787 399.123H560.293V391.687L560.296 391.689Z",
    stroke: "#615E66",
    strokeWidth: 0.291408,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.486 391.78V388.653H559.28C558.781 388.653 558.312 388.898 558.029 389.309L554.9 393.82C554.827 393.925 554.935 394.059 555.051 394.009L560.483 391.78H560.486Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.944 399.319L564.678 393.249L560.123 391.41V399.319H561.944Z",
    fill: "#FFFDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.314 391.689L564.423 393.348L561.824 399.123H560.317V391.687L560.314 391.689Z",
    stroke: "#615E66",
    strokeWidth: 0.291408,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.125 391.78V388.653H561.331C561.83 388.653 562.296 388.898 562.582 389.309L565.711 393.82C565.784 393.925 565.673 394.059 565.56 394.009L560.128 391.78H560.125Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.261 431.146H558.35C557.719 431.146 557.208 431.657 557.208 432.288V434.153C557.208 434.784 557.719 435.295 558.35 435.295H562.261C562.892 435.295 563.403 434.784 563.403 434.153V432.288C563.403 431.657 562.892 431.146 562.261 431.146Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M902.874 398.15C903.294 398.15 903.635 398.491 903.635 398.911V402.973H905.284C905.59 402.973 905.835 403.221 905.835 403.524C905.835 403.827 905.587 404.075 905.284 404.075H903.635V431.939C903.635 432.359 903.291 432.7 902.874 432.7H902.563C902.143 432.7 901.802 432.359 901.802 431.939V404.075H900.196C899.893 404.075 899.646 403.827 899.646 403.524C899.646 403.221 899.893 402.973 900.196 402.973H901.802V398.911C901.802 398.491 902.146 398.15 902.563 398.15H902.874Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.191 398.191H901.286C900.98 398.191 900.735 398.439 900.735 398.742C900.735 399.048 900.983 399.293 901.286 399.293H904.191C904.497 399.293 904.742 399.045 904.742 398.742C904.742 398.436 904.495 398.191 904.191 398.191Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.985 387.154H901.496C901.076 387.154 900.735 387.495 900.735 387.915V389.337C900.735 389.757 901.076 390.098 901.496 390.098H903.985C904.405 390.098 904.745 389.757 904.745 389.337V387.915C904.745 387.495 904.405 387.154 903.985 387.154Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.1 398.56L898.366 392.49L902.921 390.651V398.56H901.1Z",
    fill: "#FFFDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.728 390.931L898.619 392.589L901.218 398.364H902.725V390.928L902.728 390.931Z",
    stroke: "#615E66",
    strokeWidth: 0.291408,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.921 391.019V387.893H901.714C901.216 387.893 900.747 388.137 900.464 388.548L897.334 393.059C897.261 393.164 897.369 393.298 897.486 393.249L902.918 391.019H902.921Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.378 398.56L907.111 392.49L902.557 390.651V398.56H904.378Z",
    fill: "#FFFDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.749 390.931L906.858 392.589L904.259 398.364H902.752V390.928L902.749 390.931Z",
    stroke: "#615E66",
    strokeWidth: 0.291408,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.557 391.02V387.894H903.763C904.261 387.894 904.728 388.138 905.013 388.549L908.143 393.06C908.216 393.165 908.105 393.299 907.991 393.25L902.56 391.02H902.557Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.696 430.384H900.785C900.154 430.384 899.643 430.895 899.643 431.526V433.391C899.643 434.022 900.154 434.533 900.785 434.533H904.696C905.326 434.533 905.838 434.022 905.838 433.391V431.526C905.838 430.895 905.326 430.384 904.696 430.384Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.641 460.923C934.078 460.923 933.615 461.379 933.615 461.948V478.341C933.615 478.903 934.072 479.366 934.641 479.366C935.203 479.366 935.666 478.909 935.666 478.341V461.948C935.666 461.385 935.21 460.923 934.641 460.923Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.786 462.284H933.615V469.111H898.786V462.284Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.786 467.066H933.615V467.748H898.786V467.066Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.786 464.339H933.615V465.02H898.786V464.339Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.838 461.948C900.838 461.379 900.381 460.923 899.819 460.923C899.256 460.923 898.787 461.379 898.787 461.948V478.341C898.787 478.903 899.244 479.366 899.819 479.366C900.394 479.366 900.838 478.909 900.838 478.341V461.948Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.176 472.529C928.613 472.529 928.151 472.986 928.151 473.555V479.7C928.151 480.263 928.607 480.725 929.176 480.725C929.739 480.725 930.201 480.269 930.201 479.7V473.555C930.201 472.992 929.745 472.529 929.176 472.529Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.034 472.529C894.472 472.529 894.009 472.986 894.009 473.555V479.7C894.009 480.263 894.465 480.725 895.034 480.725C895.597 480.725 896.06 480.269 896.06 479.7V473.555C896.06 472.992 895.603 472.529 895.034 472.529Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.615 472.533L935.666 470.826H898.786L894.01 472.533V474.584H930.202L933.615 472.533Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.003 472.529H930.201V474.58H894.003V472.529Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.666 470.826L930.202 472.533V475.265L935.666 472.877V470.826Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5949 333.672H-60.3496V444.996H97.5949V333.672Z",
    fill: "#F9E3E1",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5949 419.29H-60.3496V444.997H97.5949V419.29Z",
    fill: "#D7C7A3",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17207 424.305H-6.49805V444.997H6.17207V424.305Z",
    fill: "#6B6770",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7512 424.305H12.0811V444.997H24.7512V424.305Z",
    fill: "#6B6770",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7639 424.305H28.0938V444.997H40.7639V424.305Z",
    fill: "#6B6770",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2077 428.324C44.2077 424.198 48.1636 420.854 53.046 420.854C57.9284 420.854 61.8843 424.198 61.8843 428.324V444.995H44.1973V428.324H44.2077Z",
    fill: "#6B6770",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.555 424.305H64.8848V444.997H77.555V424.305Z",
    fill: "#6B6770",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0111 424.305H81.3408V444.997H94.0111V424.305Z",
    fill: "#6B6770",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17207 427.755H-6.49805V444.998H6.17207V427.755Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7512 427.755H12.0811V444.998H24.7512V427.755Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7639 427.755H28.0938V444.998H40.7639V427.755Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2077 431.774C44.2077 427.648 48.1636 424.305 53.046 424.305C57.9284 424.305 61.8843 427.648 61.8843 431.774V444.997H44.1973V431.774H44.2077Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.555 427.755H64.8848V444.998H77.555V427.755Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0111 427.755H81.3408V444.998H94.0111V427.755Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.409076 384.668H-4.95605V395.017H0.409076V384.668Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.409076 405.366H-4.95605V415.715H0.409076V405.366Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6923 384.668H5.32715V395.017H10.6923V384.668Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6913 405.366H5.32617V415.715H10.6913V405.366Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9755 384.668H15.6104V395.017H20.9755V384.668Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9755 405.366H15.6104V415.715H20.9755V405.366Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2587 384.668H25.8936V395.017H31.2587V384.668Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2587 405.366H25.8936V415.715H31.2587V405.366Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5419 384.668H36.1768V395.017H41.5419V384.668Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5409 405.366H36.1758V415.715H41.5409V405.366Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8241 384.668H46.459V395.017H51.8241V384.668Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8241 405.366H46.459V415.715H51.8241V405.366Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1083 384.668H56.7432V395.017H62.1083V384.668Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1073 405.366H56.7422V415.715H62.1073V405.366Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3905 384.668H67.0254V395.017H72.3905V384.668Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3905 405.366H67.0254V415.715H72.3905V405.366Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6737 384.668H77.3086V395.017H82.6737V384.668Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6737 405.366H77.3086V415.715H82.6737V405.366Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9569 384.668H87.5918V395.017H92.9569V384.668Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9569 405.366H87.5918V415.715H92.9569V405.366Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.409076 341.718H-4.95605V352.067H0.409076V341.718Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.409076 362.416H-4.95605V372.765H0.409076V362.416Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6923 341.718H5.32715V352.067H10.6923V341.718Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6913 362.416H5.32617V372.765H10.6913V362.416Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9755 341.718H15.6104V352.067H20.9755V341.718Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9755 362.416H15.6104V372.765H20.9755V362.416Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2587 341.718H25.8936V352.067H31.2587V341.718Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2587 362.416H25.8936V372.765H31.2587V362.416Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5419 341.718H36.1768V352.067H41.5419V341.718Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5419 362.416H36.1768V372.765H41.5419V362.416Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8241 341.718H46.459V352.067H51.8241V341.718Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8241 362.416H46.459V372.765H51.8241V362.416Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1083 341.718H56.7432V352.067H62.1083V341.718Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1083 362.416H56.7432V372.765H62.1083V362.416Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3915 341.718H67.0264V352.067H72.3915V341.718Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3915 362.416H67.0264V372.765H72.3915V362.416Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6737 341.718H77.3086V352.067H82.6737V341.718Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6737 362.416H77.3086V372.765H82.6737V362.416Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9569 341.718H87.5918V352.067H92.9569V341.718Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9569 362.416H87.5918V372.765H92.9569V362.416Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.235 333.312H-64.999V335.847H102.235V333.312Z",
    fill: "#6B6770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.122 328H-62.8838V333.068H100.122V328Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8183 329.574H0.460938V331.261H14.8183V329.574Z",
    fill: "#CDD9F4",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0898 329.463H20.7324V331.15H35.0898V329.463Z",
    fill: "#CDD9F4",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3554 329.463H40.998V331.15H55.3554V329.463Z",
    fill: "#CDD9F4",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6281 329.463H61.2705V331.15H75.6281V329.463Z",
    fill: "#CDD9F4",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9013 329.463H81.5439V331.15H95.9013V329.463Z",
    fill: "#CDD9F4",
    stroke: "#6B6770",
    strokeWidth: 0.646439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6964 424.053L74.1307 424.168L74.2236 424.632H74.6964V424.053ZM77.0655 424.053H77.6445V423.474H77.0655V424.053ZM77.0655 426.939V427.518H77.6445V426.939H77.0655ZM65.5164 426.939H64.9375V427.518H65.5164V426.939ZM65.5164 424.053V423.474H64.9375V424.053H65.5164ZM67.8855 424.053V424.632H68.3585L68.4513 424.168L67.8855 424.053ZM74.6964 424.632H76.4909H77.0655V423.479H74.6964V424.632ZM76.4909 424.053V424.632V426.36V426.939H77.6445V424.053H76.4909ZM77.0655 426.36H76.4909H66.0954H65.5164V427.514H77.0655V426.36ZM66.0954 426.939V426.36V424.632V424.053H64.9419V426.939H66.0954ZM65.5164 424.632H66.0954H67.8855V423.479H65.5164V424.632ZM68.4513 424.168C68.6634 423.116 69.6004 422.321 70.7142 422.321V421.167C69.039 421.167 67.6424 422.356 67.3197 423.938L68.4513 424.168ZM70.7142 422.321H71.8678V421.167H70.7142V422.321ZM71.8678 422.321C72.9816 422.321 73.9185 423.116 74.1307 424.168L75.2622 423.938C74.9395 422.356 73.5429 421.167 71.8678 421.167V422.321Z",
    fill: "#6B6770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2236 424.632L74.1307 424.168C73.9185 423.116 72.9816 422.321 71.8678 422.321H70.7142C69.6004 422.321 68.6634 423.116 68.4513 424.168L68.3585 424.632H67.8855H66.0954V426.36H76.4909V424.632H74.6964H74.2236Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9396 424.053L21.3738 424.168L21.4668 424.632H21.9396V424.053ZM24.3087 424.053H24.8877V423.474H24.3087V424.053ZM24.3087 426.939V427.518H24.8877V426.939H24.3087ZM12.7596 426.939H12.1807V427.518H12.7596V426.939ZM12.7596 424.053V423.474H12.1807V424.053H12.7596ZM15.1287 424.053V424.632H15.6016L15.6944 424.168L15.1287 424.053ZM21.9396 424.632H23.7341H24.3087V423.479H21.9396V424.632ZM23.7341 424.053V424.632V426.36V426.939H24.8877V424.053H23.7341ZM24.3087 426.36H23.7341H13.3386H12.7596V427.514H24.3087V426.36ZM13.3386 426.939V426.36V424.632V424.053H12.1851V426.939H13.3386ZM12.7596 424.632H13.3386H15.1287V423.479H12.7596V424.632ZM15.6944 424.168C15.9066 423.116 16.8435 422.321 17.9573 422.321V421.167C16.2822 421.167 14.8856 422.356 14.5629 423.938L15.6944 424.168ZM17.9573 422.321H19.1109V421.167H17.9573V422.321ZM19.1109 422.321C20.2247 422.321 21.1617 423.116 21.3738 424.168L22.5053 423.938C22.1827 422.356 20.7861 421.167 19.1109 421.167V422.321Z",
    fill: "#6B6770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4668 424.632L21.3738 424.168C21.1617 423.116 20.2247 422.321 19.1109 422.321H17.9573C16.8435 422.321 15.9066 423.116 15.6944 424.168L15.6016 424.632H15.1287H13.3386V426.36H23.7341V424.632H21.9396H21.4668Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2384 424.053L90.6727 424.168L90.7656 424.632H91.2384V424.053ZM93.6075 424.053H94.1865V423.474H93.6075V424.053ZM93.6075 426.939V427.518H94.1865V426.939H93.6075ZM82.0584 426.939H81.4795V427.518H82.0584V426.939ZM82.0584 424.053V423.474H81.4795V424.053H82.0584ZM84.4275 424.053V424.632H84.9004L84.9932 424.168L84.4275 424.053ZM91.2384 424.632H93.0329H93.6075V423.479H91.2384V424.632ZM93.0329 424.053V424.632V426.36V426.939H94.1865V424.053H93.0329ZM93.6075 426.36H93.0329H82.6374H82.0584V427.514H93.6075V426.36ZM82.6374 426.939V426.36V424.632V424.053H81.4839V426.939H82.6374ZM82.0584 424.632H82.6374H84.4275V423.479H82.0584V424.632ZM84.9932 424.168C85.2054 423.116 86.1423 422.321 87.2561 422.321V421.167C85.581 421.167 84.1844 422.356 83.8617 423.938L84.9932 424.168ZM87.2561 422.321H88.4098V421.167H87.2561V422.321ZM88.4098 422.321C89.5236 422.321 90.4605 423.116 90.6727 424.168L91.8042 423.938C91.4815 422.356 90.0849 421.167 88.4098 421.167V422.321Z",
    fill: "#6B6770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7656 424.632L90.6727 424.168C90.4605 423.116 89.5236 422.321 88.4098 422.321H87.2561C86.1423 422.321 85.2054 423.116 84.9932 424.168L84.9004 424.632H84.4275H82.6374V426.36H93.0329V424.632H91.2384H90.7656Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4816 424.053L37.9158 424.168L38.0087 424.632H38.4816V424.053ZM40.8507 424.053H41.4297V423.474H40.8507V424.053ZM40.8507 426.939V427.518H41.4297V426.939H40.8507ZM29.3016 426.939H28.7227V427.518H29.3016V426.939ZM29.3016 424.053V423.474H28.7227V424.053H29.3016ZM31.6707 424.053V424.632H32.1436L32.2364 424.168L31.6707 424.053ZM38.4816 424.632H40.2761H40.8507V423.479H38.4816V424.632ZM40.2761 424.053V424.632V426.36V426.939H41.4297V424.053H40.2761ZM40.8507 426.36H40.2761H29.8806H29.3016V427.514H40.8507V426.36ZM29.8806 426.939V426.36V424.632V424.053H28.7271V426.939H29.8806ZM29.3016 424.632H29.8806H31.6707V423.479H29.3016V424.632ZM32.2364 424.168C32.4486 423.116 33.3855 422.321 34.4993 422.321V421.167C32.8242 421.167 31.4276 422.356 31.1049 423.938L32.2364 424.168ZM34.4993 422.321H35.6529V421.167H34.4993V422.321ZM35.6529 422.321C36.7667 422.321 37.7037 423.116 37.9158 424.168L39.0473 423.938C38.7247 422.356 37.3281 421.167 35.6529 421.167V422.321Z",
    fill: "#6B6770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0087 424.632L37.9158 424.168C37.7037 423.116 36.7667 422.321 35.6529 422.321H34.4993C33.3855 422.321 32.4486 423.116 32.2364 424.168L32.1436 424.632H31.6707H29.8806V426.36H40.2761V424.632H38.4816H38.0087Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2822 441.701C75.4803 441.793 75.017 442.194 74.752 442.57C74.6188 442.76 74.5353 442.944 74.4854 443.08C74.4605 443.148 74.4438 443.204 74.4336 443.242C74.4285 443.261 74.4251 443.276 74.4229 443.286C74.4218 443.291 74.4204 443.295 74.4199 443.297V443.3L74.3896 443.46L74.2686 443.351L74.2676 443.35C74.2668 443.349 74.2653 443.348 74.2637 443.347C74.2601 443.344 74.2552 443.338 74.248 443.332C74.2337 443.32 74.2118 443.303 74.1846 443.282C74.1299 443.241 74.0521 443.187 73.96 443.136C73.7722 443.032 73.5398 442.951 73.3242 442.995C73.2396 443.013 73.1872 443.067 73.1553 443.156C73.1218 443.25 73.1144 443.374 73.123 443.504C73.1316 443.632 73.1552 443.759 73.1768 443.854C73.1875 443.902 73.1976 443.941 73.2051 443.969C73.2088 443.982 73.2118 443.993 73.2139 444C73.2148 444.003 73.2153 444.006 73.2158 444.008L73.2168 444.01V444.011L73.0547 444.089L73.0537 444.088L73.0518 444.085C73.0501 444.083 73.0481 444.079 73.0449 444.074C73.0384 444.065 73.0282 444.051 73.0156 444.033C72.9904 443.998 72.9534 443.946 72.9072 443.885C72.8148 443.762 72.6856 443.598 72.5381 443.435C72.3901 443.27 72.2252 443.108 72.0625 442.987C71.8972 442.865 71.7466 442.794 71.624 442.792C71.5626 442.791 71.5211 442.805 71.4922 442.823C71.4633 442.842 71.4404 442.87 71.4229 442.91C71.3861 442.994 71.379 443.116 71.3926 443.254C71.4059 443.389 71.438 443.526 71.4668 443.63C71.4812 443.682 71.4941 443.726 71.5039 443.756C71.5088 443.771 71.5129 443.782 71.5156 443.79C71.517 443.794 71.5179 443.797 71.5186 443.799L71.5195 443.801V443.802L71.3516 443.871H71.3506C71.3504 443.871 71.3501 443.869 71.3496 443.868C71.3486 443.866 71.3469 443.863 71.3447 443.858C71.3399 443.849 71.3326 443.834 71.3223 443.815C71.3016 443.778 71.2694 443.724 71.2246 443.658C71.1349 443.526 70.9942 443.346 70.792 443.157C70.3882 442.781 69.7372 442.37 68.75 442.24C68.2562 442.175 67.9462 442.239 67.7549 442.354C67.5674 442.466 67.4799 442.637 67.4473 442.824C67.4143 443.014 67.4388 443.216 67.4736 443.373C67.4909 443.451 67.5104 443.517 67.5254 443.562C67.5329 443.585 67.5395 443.604 67.5439 443.616C67.546 443.622 67.5477 443.626 67.5488 443.629C67.5494 443.63 67.5495 443.632 67.5498 443.633H67.5508L67.6602 443.904L67.416 443.743H67.415L67.4141 443.742C67.4127 443.741 67.4101 443.74 67.4072 443.738C67.4015 443.735 67.393 443.729 67.3818 443.722C67.3594 443.708 67.3261 443.688 67.2852 443.665C67.203 443.618 67.0891 443.557 66.9609 443.501C66.8324 443.445 66.6919 443.395 66.5566 443.367C66.4544 443.347 66.3592 443.339 66.2764 443.351L66.1973 443.368C66.1579 443.381 66.1413 443.399 66.1328 443.417C66.1228 443.438 66.1185 443.472 66.126 443.522C66.1414 443.625 66.2025 443.759 66.2852 443.899C66.3665 444.037 66.4623 444.172 66.5391 444.272C66.5773 444.323 66.6113 444.364 66.6348 444.393C66.6463 444.407 66.6558 444.418 66.6621 444.426C66.665 444.429 66.6674 444.432 66.6689 444.434C66.6697 444.434 66.6705 444.435 66.6709 444.436V444.437L66.5635 444.579L66.5625 444.578L66.5605 444.577C66.5586 444.576 66.5556 444.575 66.5518 444.573C66.5435 444.57 66.5308 444.564 66.5146 444.557C66.4822 444.543 66.4343 444.523 66.375 444.5C66.256 444.454 66.0897 444.393 65.9014 444.341C65.5197 444.234 65.0658 444.163 64.7246 444.267C64.6494 444.29 64.6173 444.322 64.6035 444.351C64.5886 444.382 64.5854 444.429 64.6035 444.496C64.6405 444.634 64.7546 444.811 64.9023 444.992C65.0477 445.171 65.2165 445.343 65.3496 445.472C65.4159 445.536 65.4731 445.588 65.5137 445.625C65.529 445.639 65.5426 445.65 65.5527 445.659H84.6973C84.7029 445.654 84.7097 445.648 84.7168 445.642C84.7468 445.614 84.7899 445.572 84.8418 445.52C84.9458 445.414 85.0849 445.262 85.2246 445.08C85.5067 444.712 85.7809 444.231 85.7959 443.75C85.7995 443.633 85.7802 443.556 85.752 443.505C85.7249 443.456 85.686 443.426 85.6357 443.409C85.5268 443.372 85.3631 443.394 85.1758 443.457C84.9934 443.518 84.8082 443.611 84.667 443.689C84.5967 443.728 84.538 443.764 84.4971 443.789C84.4766 443.802 84.46 443.811 84.4492 443.818L84.4346 443.828L84.4336 443.829L84.3037 443.707H84.3047C84.305 443.707 84.305 443.705 84.3057 443.704C84.3071 443.702 84.3098 443.698 84.3125 443.692C84.318 443.682 84.3257 443.666 84.334 443.646C84.3507 443.608 84.3686 443.556 84.377 443.505C84.3853 443.453 84.3824 443.407 84.3672 443.373C84.3536 443.343 84.3259 443.309 84.2607 443.288L84.2598 443.289C84.205 443.272 84.1173 443.284 84 443.334C83.8869 443.383 83.7633 443.458 83.6475 443.54C83.5322 443.621 83.4269 443.707 83.3506 443.772C83.3127 443.805 83.2819 443.832 83.2607 443.851C83.2501 443.86 83.2418 443.868 83.2363 443.873C83.2337 443.876 83.2318 443.878 83.2305 443.879L83.2285 443.88V443.881L83.0771 444.022L83.0752 443.815V443.814L83.0742 443.811C83.0741 443.807 83.0744 443.802 83.0742 443.796C83.0737 443.783 83.0729 443.763 83.0713 443.737C83.068 443.686 83.0616 443.612 83.0498 443.523C83.0261 443.345 82.9796 443.107 82.8906 442.864C82.7232 442.408 82.4118 441.952 81.8242 441.829L81.7031 441.81C81.0147 441.724 80.5814 441.934 80.3203 442.157C80.1886 442.27 80.0985 442.388 80.042 442.478C80.0139 442.522 79.994 442.559 79.9814 442.585C79.9752 442.598 79.9706 442.608 79.9678 442.614C79.9664 442.617 79.9654 442.62 79.9648 442.621V442.622L79.876 442.851L79.7939 442.62L79.793 442.619C79.7925 442.618 79.792 442.616 79.791 442.613C79.7891 442.608 79.7862 442.601 79.7822 442.591C79.7741 442.571 79.7615 442.542 79.7451 442.507C79.7122 442.437 79.6629 442.344 79.5986 442.252C79.483 442.086 79.3309 441.939 79.1465 441.9L79.0654 441.892C78.9498 441.889 78.8766 441.918 78.8291 441.955C78.7804 441.994 78.7495 442.048 78.7305 442.108C78.7113 442.169 78.7064 442.232 78.7061 442.281C78.7059 442.306 78.7069 442.326 78.708 442.34C78.7085 442.346 78.7086 442.351 78.709 442.354C78.7092 442.356 78.7099 442.358 78.71 442.358L78.5449 442.425L78.5439 442.424C78.543 442.423 78.5413 442.42 78.5391 442.417C78.5344 442.411 78.5274 442.402 78.5176 442.391C78.4975 442.367 78.4664 442.333 78.4238 442.292C78.3384 442.21 78.2064 442.102 78.0244 441.999C77.6616 441.794 77.0941 441.608 76.2822 441.701Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.18247
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7725 441.7C94.0837 441.791 93.6832 442.188 93.4521 442.565C93.3363 442.755 93.2634 442.939 93.2197 443.076C93.198 443.144 93.1837 443.201 93.1748 443.239C93.1704 443.258 93.167 443.273 93.165 443.283C93.1641 443.288 93.1635 443.293 93.1631 443.295L93.1621 443.297V443.298L93.1328 443.479L93.0068 443.346H93.0059C93.0052 443.345 93.0044 443.343 93.0029 443.342C92.9999 443.339 92.9945 443.334 92.9883 443.328C92.9759 443.316 92.9579 443.299 92.9346 443.278C92.8873 443.237 92.8196 443.183 92.7402 443.133C92.5774 443.029 92.3823 442.952 92.2041 442.994C92.1396 443.009 92.0937 443.059 92.0645 443.152C92.0347 443.248 92.0276 443.374 92.0352 443.505C92.0426 443.634 92.0632 443.762 92.082 443.857C92.0914 443.905 92.1009 443.944 92.1074 443.972C92.1106 443.985 92.1124 443.996 92.1143 444.003C92.1152 444.006 92.1167 444.01 92.1172 444.012V444.014L91.9502 444.084V444.083L91.9482 444.08C91.9468 444.078 91.9451 444.074 91.9424 444.069C91.9367 444.06 91.928 444.046 91.917 444.028C91.895 443.993 91.8633 443.941 91.8232 443.88C91.7429 443.757 91.6302 443.593 91.502 443.43C91.3733 443.265 91.2306 443.104 91.0898 442.983C90.9455 442.86 90.8184 442.794 90.7197 442.792C90.6709 442.791 90.6394 442.804 90.6172 442.82C90.594 442.838 90.5734 442.865 90.5576 442.906C90.5248 442.992 90.5194 443.117 90.5312 443.255C90.5429 443.391 90.5706 443.528 90.5957 443.633C90.6082 443.685 90.6193 443.729 90.6279 443.759C90.6322 443.774 90.6363 443.786 90.6387 443.794C90.6398 443.798 90.641 443.801 90.6416 443.803V443.805H90.6426V443.806L90.4707 443.867V443.866L90.4697 443.864C90.4688 443.862 90.4669 443.858 90.4648 443.854C90.4607 443.844 90.4542 443.83 90.4453 443.812C90.4273 443.774 90.3994 443.719 90.3604 443.653C90.2823 443.521 90.1598 443.341 89.9844 443.153C89.634 442.778 89.0711 442.369 88.2188 442.24C87.793 442.176 87.5297 442.238 87.3682 442.35C87.208 442.46 87.1305 442.631 87.1016 442.822C87.0725 443.014 87.0946 443.218 87.125 443.376C87.1401 443.454 87.1568 443.52 87.1699 443.566C87.1764 443.589 87.1817 443.607 87.1855 443.619C87.1874 443.625 87.1894 443.63 87.1904 443.633L87.1914 443.637L87.292 443.924L87.0508 443.74L87.0488 443.739C87.0477 443.738 87.0462 443.737 87.0439 443.735C87.039 443.732 87.0312 443.726 87.0215 443.719C87.0021 443.705 86.9738 443.685 86.9385 443.662C86.8674 443.615 86.768 443.555 86.6572 443.499C86.5462 443.443 86.4259 443.393 86.3105 443.366C86.194 443.339 86.0914 443.338 86.0107 443.367C85.982 443.378 85.9681 443.393 85.96 443.412C85.9503 443.435 85.9464 443.472 85.9531 443.523C85.9667 443.628 86.0199 443.764 86.0918 443.904C86.1626 444.042 86.2468 444.177 86.3135 444.277C86.3467 444.327 86.3751 444.369 86.3955 444.397C86.4056 444.412 86.4144 444.422 86.4199 444.43C86.4226 444.433 86.4244 444.437 86.4258 444.438C86.4264 444.439 86.4274 444.44 86.4277 444.44V444.441L86.3115 444.576L86.3018 444.571C86.2946 444.568 86.2836 444.562 86.2695 444.555C86.2414 444.541 86.1999 444.521 86.1484 444.498C86.0455 444.452 85.902 444.392 85.7393 444.34C85.4077 444.233 85.019 444.164 84.7295 444.266C84.6694 444.287 84.6434 444.317 84.6309 444.347C84.6168 444.381 84.6138 444.43 84.6299 444.499C84.6625 444.639 84.7626 444.816 84.8906 444.997C85.0169 445.175 85.1637 445.347 85.2793 445.476C85.337 445.54 85.3867 445.593 85.4219 445.63C85.4328 445.641 85.4423 445.651 85.4502 445.659H102.076C102.08 445.655 102.084 445.651 102.089 445.646C102.115 445.619 102.152 445.577 102.197 445.524C102.288 445.419 102.408 445.267 102.529 445.085C102.774 444.718 103.014 444.235 103.027 443.751C103.031 443.632 103.014 443.552 102.988 443.5C102.964 443.45 102.931 443.423 102.893 443.407C102.806 443.373 102.67 443.393 102.508 443.456C102.351 443.517 102.191 443.608 102.068 443.687C102.007 443.725 101.956 443.76 101.921 443.785C101.903 443.798 101.889 443.809 101.88 443.815C101.875 443.819 101.872 443.822 101.87 443.823C101.869 443.824 101.868 443.825 101.867 443.825H101.866L101.729 443.712V443.711C101.73 443.71 101.731 443.71 101.731 443.709C101.733 443.706 101.734 443.702 101.736 443.696C101.741 443.686 101.749 443.67 101.756 443.65C101.77 443.611 101.787 443.56 101.794 443.507C101.801 443.453 101.798 443.405 101.784 443.368C101.778 443.352 101.769 443.337 101.755 443.323L101.696 443.287C101.657 443.273 101.589 443.282 101.487 443.332C101.39 443.38 101.284 443.455 101.184 443.537C101.084 443.618 100.993 443.703 100.927 443.768C100.894 443.8 100.867 443.828 100.849 443.847C100.84 443.856 100.832 443.863 100.827 443.868C100.825 443.871 100.823 443.873 100.822 443.874L100.82 443.876L100.664 444.045L100.662 443.814V443.811C100.662 443.807 100.661 443.802 100.661 443.795C100.661 443.782 100.661 443.762 100.659 443.736C100.656 443.685 100.651 443.611 100.641 443.522C100.62 443.344 100.58 443.104 100.502 442.86C100.355 442.399 100.083 441.95 99.582 441.829L99.4785 441.81C98.8885 441.726 98.5173 441.931 98.292 442.152C98.178 442.265 98.1001 442.383 98.0508 442.473C98.0264 442.517 98.0091 442.554 97.998 442.58C97.9925 442.593 97.9888 442.604 97.9863 442.61C97.9851 442.613 97.9839 442.616 97.9834 442.617L97.9824 442.618L97.8936 442.885L97.8096 442.616L97.8086 442.615C97.8082 442.614 97.8075 442.612 97.8066 442.609C97.805 442.604 97.8023 442.597 97.7988 442.587C97.7917 442.567 97.7809 442.538 97.7666 442.503C97.7379 442.433 97.6957 442.34 97.6396 442.247C97.5374 442.078 97.4068 441.937 97.2549 441.9L97.1885 441.892C97.0937 441.889 97.0351 441.916 96.9961 441.951C96.955 441.989 96.9272 442.043 96.9102 442.105C96.8932 442.167 96.888 442.231 96.8877 442.281C96.8875 442.306 96.8887 442.327 96.8896 442.341C96.8901 442.348 96.8903 442.353 96.8906 442.356L96.8916 442.36L96.7236 442.42L96.7227 442.419C96.7218 442.418 96.7208 442.415 96.7188 442.412C96.7147 442.406 96.7079 442.397 96.6992 442.386C96.6817 442.362 96.6551 442.328 96.6182 442.287C96.5442 442.206 96.4304 442.098 96.2734 441.996C95.9608 441.793 95.4723 441.608 94.7725 441.7Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.18247
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7432 444.932V446.558H102.953V444.932H64.7432Z",
    fill: "white",
    stroke: "#382456",
    strokeWidth: 0.18247
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.057 431.064C108.497 431.064 108.858 431.421 108.858 431.865V444.665C108.858 445.104 108.502 445.465 108.057 445.465C107.618 445.465 107.257 445.109 107.257 444.665V431.865C107.257 431.426 107.613 431.064 108.057 431.064Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.054 432.127H108.858V437.458H136.054V432.127Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.054 435.861H108.858V436.393H136.054V435.861Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.054 433.731H108.858V434.264H136.054V433.731Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.452 431.865C134.452 431.421 134.809 431.064 135.248 431.064C135.687 431.064 136.053 431.421 136.053 431.865V444.665C136.053 445.104 135.697 445.465 135.248 445.465C134.799 445.465 134.452 445.109 134.452 444.665V431.865Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.325 440.127C112.764 440.127 113.126 440.483 113.126 440.928V445.726C113.126 446.166 112.769 446.527 112.325 446.527C111.886 446.527 111.524 446.17 111.524 445.726V440.928C111.524 440.488 111.881 440.127 112.325 440.127Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.983 440.127C139.423 440.127 139.784 440.483 139.784 440.928V445.726C139.784 446.166 139.427 446.527 138.983 446.527C138.544 446.527 138.183 446.17 138.183 445.726V440.928C138.183 440.488 138.539 440.127 138.983 440.127Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.858 440.13L107.257 438.797H136.054L139.783 440.13V441.731H111.523L108.858 440.13Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.789 440.127H111.524V441.728H139.789V440.127Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.257 438.797L111.523 440.13V442.263L107.257 440.398V438.797Z",
    fill: "#615E66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7001_56018",
    x1: 97.8215,
    y1: -0.0000307697,
    x2: 1185.32,
    y2: 487.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF9FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7001_56018",
    x1: 18.3054,
    y1: 593.249,
    x2: 93.4513,
    y2: 997.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727BBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7001_56018",
    x1: 524.996,
    y1: 552.827,
    x2: 524.996,
    y2: 570.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7001_56018",
    x1: 535.054,
    y1: 313.093,
    x2: 535.054,
    y2: 430.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4AD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7001_56018",
    x1: 535.054,
    y1: 313.093,
    x2: 535.054,
    y2: 430.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4AD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7001_56018",
    x1: 530.007,
    y1: 408.811,
    x2: 538.599,
    y2: 407.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7001_56018",
    x1: 271.091,
    y1: 403.018,
    x2: 271.091,
    y2: 417.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7001_56018",
    x1: 732.711,
    y1: 408.645,
    x2: 732.711,
    y2: 418.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1BFB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F6E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7001_56018",
    x1: 727.193,
    y1: 409.755,
    x2: 727.193,
    y2: 418.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1BFB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F6E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7001_56018",
    x1: 709.212,
    y1: 409.755,
    x2: 709.212,
    y2: 418.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1BFB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F6E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7001_56018",
    x1: 947.149,
    y1: 405.345,
    x2: 955.432,
    y2: 404.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7001_56018",
    x1: 941.725,
    y1: 397.834,
    x2: 941.725,
    y2: 402.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7001_56018",
    x1: 141.438,
    y1: 400.447,
    x2: 141.438,
    y2: 405.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7B5AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81807C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_7001_56018",
    x1: 151.58,
    y1: 400.447,
    x2: 151.58,
    y2: 405.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7B5AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81807C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7001_56018",
    x1: 137.419,
    y1: 400.244,
    x2: 137.419,
    y2: 405.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7B5AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81807C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_7001_56018",
    x1: 806.622,
    y1: 421.785,
    x2: 798.388,
    y2: 420.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6E3E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_7001_56018",
    x1: 802.956,
    y1: 416.197,
    x2: 824.279,
    y2: 416.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_7001_56018",
    x1: 813.618,
    y1: 413.806,
    x2: 813.618,
    y2: 418.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767571"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7001_56018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 571,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackPlanTablet);
export default __webpack_public_path__ + "static/media/BackPlanTablet.990c65374beee7a3454b.svg";
export { ForwardRef as ReactComponent };